
<template>
<div :class="WindowPreset.Name === 'Default' ? 'v-main__wrap' : $vuetify.theme.dark ? 'v-main__wrap  grey-darken-4' : 'v-main__wrap grey-darken-4'"
:style="PageEditStyling+'text-align: -webkit-center;height: 100%;'+PageCustomStyle">
   <!-- RAWebBtnGraddark  RAWebBtnGradlightsoft-->
     <!-- <v-overlay v-if="PageOverlay" color="#ffffff00" :style="PageOverlay">
      </v-overlay> -->
    <v-toolbar color="#5669a3" style="position: fixed;top:60px;z-index:5;width: 100%;">
        <v-spacer>
        </v-spacer>
        <v-btn-toggle light >
            <v-btn @click="WindowPreset = item" fab icon v-for="item in WindowPresets" :key="item.iemObjKey">
                <v-icon color="#466ca4" :style="item.Rotate? 'transform: rotate(90deg);' : ''">
                    {{item.Icon}}
                </v-icon>
            </v-btn>
        </v-btn-toggle>
    </v-toolbar>
    <v-card-title  :class="$vuetify.theme.dark ? 'RAWebBtnGraddark mediumoverline white--text justify-center' : 'RAWebBtnGradlightsoft mediumoverline white--text justify-center'" v-if="WindowPreset.Name !== 'Default'" style="margin-top:100px;">
        <v-icon dark large left>
            {{WindowPreset.Icon}}
        </v-icon>
        {{WindowPreset.Name}}
    </v-card-title>
    <!-- <v-banner mobile-breakpoint="600"  :width="ResponsiveSize.Width" 
      :height="ResponsiveSize.Height"> -->
    <!-- </v-banner> -->
     <v-responsive
        :class="WindowPreset.Name === 'Default' ? '' : 'overflow-y-auto white'"
      :width="ResponsiveSize.Width"
      :height="ResponsiveSize.Height"
      
      :style="WindowPreset.Name === 'Default' ? '' : ''"
    >
      <!-- <v-responsive
        height="200vh"
        class="d-flex align-center text-center pa-2"
      > -->
    
   	 <!-- <v-layout v-if="$route.name === 'PageBuilder' || $route.name === 'GroupPageBuilder' || $route.name === 'PageEditor' || $route.name === 'GroupPageEditor'" column 
            style="z-index:7;position: fixed;bottom: 60px;left: 30px;z-index:10;" >
            <v-btn v-if="MiniView" icon x-large @click="ToggleSiteDialog()"><v-icon  color="purple" x-large>mdi-tools</v-icon></v-btn>							
        </v-layout> -->
    <v-dialog v-if="CurrentEntity" v-model="WikiPublishTypeDialog" max-width="800">
        <v-card>
            <v-card-title>
                New Wiki Entity
            </v-card-title>
            <v-card-text>
                We have found that there is no official Wiki Entity for {{CurrentEntity.id}} as yet. In order to create it, please provide a Publish Type.
                <v-select v-model="PublishType" :items="PublishTypes" label="Publish Type"/>                
            </v-card-text>
            <v-card-actions>
                <v-btn @click="CancelCreateWikiEntityandSaveWikiTabs()">Cancel</v-btn>
                <v-spacer>
                </v-spacer>
                <v-btn @click="ProcessCreateWikiEntityandSaveWikiTabs(EntityCollectionRef)">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>	
    <v-dialog v-model="EditTestimonyDialog" max-width="400" dark v-if="EditedTestimony" persistent>									
        <v-card width="400">									
            <v-card-text>									
                <input type="file"  @change="NewTestimonialImageFileselected($event)"/>									
                <v-avatar									
                size="150"									
                                                    
                >									
                <v-img style="object-fit: cover;" v-if="!SampleTestinomialFile && EditedTestimony.Avatar"									
                    :src="EditedTestimony.Avatar"									
                    />									
                    <v-img style="object-fit: cover;" v-if="SampleTestinomialFile"									
                    :src="SampleTestinomialFile"									
                    />									
                    <v-img style="object-fit: cover;" v-if="!EditedTestimony.Avatar && !SampleTestinomialFile"									
                    src="@/assets/ImageHolder.png"									
                    />									
                </v-avatar>									
                <v-btn v-if="SampleTestinomialFile" @click="SaveTestimonialFile()">									
                    Save									
                </v-btn>									
            </v-card-text>									
            <v-card-text>									
            <v-list									
        class="transparent"									
        dark									
        height="100%"									
        dense									
        >									
            <v-list-item >									
            <v-text-field label="Name" v-model="EditedTestimony.Name" />
            <v-text-field label="Role" v-model="EditedTestimony.Role" />									
        </v-list-item>									
                                                
        <v-list-item>									
            <v-btn-toggle dark>									
                                                                        
                <v-btn x-small onclick="document.execCommand('formatBlock', false, '<h1>')">									
                    H1									
                </v-btn>									
                <v-btn x-small onclick="document.execCommand('formatBlock', false, '<h2>')">									
                    H2									
                </v-btn>									
                <v-btn x-small onclick="document.execCommand('formatBlock', false, '<h3>')">									
                    H3									
                </v-btn>									
                <v-btn x-small onclick="document.execCommand('formatBlock', false, '<p>')">									
                <v-icon>mdi-format-paragraph </v-icon>									
                </v-btn>									
                                                    
                                                    
                </v-btn-toggle>									
                                                        
        </v-list-item>									
        <v-list-item>									
            <v-btn-toggle dark>									
                                                    
                <v-btn x-small onclick="document.execCommand('justifyLeft',false,'')">									
                    <v-icon x-small>mdi-format-align-left</v-icon>									
                </v-btn>									
                <!-- <v-btn>									
                    <v-icon>mdi-format-align-center</v-icon>									
                </v-btn> -->									
                <v-btn x-small onclick="document.execCommand('justifyCenter',false,'')">									
                    <v-icon x-small>mdi-format-align-justify</v-icon>									
                </v-btn>									
                <v-btn x-small onclick="document.execCommand('justifyRight',false,'')">									
                    <v-icon x-small>mdi-format-align-right</v-icon>									
                </v-btn>									
                <v-btn x-small onclick="document.execCommand('insertUnorderedList',false,'')">									
                    <v-icon x-small>mdi-format-list-bulleted</v-icon>									
                </v-btn>									
                                                    
                                                    
                </v-btn-toggle>									
                                                        
        </v-list-item>									
        <v-list-item>									
            <v-btn-toggle dark>									
                <v-btn x-small onclick="document.execCommand('fontSize', 0, '12px');">									
                    <v-icon x-small>mdi-format-title</v-icon>									
                </v-btn>									
                                            
                                                    
                <v-btn x-small onclick="document.execCommand('bold', false, '');">									
                    <v-icon x-small>mdi-format-bold</v-icon>									
                </v-btn>									
                <v-btn x-small onclick="document.execCommand('italic', false, '');">									
                    <v-icon x-small>mdi-format-italic</v-icon>									
                </v-btn>									
                <v-btn x-small onclick="document.execCommand('underline', false, '')">									
                    <v-icon x-small>mdi-format-underline</v-icon>									
                </v-btn>									
                                                
                </v-btn-toggle>									
        </v-list-item>									
                                        
        <v-list-item>									
            <v-btn-toggle dark>									
                                                
                    <v-btn x-small>									
                        <v-icon @click="link()">mdi-link</v-icon>									
                    </v-btn>									
                    <v-btn x-small>									
                        <v-icon x-small @click="addphone()">mdi-phone</v-icon>									
                    </v-btn>									
                    <v-btn x-small>									
                        <v-icon x-small @click="addemail()">mdi-email</v-icon>									
                    </v-btn>									
                    <v-btn x-small onclick="document.execCommand('strikeThrough',false,'')">									
                        <v-icon x-small>mdi-format-strikethrough</v-icon>									
                    </v-btn>									
                    </v-btn-toggle>									
        </v-list-item>									
        <v-list-item>									
            <v-card width="90%" min-height="300px" outlined flat v-html="EditedTestimony.Description" contenteditable 									
            :id="EditedTestimony.Name.split(' ').join('_')+'editor'">									
                    </v-card>									
        </v-list-item>									
        <v-list-item>									
            <v-btn @click="UpdateTestimonyHTMLBox()">Update</v-btn>									
        </v-list-item>									
            </v-list>									
            </v-card-text>									
                                                
            <v-card-actions>                            									
                <v-spacer></v-spacer>									
                <v-btn @click="CancelEditTestimony()">Close</v-btn>									
            </v-card-actions>									
        </v-card>									
    </v-dialog>
        <div :style="SitePageNavStyle" :class="DocLibEditor ? 'transparent layout row' : ''">
        <div v-if="DocLibEditor && ActiveDocumentationLibrary" class="flex xl2 lg3 md4 sm5 xs12" style="text-align: -webkit-left;">
            <!-- ActiveDocumentationLibrary.LibraryNavbarItems -->
           <v-navigation-drawer width="100%">
                <v-layout column align-center>
                    <v-flex>
                    <v-avatar
                        class="profile"
                        size="220"
                        tile
                    >
                        <v-img contain src="@/assets/logo.png"></v-img>
                    </v-avatar>
                    
                    </v-flex>
                </v-layout>
                <v-divider>
                </v-divider>
                <v-list-item class="justify-center">
                    <v-icon style="padding-right: 7px;">
                        {{ActiveDocumentationLibrary.PageIcon}}
                    </v-icon>
                 {{ActiveDocumentationLibrary.Name}}
                </v-list-item>
                 <v-divider>
                </v-divider>
               <v-list width="100%" class="transparent" style="padding-top:20px;padding-left:5px;">
                <div v-for="main in ActiveDocumentationLibrary.LibraryNavbarItems" :key="main.title">
                <v-list-item v-if="!main.Children || main.Children.length===0" @click="ActivateLibraryPage(main)" style="text-align: -webkit-left;">
                <v-list-item-content>
                    <v-list-item-title >  <v-icon style="padding-right: 7px;">
                        {{main.icon}}
                    </v-icon>{{ main.title}}
                    </v-list-item-title>
                    </v-list-item-content>
                
                </v-list-item>
                    <v-list-group style="text-align: -webkit-left;"
                    v-if="main.Children && main.Children.length"
                    >
                        <template v-slot:activator>
                        <v-list-item-title>
                             <v-icon style="padding-right: 7px;">
                        {{main.icon}}
                    </v-icon>
                            {{main.title}}</v-list-item-title>
                        </template>
                        <!-- <v-virtual-scroll 
                        class="transparent"
                            :items="main.Children"
                            :item-height="40"
                            :height="100"
                        >
                        IF USED subsub BECOMES item
                        <template v-slot:default="{ item }"> -->
                        <div v-for="subsub in main.Children"
                                :key="subsub.itemObjKey">
                            <v-list-item class="mx-3"
                                
                                @click="ActivateLibraryPage(subsub)"
                            >                                   
                                <v-list-item-title style="padding-left:15px;">   <v-icon style="padding-right: 7px;">
                                    {{subsub.icon}}
                                </v-icon>
                                    {{ subsub.title }}</v-list-item-title>
                            </v-list-item>
                        </div>
                        <!-- </template>
                        </v-virtual-scroll> -->
                        <!-- </div> -->
                    </v-list-group>
                </div>
            </v-list>
           </v-navigation-drawer>
        </div>
        <ViewEditorComponent v-if="FieldTypes && FieldTypes.length > 0" :WikiEntities="WikiEntities" :ClsfdNavList="ClsfdNavList" :FrequentlyAskedQuestions="FrequentlyAskedQuestions"
        @AddContentBlocks="AddContentBlocks" :System="System" :SystemPhotoLibraries="SystemPhotoLibraries" :FeatureNavList="FeatureNavList" :GroupData="GroupData" :TableRecordView="TableRecordView"
        :LoadedPageIcon="PageIcon" :LoadedPageBGGradient="PageBGGradient" :LoadedPageBGAsset="PageBGAsset" :LoadedPageBGColor="PageBGColor" :SelectedActiveButton="SelectedActiveButton"
        :LoadedPageName="PageName" :LoadedPageRoute="PageRoute" :LoadedPageOverview="PageOverview" :LoadedPublishType="PublishType" :LoadedPageContentFont="PageContentFont" :LoadedPageHeadersFontSize="PageHeadersFontSize" :LoadedPageHeadersFont="PageHeadersFont"
        :OptionSetDialog="OptionSetDialog" :EditOptionSet="EditOptionSet" :ContentTypesDialog="ContentTypesDialog" :TabDialog="TabDialog" @AssignImage="AssignImage"
        :EditedTab="EditedTab" :EditedTabindex="EditedTabindex" :Option="Option" :OptionName="OptionName" :FieldsDialogActivate="FieldsDialogActivate" :PageTabs="PageTabs"
        :SystemAssets="ComputedSystemAssets" :FieldTypes="FieldTypes" :SystemEntities="ComputedSystemEntities" :CurrentEntity="CurrentEntity" :EntityCollectionRef="EntityCollectionRef" :EntityDataRef="EntityDataRef"
        :RelatedObj="RelatedObj" @SavePage="SavePage" :GalleryLibraries="GalleryLibraries" :DynamicWikiData="DynamicWikiData" :SystemGuides="SystemGuides"
        :SampleTestinomialFile="SampleTestinomialFile" :EditedTestimony="EditedTestimony" :SystemAssetsPage="SystemAssetsPage" :SitePages="SitePages" @AssignRenderedContentBlocks="AssignRenderedContentBlocks"
        @NoPropsemit="NoPropsemit" @TabPropEmit="TabPropEmit" @Onepropemit="Onepropemit" @Twopropemit="Twopropemit" @Threepropemit="Threepropemit" @OpenDialog="OpenDialog"
        @DeactivateTabDialog="DeactivateTabDialog" @AddField="AddField" @AddTableOption="AddTableOption"
        />	
        <span v-if="CatNavList && CatNavList.id">
            <DirectoryViewer v-if="CatNavList && CatNavList.CategoricalListType && !Refreshing" :ProvidedAdditionalFilters="CatNavList.AdditionalFilters"
        :ProvidedNavList="CatNavList.NavList" :ProvidedCurrentEntity="CatNavList"
        @ActivateTreeNode="ActivateTreeNode" :ProvidedFeatureList="CatNavList.FeatureList" :style="FinalPageStyling"
        />
        </span>
        <div :class="DocLibEditor ? 'flex xl10 lg9 md8 sm7 xs12' : 'transparent'" v-if="!CatNavList" :style="FinalPageStyling">
              <v-card-title class="justify-center recordtoolbar display-2 white--text" v-if="DocLibEditor && ActiveDocumentationLibrary">
                   <v-icon dark x-large style="padding-right: 15px;">
                       {{PageData.PageIcon}}
                   </v-icon>
            {{PageData.Name}}
              </v-card-title>
              <v-layout class="justify-center" style="z-index: 10;" v-if="PageTabs.length === 0 || dragging && !EditedTab">   
                <v-btn dark small color="success" class="soloactionicon" style="position: absolute;z-index: 10;" @click="ActivateAddContentDialog()" fab icon>
                    <v-icon>mdi-plus</v-icon>
                </v-btn>	
                </v-layout>	
            <v-card flat width="100%" @dragleave="AllowTopRowAdding()" @dragover.prevent  @drop.prevent="newcontentdropFinish(0, $event)" id="top-drop-area" v-if="PageTabs.length === 0 || dragging && !EditedTab">									
                <v-layout class="justify-center">									
                    <v-card-title class="grey--text">									
                    <v-icon>mdi-plus-thick</v-icon> Add a Tab at the Top									
                    </v-card-title>									
                </v-layout>									
                </v-card>													
                <v-card :color="MatchColor(tab)" :class="'pagerow '+tab.RowTransparency" tile  width="100%" flat  class="CodeRenders tabonbuild" id="PageCode"
                :style="GetTabStyle(tab)"							
                v-for="(tab,i) in ComputedPageTabs" :key="tab.itemObjKey" @dragover.prevent="allowDrop(event,i)">
                <hr class="my-auto purple--text" style="border-top: dashed 0.5px;" />
                 <v-btn dark small color="success" class="soloactionicon" style="position: absolute;z-index: 4;right: 50%;top:-20px;" @click="ActivateAddContentDialog(tab,i)" fab icon>
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                <ul style="width: 100vh;z-index: 4;" v-if="WindowPreset.Name === 'Default'">
                            <v-menu v-if="tab.Name !== 'blank'">
                                <template v-slot:activator="{ on: menu, attrs }">
                                <v-chip
                                    style="z-index: 4;position: absolute; left:0px;"
                                    class="ma-2"
                                    v-bind="attrs"
                                    v-on="{ ...menu }"
                                    color="deep-purple accent-4"
                                    outlined
                                    :disabled="false"
                                >
                                <!-- :disabled="tab.Database === 'Client'" -->
                                    <v-icon left>
                                    {{ tab.Icon }}
                                    </v-icon>
                                    {{ tab.Preset_Name }}
                                    <v-icon right> mdi-chevron-down </v-icon>
                                </v-chip>
                                </template>
                                <v-virtual-scroll
                                width="350"
                                :items="FilteredRAStorePagePresets(tab,true)"
                                :item-height="380"
                                height="450"
                                class="background"
                                >
                                <template v-slot:default="{ item }">
                                    <v-list-item dense class="overline" >
                                   <v-avatar tile size="35">
                                            <v-icon size="35">{{item.Icon}}</v-icon>
                                        </v-avatar> {{item.Preset_Name}}
                                </v-list-item>
                                    <v-list-item class="RAWebBtnGradlightsoft"
                                    dense
                                     style="border-radius: 15px;"
                                    @click="UpdateTabPreset(tab, item, i)"
                                    >
                                    <PageTabRenderer
                                        :PageHeadersFont="PageHeadersFont"
                                        :PageContentFont="PageContentFont"
                                        :PageHeadersFontSize="PageHeadersFontSize"
                                        :System="System"
                                        :SystemEntities="SystemEntities"
                                        :tab="item"
                                        :i="i"
                                        :downsized="true"
                                        :SampleOnly="true"
                                    />
                                    </v-list-item>
                                </template>
                                </v-virtual-scroll>
                            </v-menu>
                            <!-- btn,tab,tabindex,IsElement,CustomBoxTabIndex,isrow,rowindex,ContentDialog -->
                            <v-chip
                            @click="ActivateTabDialNew(TabStyleItems(tab)[0],tab,i,false)" 
                            style="z-index:4;position: absolute;right:100px;"
                            class="ma-2"
                            color="blue accent-4"
                            outlined
                            >
                            <v-icon left>
                                    mdi-cogs
                                    </v-icon>
                            Row</v-chip>
                            <v-chip
                            @click="DeleteTabNew(tab,i,false)" 
                            style="z-index:4;position: absolute;right:0px;"
                            class="ma-2"
                            color="red accent-4"
                            outlined
                            >
                            <v-icon left>
                                    mdi-delete-forever
                                    </v-icon>
                            Delete</v-chip>
                             <!-- <v-btn  style="position: absolute;right: 0px;z-index:101;" fab icon>
                    <v-icon class="red--text"  @click="DeleteTabNew(tab,i,false)" >mdi-delete-forever</v-icon>
                    </v-btn> -->
                            </ul>
                            
                        <!-- <v-row class="tabtoolbarshown justify-center" v-if="!FilteredSystemTabs">
                                <v-col
                                cols="12"
                                sm="6"
                                >
                                <v-btn-toggle v-model="toggle_exclusive">
                                    <v-btn @click="ActivateStyleButton(btn,tab)" v-for="btn in FilteredTabStyleItems(tab)" :key="btn.itemObjKey">
                                    <v-icon>{{btn.Icon}}</v-icon>
                                    </v-btn>
                                </v-btn-toggle>
                                </v-col>
                         </v-row>	 -->
                         <!--  :style="'display: block;width: 100%;margin: 0;z-index:2;top:0;position:absolute;left:0px;float:left;transform: rotate(180deg);'" -->
                         <svg v-if="tab.HasTopWaves" :style="tab.TopWaveRestrictHeight ?
                         'display: block;width: 100%;margin: 0;z-index:2;top:0;position:absolute;float:left;transform: rotate(180deg);max-height: '+tab.TopWaveHeight+'px;' : 
                         'display: block;width: 100%;margin: 0;z-index:2;top:0;position:absolute;float:left;transform: rotate(180deg);height: -webkit-fill-available;'"
                            xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                viewBox="0 0 106 40"
                                :preserveAspectRatio="$vuetify.breakpoint.xs ? tab.TopWaveAspectRatio : 'none'">
                            <defs v-html="tab.TopPathsHTML">
                            </defs>
                            <g :style="tab.TopWave1Style">
                            <use :href="'#'+i+'_TopWave1Path'" :x="tab.TopWave1XPos" :y="tab.TopWave1YPos" :fill="tab.TopWave1Color.hexa"/>
                            </g>
                                <g  :style="tab.TopWave2Style" v-if="tab.TopWaveCount > 1">
                            <use :href="'#'+i+'_TopWave2Path'" :x="tab.TopWave2XPos" :y="tab.TopWave2YPos" :fill="tab.TopWave2Color.hexa"/>
                                </g>
                                <g :style="tab.TopWave3Style" v-if="tab.TopWaveCount > 2">
                            <use :href="'#'+i+'_TopWave3Path'" :x="tab.TopWave3XPos" :y="tab.TopWave3YPos" :fill="tab.TopWave3Color.hexa"/>
                            </g>
                                <g :style="tab.TopWave4Style" v-if="tab.TopWaveCount > 3">
                            <use :href="'#'+i+'_TopWave4Path'" :x="tab.TopWave4XPos" :y="tab.TopWave4YPos" :fill="tab.TopWave4Color.hexa"/>  
                            </g>
                        </svg>
                        <!-- :style="'display: block;width: 100%;height: '+tab.BottomWaveHeight+'px;max-height: '+tab.BottomWaveHeight+'px;margin: 0;z-index:2;bottom:0;position:absolute;left:0px;float:left;'" -->
                        <svg v-if="tab.HasBottomWaves" :style="tab.BottomWaveRestrictHeight ? 
                        'display: block;width: 100%;margin: 0;z-index:2;bottom:0;position:absolute;float:left;max-height: '+tab.BottomWaveHeight+'px;' : 
                        'display: block;width: 100%;margin: 0;z-index:2;bottom:0;position:absolute;float:left;height: -webkit-fill-available;'"
                                xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    viewBox="0 0 106 40"
                                    :preserveAspectRatio="$vuetify.breakpoint.xs ? tab.BottomWaveAspectRatio : 'none'">
                                <defs v-html="tab.BottomPathsHTML">
                                </defs>
                                <g :style="'animation: move-forever1 '+tab.BottomWave1Speed+' linear infinite;'">
                                <use :xlink:href="'#'+i+'_BottomWave1Path'" :x="tab.BottomWave1XPos" :y="tab.BottomWave1YPos"  :fill="tab.BottomWave1Color.hexa"/>
                                </g>
                                    <g :style="'animation: move-forever2 '+tab.BottomWave2Speed+' linear infinite;'" v-if="tab.BottomWaveCount > 1">
                                <use :xlink:href="'#'+i+'_BottomWave2Path'" :x="tab.BottomWave2XPos" :y="tab.BottomWave2YPos"  :fill="tab.BottomWave2Color.hexa"/>
                                    </g>
                                    <g :style="'animation: move-forever3 '+tab.BottomWave3Speed+' linear infinite;'" v-if="tab.BottomWaveCount > 2">
                                <use :xlink:href="'#'+i+'_BottomWave3Path'" :x="tab.BottomWave3XPos" :y="tab.BottomWave3YPos"  :fill="tab.BottomWave3Color.hexa"/>
                                </g>
                                    <g :style="'animation: move-forever4 '+tab.BottomWave4Speed+' linear infinite;'" v-if="tab.BottomWaveCount > 3">
                                <use :xlink:href="'#'+i+'_BottomWave4Path'" :x="tab.BottomWave4XPos" :y="tab.BottomWave4YPos"  :fill="tab.BottomWave4Color.hexa"/>  
                                </g>
                            </svg>
                            <v-layout row justify-center v-if="tab.ShowComponents">									
                                <v-card v-if="tab.Name === 'Card Row' && tab.Elements.length === 0 || tab.Name === 'Card Blocks' && tab.Elements.length === 0 || tab.Name === 'Counter' && tab.Elements.length === 0 || tab.Name === 'Store Products' && tab.Elements.length === 0" id="drop-area"  @click.prevent="AdjustRowAmount(tab,i)">									
                             <v-layout class="justify-center">									
                                <v-card-text class="grey--text">									
                                Click on this card to start adding Elements									
                                </v-card-text>									
                            </v-layout>									
                            </v-card>									
                            <v-list-item-avatar  v-if="tab.Name === 'Card Row' && tab.Elements.length !== 0 || tab.Name === 'Card Blocks' && tab.Elements.length !== 0 || tab.Name === 'Counter' && tab.Elements.length !== 0 || tab.Name === 'Store Products' && tab.Elements.length !== 0" size="20" @click.prevent="AdjustRowAmount(tab,i)">									
                            <v-icon small class="links--text actionicon">mdi-plus-thick</v-icon>									
                        </v-list-item-avatar>	
                        				
                        				<!-- :style="MatchColor(tab) ? 'background-color: '+MatchColor(tab)+';' : ''"  -->
                                        <!-- a typical 6 = flex-grow: 0;flex-shrink: 0;flex-basis: 50%;max-width: 50%; whle 8 is flex-grow: 0;flex-shrink: 0;flex-basis: 66.6667%;max-width: 66.6667%;
                                        so flex basis and max width respond to col intended size, divded by 12.
                                        precede this with checking of responsewidth and what do you have? same thing no?
                                        class="'flex xl'+tab.FlexXLRG+' lg'+tab.FlexLarge+' md'+tab.FlexMedium+' sm'+tab.FlexSmall+' xs'+tab.FlexXSmall"
                                        -->
                          <div class="flex"
                          :style="ResponsiveTabFlex(tab)">  
                            											
                     <div v-if="tab.Name === 'Card Row' && tab.Type !== '3D Carousel' && tab.Type !== 'Magazine Style'" :style="'margin-top:'+tab.MarginTop+'px;margin-bottom:'+tab.MarginBottom+'px;margin-left:'+tab.MarginLeft+'px;margin-right:'+tab.MarginRight+'px;'">									
                                 <v-card-title v-if="tab.HasHeaderImage">									
                                  <v-img v-if="!tab.HeaderImage "									
                               contain									
                               class="my-1"									
                                height="80"									
                               src="@/assets/ImageHolder.png"									
                               /><v-img v-if="tab.HeaderImage "									
                               contain									
                               class="my-1"									
                                height="80"									
                               :src="tab.HeaderImage"									
                               /></v-card-title>						
                                <v-card-title :class="tab.Center" v-if="tab.Title && !tab.FancyTitle"
                                :style="tab.HeaderBGColor ? 'background-color: '+tab.HeaderBGColor+';padding-bottom: 20px;color:'+tab.HeaderColor.hex+';'+HeaderFontFamily(tab,tab.HeaderFontFamily) : 
                                'padding-bottom: 20px;color:'+tab.HeaderColor.hex+';'+HeaderFontFamily(tab,tab.HeaderFontFamily)">									
                                <strong>{{tab.Title}}</strong>									
                                </v-card-title>		
                                <TitleTab v-if="tab.Title && tab.FancyTitle" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"									
                                :PageHeadersFontSize="PageHeadersFontSize" :IsElement="true" :tabindex="tabindex" :rowindex="rowindex"									
                                :tab="tab" :i="i" :PageID="PageID" :PageName="PageName"	@OpenDialog="OpenDialog"								
                                />						
                            <v-card-text v-html="tab.Description" :class="tab.FillHeight"
                            :style="tab.FontBGColor && !tab.FontUnderline ? DefaultPageFont+'font-size:'+tab.FontSize+'px;color:'+tab.FontColor.hex+';background-color: '+tab.FontBGColor+';width: 50%;' :
                            tab.FontUnderline && tab.FontUnderlineColor ? DefaultPageFont+'font-size:'+tab.FontSize+'px;color:'+tab.FontColor.hex+';background-image: linear-gradient(180deg,'+tab.FontUnderlineColor+','+tab.FontUnderlineColor+');background-repeat: no-repeat;background-position: 4px bottom;background-size: 100% 10px;text-decoration: none;' : 
                            DefaultPageFont+'font-size:'+tab.FontSize+'px;color:'+tab.FontColor.hex">									
                                </v-card-text>									
                             									
                             <v-card-text v-if="tab.HasImage">									
                                 <v-layout :class="tab.Justify" row>									
                                 <v-img  v-if="tab.HasImage && tab.IMG"									
                                 :contain="!tab.Clipped"									
                                   :height="tab.Height"									
                                        :src="tab.IMG"									
                                        :style="CheckifClipped(tab)"									
                                       									
                                        />									
                                        <v-img :contain="!tab.Clipped" :style="CheckifClipped(tab)" v-if="tab.HasImage && !tab.IMG"									
                                   :height="tab.Height"									
                                        src="@/assets/ImageHolder.png"									
                                        />									
                                 </v-layout>									
                             </v-card-text>									
                        									
                        <v-card-actions v-if="tab.HasActionButton" :class="tab.ButtonAlignment">									
                            <v-btn :dark="tab.ActionBtnDark"  :style="'background-color:'+tab.ButonColor.hex">									
                                {{tab.ActionButtonName}}									
                            </v-btn>									
                        </v-card-actions>									
                            </div>
                    <v-row v-if="tab.DataViewName"
                    :class="'mb-6 '+tab.Justify"
                        no-gutters
                       
                        > 
                        <v-card flat width="100%" height="100" :id="i+'drop-area'" @click="OpenDialog(tab,i)" v-if="EditedTab.Name === tab.Name && tab.DataViewName && dragging[tab.DataViewName.split(' ').join('')] || EditedTab.Name === tab.Name && draggingfield && tab.DataViewName === 'Data Single Fields'"									
                             @dragover.prevent @drop.prevent="elementdropFinish(i, $event)">									
                            <v-layout class="justify-center">									
                                <v-card-title class="grey--text">									
                                <v-icon>mdi-plus-thick</v-icon> Add Content	to {{tab.Name}}								
                                </v-card-title>									
                            </v-layout>									
                            </v-card> 
                        <v-flex :xl="tab.FlexXLRG" :lg="tab.FlexLarge" :md="tab.FlexMedium" :sm="tab.FlexSmall" :xs="tab.FlexSmall">
                        <!-- Standard
                        'tab','AppisDarkMode','CanEdit','Record','Business_Unit','PrimaryFieldName','RelatedObj','AppointmentsQuery','ActivitiesArray',
                        'SystemEntities','AdditionalSaveMethod','SingleFormEditing','tabindex','NewFieldDragging','NewFieldDraggingIndex','EntityDataRef'] -->
                       
                        <DataSingleStandard v-if="tab.DataViewName === 'Data Single Standard' && !tab.TransposedTabs"
                        :SystemEntities="ComputedSystemEntities" :EntityDataRef="EntityDataRef" :SingleFormEditing="SingleFormEditing" :FeatureNavList="FeatureNavList"
                        :NewFieldDragging="NewFieldDragging" :NewFieldDraggingIndex="NewFieldDraggingIndex" :CurrentEntity="CurrentEntity"
                        :Record="DynamicWikiData" :CanEdit="CanEdit" :Business_Unit="Business_Unit" :PrimaryFieldName="PrimaryFieldName" :RelatedObj="RelatedObj"
                        :AppointmentsQuery="AppointmentsQuery" :TasksQuery="TasksQuery" :EmailsQuery="EmailsQuery" :NotesQuery="NotesQuery" :PhoneCallsQuery="PhoneCallsQuery"
                        :ActivitiesArray="ActivitiesArray" :AdditionalSaveMethod="AdditionalSaveMethod"
                        @NewFieldDragfinish="NewFieldDragfinish" @UpdateEditableField="UpdateEditableField"                  
                        :AppisDarkMode="AppisDarkMode"
                        :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                        :PageHeadersFontSize="PageHeadersFontSize" :tab="tab" @OpenDialog="OpenDialog" :tabindex="i"
                        />
                        
                        <!-- tab.DataViewName {{tab.DataViewName}} -->
                        <!-- Cabinet
                        ['tab','AppisDarkMode','CanEdit','CanCreate','CanDelete','CanGet','Record','Business_Unit','PrimaryFieldName','RelatedObj','AppointmentsQuery','ActivitiesArray',
                        'SystemEntities','AdditionalSaveMethod','SingleFormEditing','tabindex','NewTableDragging','NewTableDraggingIndex','ActiveEntityID','EntityCollectionRef','EntityDataRef' -->
                        <DataSingleCabinet v-if="tab.DataViewName === 'Data Single Cabinet' || tab.DataViewName === 'Data Single Related' || tab.DataViewName === 'Data Single Standard' && tab.TransposedTabs"
                        :SystemEntities="ComputedSystemEntities" :EntityDataRef="EntityDataRef" :EntityCollectionRef="EntityCollectionRef" :SingleFormEditing="SingleFormEditing"
                        :NewFieldDragging="NewFieldDragging" :NewFieldDraggingIndex="NewFieldDraggingIndex" @UpdateEditableField="UpdateEditableField" @NewFieldDragfinish="NewFieldDragfinish" 
                        :NewTableDragging="NewTableDragging" :NewTableDraggingIndex="NewTableDraggingIndex" :ActiveEntityID="CurrentEntity.id" :CurrentEntity="CurrentEntity"
                        :Record="DynamicWikiData" :CanEdit="CanEdit" :CanGet="CanGet" :Business_Unit="Business_Unit" :PrimaryFieldName="PrimaryFieldName" :RelatedObj="RelatedObj"
                        :AppointmentsQuery="AppointmentsQuery" :TasksQuery="TasksQuery" :EmailsQuery="EmailsQuery" :NotesQuery="NotesQuery" :PhoneCallsQuery="PhoneCallsQuery"
                        :AdditionalSaveMethod="AdditionalSaveMethod" :FeatureNavList="FeatureNavList" :SingleElementView="FilteredSystemTabs"
                        @ActivateUploadingSingleFileNotification="ActivateUploadingSingleFileNotification" :RADB="RADB"
                        @ActivateMultipleFilesUploadNotification="ActivateMultipleFilesUploadNotification"  
                        @NewTableDragfinish="NewTableDragfinish"       
                        :AppisDarkMode="AppisDarkMode" :SystemPhotoLibraries="SystemPhotoLibraries"
                        :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                        :PageHeadersFontSize="PageHeadersFontSize" :tab="tab" @OpenDialog="OpenDialog" :tabindex="i"
                        />
                        <!-- Data Single Standard
                        Data Single Cabinet -->
                        </v-flex>
                    </v-row>								
                     <v-row  v-if="tab.Name !== 'Parallax' && tab.Name !== 'Clipped Tab' && !tab.DataViewName && tab.Type !== '3D Carousel' && tab.Type !== 'Magazine Style'"        									
                        :class="'mb-6 '+tab.Justify"									
                        no-gutters									
                       	:style="tab.CustomStyle"								
                       									
                        >   
              				
                         <v-hover v-slot="{ hover }">	
                            <div  v-if="hover">								
                        <v-card flat width="100%" height="100" :id="i+'drop-area'" @click="OpenDialog(tab,i)"
                        v-if="tab.Name === 'blank' && tab.Elements.length === 0 || tab.Name === 'blank' && dragging && !dragging.SectionType || tab.DataViewName && dragging[tab.DataViewName.split(' ').join('')]"									
                             @dragover.prevent @drop.prevent="elementdropFinish(i, $event)">									
                            <v-layout class="justify-center">									
                                <v-card-title class="grey--text">									
                                <v-icon>mdi-plus-thick</v-icon> Add Content									
                                </v-card-title>									
                            </v-layout>									
                            </v-card>  
                            </div>
                         </v-hover>  									
                            <!-- <v-col									
                            v-for="(elmnt,index) in tab.Elements" :id="'guidetab'+i+'elmnt'+index"										
                            :key="elmnt.itemObjKey" :xl="elmnt.FlexXLRG" :lg="elmnt.FlexLarge" :md="elmnt.FlexMedium" :sm="elmnt.FlexSmall" :xs="elmnt.FlexXSmall"									
                            cols="12"
                            style="position: absolute;border-right: 2px dotted blue;border-left: 2px dotted blue;height:100%;width: 100%;z-index:3;">
                            </v-col>        									 -->
                        <v-col									
                            v-for="(elmnt,index) in tab.Elements"									
                            :key="elmnt.itemObjKey"						
                            cols="12" :id="'tab'+i+'elmnt'+index"									
                            :class="elmnt.Justify+' '+ColMY(elmnt)+' tabelmnt'"  	
                             :style="ResponsiveElmntFlex(elmnt,tab)"                  									
                        >    
                        <!-- <v-btn @click="DownloadallBlockTypes()">Download Block Types</v-btn> -->
                         <!-- <div style="position:absolute;border-right: 2px dotted blue;border-left: 2px dotted blue;height:100%;width: 100%;z-index:3;"/> -->
                        <ul style="width:100%;z-index: 4;" v-if="elmnt.Category && elmnt.Database !== 'Client' && WindowPreset.Name === 'Default'">
                       
                            <v-menu>
                                <template v-slot:activator="{ on: menu, attrs }">
                                <v-chip
                                    style="z-index: 4;position: absolute;left:0px;top:30px;"
                                    class="ma-2"
                                    v-bind="attrs"
                                    v-on="{ ...menu }"
                                    color="deep-purple accent-4"
                                    outlined
                                >
                                    <v-icon left>
                                    {{ elmnt.Icon }}
                                    </v-icon>
                                    {{ elmnt.Preset_Name }}
                                    <v-icon right> mdi-chevron-down </v-icon>
                                </v-chip>
                                </template>
                                <v-virtual-scroll
                                width="350"
                                :items="FilteredRAStorePagePresets(elmnt)"
                                :item-height="420"
                                height="450"
                                class="background"
                                >
                                <template v-slot:default="{ item }">
                                     <v-list-item dense class="overline" >
                                   <v-avatar tile size="35">
                                            <v-icon size="35">{{item.Icon}}</v-icon>
                                        </v-avatar> {{item.Preset_Name}}
                                </v-list-item>
                                    <v-list-item class="RAWebBtnGradlightsoft"
                                    dense
                                     style="border-radius: 15px;max-height: 340px; min-height: 200px; padding: 0px;"
                                    @click="UpdatePreset(elmnt, item, i, index)"
                                    >
                                    <PageTabRenderer
                                        :PageHeadersFont="PageHeadersFont"
                                        :PageContentFont="PageContentFont"
                                        :PageHeadersFontSize="PageHeadersFontSize"
                                        :System="System"
                                        :SystemEntities="SystemEntities"
                                        :tab="PreparedPreviewElement(elmnt, item)"
                                        :i="i"
                                        :downsized="true"
                                        :SampleOnly="true"
                                    />
                                    </v-list-item>
                                    <!-- <v-list-item dense style="height: 40px" class="background darken-1">
                                    <v-chip outlined small color="deep-purple accent-4">
                                        {{ item.Preset_Name }}
                                    </v-chip>
                                    </v-list-item>
                                    <v-list-item
                                    dense
                                    style="max-height: 350px; min-height: 200px; padding: 0px"
                                    @click="UpdatePreset(elmnt, item, i, index)"
                                    >
                                    <PageTabRenderer
                                        :PageHeadersFont="PageHeadersFont"
                                        :PageContentFont="PageContentFont"
                                        :PageHeadersFontSize="PageHeadersFontSize"
                                        style="padding-top: 30px"
                                        :System="System"
                                        :SystemEntities="SystemEntities"
                                        :tab="PreparedPreviewElement(elmnt, item)"
                                        :i="i"
                                        :downsized="true"
                                        :SampleOnly="true"
                                    />
                                    </v-list-item> -->
                                </template>
                                </v-virtual-scroll>
                            </v-menu>
                             <!-- btn,tab,tabindex,IsElement,CustomBoxTabIndex,isrow,rowindex,ContentDialog -->
                            <v-chip
                            @click="ActivateTabDialNew(TabStyleItems(elmnt)[0],elmnt,index,true,i)" 
                            style="z-index: 4;position: absolute;right:100px;top:30px;"
                            class="ma-2"
                            color="orange accent-4"
                            outlined
                            >
                            <v-icon left>
                                    mdi-cogs
                                    </v-icon>
                            {{elmnt.Name}}</v-chip>
                            <v-chip
                            @click="DeleteTabNew(elmnt,index,true,i)" 
                            style="z-index:4;position: absolute;right:0px;top:30px;"
                            class="ma-2"
                            color="red accent-4"
                            outlined
                            >
                            <v-icon left>
                                    mdi-delete-forever
                                    </v-icon>
                            Delete</v-chip>
                            </ul>									
                        <!--  <v-row :class="MiniView ? 'tabelmnttoolbarshown' : 'tabelmnttoolbar'">
                             <v-col
                                cols="12"
                                sm="6"
                                >
                                <v-btn  @click="ActivateStyleButton(TabStyleItems(elmnt)[0],elmnt)" outlined>Configure</v-btn>
                                <v-btn-toggle v-model="toggle_exclusive">
                                    <v-btn @click="ActivateStyleButton(btn,elmnt)" v-for="btn in TabStyleItems(elmnt)" :key="btn.itemObjKey">
                                    <v-icon>{{btn.Icon}}</v-icon>
                                    </v-btn>
                                </v-btn-toggle>
                                </v-col>
                         </v-row> -->
                        <v-card-title class="mediumoverline" v-if="IsDefaultSocialPage && elmnt.DisplayName" :style="SocialPageHeaderStyle">
                                {{elmnt.DisplayName}}
                        </v-card-title>
                        <v-card-title class="mediumoverline" v-if="elmnt.Title && elmnt.SocialComponent || elmnt.Title && elmnt.Name === 'RSS Feed'" :style="HeaderFontFamily(elmnt,elmnt.HeaderFontFamily)">
                                {{elmnt.Title}} 
                        </v-card-title>		
                        	
                         <TimelineTab 									
                            v-if="elmnt.Name === 'Timeline' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"									
                            :PageHeadersFontSize="PageHeadersFontSize" :IsElement="true" :tabindex="i" :rowindex="rowindex"									
                            :tab="elmnt" @OpenDialog="OpenDialog" :i="i"									
                            />									
                            									
                            <ImageTab v-if="elmnt.Name === 'Image' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"									
                            :PageHeadersFontSize="PageHeadersFontSize" :IsElement="true" :tabindex="i" :rowindex="rowindex"									
                            :tab="elmnt" @OpenDialog="OpenDialog" :i="i"									
                            />
                            <RSSFeedTab 
                            v-if="elmnt.Name === 'RSS Feed' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"
                            :tab="elmnt" @OpenDialog="OpenDialog"
                            />
                            <SystemActivitiesFeed 
                            v-if="elmnt.Name === 'System Activities' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"
                            :tab="elmnt" @OpenDialog="OpenDialog"
                             class="mx-3" :UserRecord="userLoggedIn" :Origin="'Page'" :Excerpt="elmnt.Excerpt ? elmnt.Excerpt : 250" :Filter="''"
                            />
                            <SocialSitePosts 
                            v-if="elmnt.Name === 'Social Site Posts' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"
                            :tab="elmnt" @OpenDialog="OpenDialog"
                            :UserObj="userLoggedIn" :AppisDarkMode="AppisDarkMode" class="mx-3" @ActivateMultipleFilesUploadNotification="ActivateMultipleFilesUploadNotification" 
                            :UserRecord="userLoggedIn" :UserID="userLoggedIn.id" :UserView="false" :Slice="10"
                            />
                             <SiteArticleFeed 
                            v-if="elmnt.Name === 'Site Articles' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"
                            :tab="elmnt" @OpenDialog="OpenDialog" :AppisDarkMode="AppisDarkMode" :System="System"
                            :SliderView="elmnt.SliderView ? true : false" :UserRecord="userLoggedIn" :Origin="'Page'" :Excerpt="elmnt.Excerpt ? elmnt.Excerpt : 250" :Slice="elmnt.Slice ? elmnt.Slice : 6" :Filter="''"
                            />
                            <!-- TypeCategories -->
                            <DirectoryViewer style="padding-left: 10px;padding-right:10px;" v-if="elmnt.Name === 'Site Groups' && elmnt.ShowComponents" :ProvidedAdditionalFilters="elmnt.CatNavList.AdditionalFilters"
                            :ProvidedNavList="elmnt.CatNavList.NavList" :ProvidedCurrentEntity="elmnt.CatNavList"
                            @ActivateTreeNode="ActivateTreeNode" :ProvidedFeatureList="elmnt.CatNavList.FeatureList" :style="FinalPageStyling"
                            />
                            <SiteBlogsFeed 
                            v-if="elmnt.Name === 'Site Blogs' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"
                            :tab="elmnt" @OpenDialog="OpenDialog" :AppisDarkMode="AppisDarkMode"
                            :SliderView="elmnt.SliderView ? true : false" :UserRecord="userLoggedIn" :Origin="'Page'" :Excerpt="elmnt.Excerpt ? elmnt.Excerpt : 250" :Slice="elmnt.Slice ? elmnt.Slice : 6" :Filter="''"
                            />                            
                            <SiteEventsFeed 
                            v-if="elmnt.Name === 'Site Events' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"
                            :tab="elmnt" @OpenDialog="OpenDialog" :FeedView="true" :AppisDarkMode="AppisDarkMode"
                            />
                            <SiteMeetupsFeed 
                            v-if="elmnt.Name === 'Site Meetups' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"
                            :tab="elmnt" @OpenDialog="OpenDialog" :AppisDarkMode="AppisDarkMode"
                            :SliderView="elmnt.SliderView ? true : false" :UserRecord="userLoggedIn" :Origin="'Page'" :Excerpt="elmnt.Excerpt ? elmnt.Excerpt : 250" :Slice="elmnt.Slice ? elmnt.Slice : 6" :Filter="''"
                            />
                            <NoticeboardFeed 
                            v-if="elmnt.Name === 'Notice Board' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"
                            :tab="elmnt" @OpenDialog="OpenDialog" :SliderView="elmnt.SliderView ? true : false" 
                             style="padding:15px;" :FeedView="true" :AppisDarkMode="AppisDarkMode"
                            />
                            <DigitalBusinessCards 
                            v-if="elmnt.Name === 'Business Members' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"
                            :tab="elmnt" @OpenDialog="OpenDialog" :SliderView="elmnt.SliderView ? true : false"
                             :AppisDarkMode="AppisDarkMode"
                            />
                            <!-- nothing done on groups feed yet -->
                            <GroupsFeed  v-if="elmnt.Name === 'Groups Feed' && elmnt.ShowComponents"  :View="'Option2'" :UserRecord="userLoggedIn" :Origin="'Page'" :Excerpt="elmnt.Excerpt"
                            :Filter="[]" :FeedView="true"
                            />
                            <InfoCardTab 
                            v-if="elmnt.Name === 'Info Card' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :DefaultPageFont="DefaultPageFont"
                            :tab="elmnt" @OpenDialog="OpenDialog"
                            />
                            <CardLinkTab 
                            v-if="elmnt.Name === 'Card Link' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"
                            :tab="elmnt" @OpenDialog="OpenDialog"
                            />	
                            								
                        <TitleTab 									
                            v-if="elmnt.Name === 'Title' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"									
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"									
                            :tab="elmnt" @OpenDialog="OpenDialog"									
                            />									
                       			<CarouselTab 
                            v-if="elmnt.Name === 'Carousel' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"
                            :tab="elmnt" @OpenDialog="OpenDialog"
                            /> 	
                            <HTMLTable
                            v-if="elmnt.Name === 'HTML Table' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"
                            :tab="elmnt" @OpenDialog="OpenDialog" @onPhotoFileselected="onPhotoFileselected"
                            />	
                             <DocumentsTableTab 
                            v-if="elmnt.Name === 'Documents Table' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"
                            :tab="elmnt" @OpenDialog="OpenDialog"
                            />	
                            <DescriptionList 
                            v-if="elmnt.Name === 'Description List' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"
                            :tab="elmnt" @OpenDialog="OpenDialog"
                            />
                            <FAQ 
                            v-if="elmnt.Name === 'FAQ' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"
                            :tab="elmnt" @OpenDialog="OpenDialog"
                            />
                            				
                            <IFRAMETab  v-if="elmnt.Name === 'IFRAME' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"									
                                :PageHeadersFontSize="PageHeadersFontSize" :tab="elmnt" @OpenDialog="OpenDialog" :i="i"									
                                    />									
                        			
                             <WikiCollection 									
                            v-if="elmnt.Name === 'Wiki Collection' && elmnt.ShowComponents && elmnt.Entityid" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"									
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex" :WikiEntities="WikiEntities"								
                            :tab="elmnt" @OpenDialog="OpenDialog" :Record="DynamicWikiData"								
                            />						
                            <GoogleMyMapsTab 									
                            v-if="elmnt.Name === 'Google My Maps' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"									
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"									
                            :tab="elmnt" @OpenDialog="OpenDialog"									
                            />	
                         							
                            <HTMLBox 									
                            v-if="elmnt.Name === 'HTML Box' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"									
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"									
                            :tab="elmnt" @OpenDialog="OpenDialog"									
                            />									
                            <InfoSheet 									
                            v-if="elmnt.Name === 'Info Sheet' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"									
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"									
                            :tab="elmnt" @OpenDialog="OpenDialog"									
                            />								
                            <WebFormTab v-if="elmnt.Name === 'Web Form' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"									
                            :PageHeadersFontSize="PageHeadersFontSize" @ActivateOptionSetDialog="ActivateOptionSetDialog" 									
                            :OptionNameSelect="OptionNameSelect" :IsElement="true" :tabindex="i" :rowindex="rowindex"
                            :DynamicWikiData="DynamicWikiData" :MappedUserFieldStayHidden="elmnt.MappedUserFieldStayHidden"									
                            :tab="elmnt" :i="i"									
                            />		
                            		
                            <SurveyForm v-if="elmnt.Name === 'Survey Form' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                            :PageHeadersFontSize="PageHeadersFontSize" @ActivateOptionSetDialog="ActivateOptionSetDialog" :PageID="ActivePageID" :PageName="PageName"
                            :OptionNameSelect="OptionNameSelect" :IsElement="true" :tabindex="i" :rowindex="rowindex"
                             :DynamicWikiData="DynamicWikiData"
                            :tab="elmnt" :i="i" :Survey="elmnt"
                            />									
                            <CardRowTab 									
                            v-if="elmnt.Name === 'Card Row Single' && elmnt.ShowComponents && tab.Type !== '3D Carousel' && tab.Type !== 'Magazine Style'" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"									
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex" :System="System"								
                            :tab="elmnt" @OpenDialog="OpenDialog" :PageID="ActivePageID" :PageName="PageName" @DeleteTabAsset="DeleteTabAsset"								
                            />									
                           <CardBlocksTab 									
                            v-if="elmnt.Name === 'Card Block Single' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"									
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"									
                            :tab="elmnt" @OpenDialog="OpenDialog"									
                            />									
                            <CounterTab 									
                            v-if="elmnt.Name === 'Counter Single' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"									
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"									
                            :tab="elmnt" @OpenDialog="OpenDialog"									
                            />									
                            <TestimonialTab 									
                            v-if="elmnt.Name === 'Testimonials' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"									
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"									
                            :tab="elmnt" @OpenDialog="OpenDialog"									
                            />									
                            <StoreProductTab 									
                            v-if="elmnt.Name === 'Store Product Single' && elmnt.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"									
                            :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="i" :rowindex="rowindex"									
                            :tab="elmnt" @OpenDialog="OpenDialog"									
                            />	
                            	<div style="position: absolute;right: 0px;bottom: 0px;" v-if="tab.Name !== 'Card Row' && tab.Name !== 'Card Blocks'"> 
                             <v-btn v-if="tab.Name !== 'Card Row' && tab.Name !== 'Card Blocks'"
                             dark x-small color="warning" class="soloactionicon" style="z-index: 5;" @click="ActivateAddContentDialog(tab,i,true)" fab icon>
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                            </div>	
                         <!-- </div>						 -->
                        </v-col>	
                        <!-- <v-col style="align-self: center;" v-if="TabhasChildren(tab)">
                            <v-btn dark small color="success" class="soloactionicon" style="z-index: 10;" @click="ActivateAddContentDialog(tab,i)" fab icon>
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </v-col>								 -->
                        						
                     </v-row>		
                    							
                     <!-- <v-icon v-if="tab.Name === 'Gallery'" @click="OpenDialog(tab,i)">mdi-cogs</v-icon>									 -->
                     <CardCarouselTab  v-if="tab.Name === 'Card Row' && tab.Type === '3D Carousel' && tab.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                            :PageHeadersFontSize="PageHeadersFontSize" :tab="tab" @OpenDialog="OpenDialog" :tabindex="i"
                                @DeleteTabAsset="DeleteTabAsset" :System="System" :style="'margin-top:'+tab.MarginTop+'px;margin-bottom:'+tab.MarginBottom+'px;margin-left:'+tab.MarginLeft+'px;margin-right:'+tab.MarginRight+'px;'"
                                />
                        <CardRowMagazine  v-if="tab.Name === 'Card Row' && tab.Type === 'Magazine Style' && tab.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"
                    :PageHeadersFontSize="PageHeadersFontSize" :tab="tab" @OpenDialog="OpenDialog" :tabindex="i"
                        @DeleteTabAsset="DeleteTabAsset" :System="System" :style="'margin-top:'+tab.MarginTop+'px;margin-bottom:'+tab.MarginBottom+'px;margin-left:'+tab.MarginLeft+'px;margin-right:'+tab.MarginRight+'px;'"
                        />
                    <GalleryTab  v-if="tab.Name === 'Gallery' && tab.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"									
                            :PageHeadersFontSize="PageHeadersFontSize" :tab="tab" @OpenDialog="OpenDialog" :i="i"									
                                @DeleteTabAsset="DeleteTabAsset" :System="System"									
                                />									
                         <!-- <v-icon v-if="tab.Name === 'Parallax'" @click="OpenDialog(tab,i)">mdi-cogs</v-icon>									 -->
                   <ParallaxTab v-if="tab.Name === 'Parallax' && tab.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"									
                    :PageHeadersFontSize="PageHeadersFontSize" @CheckifClipped="CheckifClipped" @OpenContentTypesDialog="OpenContentTypesDialog"									
                    :tab="tab" @OpenDialog="OpenDialog" :i="i" @click="OpenDialog(tab,i)"							
                    />									
                    <!-- <v-icon v-if="tab.Name === 'Clipped Tab'" @click="OpenDialog(tab,i)">mdi-cogs</v-icon>									 -->
                  									
                    <ClippedTab 									
                    v-if="tab.Name === 'Clipped Tab' && tab.ShowComponents" :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"									
                    :PageHeadersFontSize="PageHeadersFontSize"									
                    :tab="tab" @OpenDialog="OpenDialog" :i="i"									
                    />	
                     <v-card flat width="100%" style="visibility:hidden;height:0px"  @dragleave="unallowDrop(event,i)" @dragover.prevent="scrollintoview(i, $event)" @drop.prevent="contentdropFinish(i, $event)" :id="i+'drop-area'">									
                <v-layout id="drop-area" class="justify-center">									
                    <v-card-title class="grey--text">									
                    <v-icon>mdi-plus-thick</v-icon> Add tab below									
                    </v-card-title>									
                </v-layout>									
                </v-card>								
                      </div>								
                    										
                      									
                            </v-layout> 
                            
                            <!-- <v-layout class="justify-center"  style="z-index: 4;position:absolute;right: 50%;">   -->
                                 
                           	
                             <!-- <hr class="my-auto purple--text" style="border-top: dashed 0.5px;" /> -->
                            <!-- </v-layout>								 -->
                </v-card>	
        </div>
        </div>
      <!-- </v-responsive> -->
     </v-responsive>
    <!-- </v-banner> -->
            </div>
        											
</template>									
									
<script>									
import firebase from 'firebase';									
import db from '@/main'									
import axios from 'axios'									
import format from 'date-fns/format'		
import PageTabRenderer from '@/components/WebPages/PageTabRenderer.vue';							
import DirectoryViewer from '@/components/Directories/DirectoryViewer';
import DataSingleStandard from '@/components/Database/DataSingleStandard.vue';
import DataSingleCabinet from '@/components/Database/DataSingleCabinet.vue';	
import ViewEditorComponent from '@/components/WebPages/ViewEditorComponent';								
import TimelineTab from '@/components/WebPages/RenderComponents/TimelineTab';									
import WebFormTab from '@/components/WebPages/RenderComponents/WebFormTab';
import SurveyForm from '@/components/WebPages/RenderComponents/SurveyForm';
import InfoCardTab from '@/components/WebPages/RenderComponents/InfoCardTab';
import CardLinkTab from '@/components/WebPages/RenderComponents/CardLinkTab';

import SystemActivitiesFeed from '@/components/SocialNetwork/SystemActivitiesFeed';
import SocialSitePosts from '@/components/SocialNetwork/SocialSitePosts';
import SiteArticleFeed from '@/components/SuitePlugins/Articles/SiteArticleFeed';
import SiteBlogsFeed from '@/components/SuitePlugins/Blogs/SiteBlogsFeed';
import SiteEventsFeed from '@/components/SuitePlugins/Events/SiteEvents';
import SiteMeetupsFeed from '@/components/SuitePlugins/Meetups/SiteMeetupsFeed';
import NoticeboardFeed from '@/components/SuitePlugins/DigitalNoticeBoard/NoticeboardFeed';
import DigitalBusinessCards from '@/components/SuitePlugins/DigitalBusinessCards/DigitalBusinessCards';
import GroupsFeed from '@/components/SuitePlugins/Groups/GroupsFeed';
import RSSFeedTab from '@/components/WebPages/RenderComponents/RSSFeedTab';		
import CarouselTab from '@/components/WebPages/RenderComponents/CarouselTab';
import HTMLTable from '@/components/WebPages/RenderComponents/HTMLTable';
import DocumentsTableTab from '@/components/WebPages/RenderComponents/DocumentsTableTab';		
import DescriptionList from '@/components/WebPages/RenderComponents/DescriptionList';		
import FAQ from '@/components/WebPages/RenderComponents/FAQ';		
			
import TitleTab from '@/components/WebPages/RenderComponents/TitleTab';									
import CounterTab from '@/components/WebPages/RenderComponents/CounterTab';									
import StoreProductTab from '@/components/WebPages/RenderComponents/StoreProductTab';									
import TestimonialTab from '@/components/WebPages/RenderComponents/TestimonialTab';									
import CardBlocksTab from '@/components/WebPages/RenderComponents/CardBlocksTab';									
import CardRowTab from '@/components/WebPages/RenderComponents/CardRowTab';		
import InfoSheet from '@/components/WebPages/RenderComponents/InfoSheet';								
import HTMLBox from '@/components/WebPages/RenderComponents/HTMLBox';									
import ImageTab from '@/components/WebPages/RenderComponents/ImageTab';									
import ParallaxTab from '@/components/WebPages/RenderComponents/ParallaxTab';									
import ClippedTab from '@/components/WebPages/RenderComponents/ClippedTab';									
import IFRAMETab from '@/components/WebPages/RenderComponents/IFRAMETab';									
import GalleryTab from '@/components/WebPages/RenderComponents/GalleryTab';	
import CardCarouselTab from '@/components/WebPages/RenderComponents/CardCarouselTab';	
import CardRowMagazine from '@/components/WebPages/RenderComponents/CardRowMagazine';							
import GoogleMyMapsTab from '@/components/WebPages/RenderComponents/GoogleMyMapsTab';	
import WikiCollection from '@/components/WebPages/RenderComponents/WikiCollection';			
export default {									
    props: ['SystemGuides','RADB','GroupEntities','CategoricalNavlists','DocumentationLibraries',
        'SingleFormEditing','DataSingleTabs','FrequentlyAskedQuestions' ,       
        'SinglePageBGGradient','EntityDataRef','EntityCollectionRef','CurrentEntity',
        'System','AdditionalSaveMethod','ClsfdNavList','TableRecordView',
        'SystemEntities','AppisDarkMode','CanEdit','tab','DynamicWikiData','Business_Unit',
        'RelatedObj','AppointmentsQuery','TasksQuery','EmailsQuery','NotesQuery','PhoneCallsQuery','ActivitiesArray','PrimaryFieldName',        
        'SingleRecordNavMenu','SingleRecordNavMenuItem','SitePages','SystemPhotoLibraries','FeatureNavList','WikiEntities'
    ],								
    components: {	
        PageTabRenderer,
        ViewEditorComponent,					
        TimelineTab,									
        WebFormTab,	
        SurveyForm,
        InfoCardTab,
        CardLinkTab,
        SiteArticleFeed,
        SiteBlogsFeed,
        SystemActivitiesFeed,
        SocialSitePosts,
        SiteEventsFeed,
        SiteMeetupsFeed,
        NoticeboardFeed,
        DigitalBusinessCards,
        GroupsFeed,
        RSSFeedTab,	
        CarouselTab,
        HTMLTable,
        DocumentsTableTab,
        DescriptionList,
        FAQ,							
        TitleTab,	
        InfoSheet,								
        HTMLBox,									
        CardBlocksTab,									
        CardRowTab,									
        CounterTab,									
        StoreProductTab,									
        TestimonialTab,									
        ImageTab,									
        ParallaxTab,									
        CardCarouselTab,	
        CardRowMagazine,								
        ClippedTab,        									
        GalleryTab,									
        IFRAMETab,									
        GoogleMyMapsTab,
        DataSingleStandard,
        DataSingleCabinet,
        WikiCollection,
        DirectoryViewer						
        									
        },									
    data() {									
    return {
        SVGPaths: ['TopWave1Path','TopWave2Path','TopWave3Path','TopWave4Path','BottomWave1Path','BottomWave2Path','BottomWave3Path','BottomWave4Path'],
        ClearNavbarColor: false,
        PageCustomStyle: '',
        PageOverlay: '',
        ImageRecord: '',
        ImageField: '',
        WindowPreset: {
            Name: 'Default',
            Icon: 'mdi-monitor'
        },
        WindowPresets: [            
            {
                Name: 'Default',
                Icon: 'mdi-monitor'
            },
            {
                Name: 'Laptop',
                Icon: 'mdi-laptop',
                Width: '1263px',
                Height: '710px'
            },
             {
                Name: 'Tablet Portrait',
                Icon: 'mdi-tablet',
                Width: '768px',
                Height: '1024px',
                Rotate: true,
            },
            {
                Name: 'Tablet Landscape',
                Icon: 'mdi-tablet',
                Width: '1024px',
                Height: '768px'
            },           
            {
                Name: 'Phone Portrait',
                Icon: 'mdi-cellphone',
                Width: '360px',
                Height: '740px',
            },
            {
                Name: 'Phone Landscape',
                Icon: 'mdi-cellphone',
                Width: '740px',
                Height: '360px',
                Rotate: true,
            },
        ],
        BelowTabIndex: -1,
        BelowTab: '',
        ToElement: false,
        RefreshingSingleElement: false,
        SelectedElement: '',
        RenderedContentBlocks: [],
        
        STDCSSColors: [{Name: 'aliceblue', HEX: '#f0f8ff'},{Name: 'antiquewhite', HEX: '#faebd7'},{Name: 'aqua', HEX: '#00ffff'},{Name: 'aquamarine', HEX: '#7fffd4'},{Name: 'azure', HEX: '#f0ffff'},{Name: 'beige', HEX: '#f5f5dc'},{Name: 'bisque', HEX: '#ffe4c4'},{Name: 'black', HEX: '#000000'},{Name: 'blanchedalmond', HEX: '#ffebcd'},{Name: 'blue', HEX: '#0000ff'},{Name: 'blueviolet', HEX: '#8a2be2'},{Name: 'brown', HEX: '#a52a2a'},{Name: 'burlywood', HEX: '#deb887'},{Name: 'cadetblue', HEX: '#5f9ea0'},{Name: 'chartreuse', HEX: '#7fff00'},{Name: 'chocolate', HEX: '#d2691e'},{Name: 'coral', HEX: '#ff7f50'},{Name: 'cornflowerblue', HEX: '#6495ed'},{Name: 'cornsilk', HEX: '#fff8dc'},{Name: 'crimson', HEX: '#dc143c'},{Name: 'cyan', HEX: '#00ffff'},{Name: 'darkblue', HEX: '#00008b'},{Name: 'darkcyan', HEX: '#008b8b'},{Name: 'darkgoldenrod', HEX: '#b8860b'},{Name: 'darkgray', HEX: '#a9a9a9'},{Name: 'darkgreen', HEX: '#006400'},{Name: 'darkgrey', HEX: '#a9a9a9'},{Name: 'darkkhaki', HEX: '#bdb76b'},{Name: 'darkmagenta', HEX: '#8b008b'},{Name: 'darkolivegreen', HEX: '#556b2f'},{Name: 'darkorange', HEX: '#ff8c00'},{Name: 'darkorchid', HEX: '#9932cc'},{Name: 'darkred', HEX: '#8b0000'},{Name: 'darksalmon', HEX: '#e9967a'},{Name: 'darkseagreen', HEX: '#8fbc8f'},{Name: 'darkslateblue', HEX: '#483d8b'},{Name: 'darkslategray', HEX: '#2f4f4f'},{Name: 'darkslategrey', HEX: '#2f4f4f'},{Name: 'darkturquoise', HEX: '#00ced1'},{Name: 'darkviolet', HEX: '#9400d3'},{Name: 'deeppink', HEX: '#ff1493'},{Name: 'deepskyblue', HEX: '#00bfff'},{Name: 'dimgray', HEX: '#696969'},{Name: 'dimgrey', HEX: '#696969'},{Name: 'dodgerblue', HEX: '#1e90ff'},{Name: 'firebrick', HEX: '#b22222'},{Name: 'floralwhite', HEX: '#fffaf0'},{Name: 'forestgreen', HEX: '#228b22'},{Name: 'fuchsia', HEX: '#ff00ff'},{Name: 'gainsboro', HEX: '#dcdcdc'},{Name: 'ghostwhite', HEX: '#f8f8ff'},{Name: 'gold', HEX: '#ffd700'},{Name: 'goldenrod', HEX: '#daa520'},{Name: 'gray', HEX: '#808080'},{Name: 'green', HEX: '#008000'},{Name: 'greenyellow', HEX: '#adff2f'},{Name: 'grey', HEX: '#808080'},{Name: 'honeydew', HEX: '#f0fff0'},{Name: 'hotpink', HEX: '#ff69b4'},{Name: 'indianred', HEX: '#cd5c5c'},{Name: 'indigo', HEX: '#4b0082'},{Name: 'ivory', HEX: '#fffff0'},{Name: 'khaki', HEX: '#f0e68c'},{Name: 'lavender', HEX: '#e6e6fa'},{Name: 'lavenderblush', HEX: '#fff0f5'},{Name: 'lawngreen', HEX: '#7cfc00'},{Name: 'lemonchiffon', HEX: '#fffacd'},{Name: 'lightblue', HEX: '#add8e6'},{Name: 'lightcoral', HEX: '#f08080'},{Name: 'lightcyan', HEX: '#e0ffff'},{Name: 'lightgoldenrodyellow', HEX: '#fafad2'},{Name: 'lightgray', HEX: '#d3d3d3'},{Name: 'lightgreen', HEX: '#90ee90'},{Name: 'lightgrey', HEX: '#d3d3d3'},{Name: 'lightpink', HEX: '#ffb6c1'},{Name: 'lightsalmon', HEX: '#ffa07a'},{Name: 'lightseagreen', HEX: '#20b2aa'},{Name: 'lightskyblue', HEX: '#87cefa'},{Name: 'lightslategray', HEX: '#778899'},{Name: 'lightslategrey', HEX: '#778899'},{Name: 'lightsteelblue', HEX: '#b0c4de'},{Name: 'lightyellow', HEX: '#ffffe0'},{Name: 'lime', HEX: '#00ff00'},{Name: 'limegreen', HEX: '#32cd32'},{Name: 'linen', HEX: '#faf0e6'},{Name: 'magenta', HEX: '#ff00ff'},{Name: 'maroon', HEX: '#800000'},{Name: 'mediumaquamarine', HEX: '#66cdaa'},{Name: 'mediumblue', HEX: '#0000cd'},{Name: 'mediumorchid', HEX: '#ba55d3'},{Name: 'mediumpurple', HEX: '#9370db'},{Name: 'mediumseagreen', HEX: '#3cb371'},{Name: 'mediumslateblue', HEX: '#7b68ee'},{Name: 'mediumspringgreen', HEX: '#00fa9a'},{Name: 'mediumturquoise', HEX: '#48d1cc'},{Name: 'mediumvioletred', HEX: '#c71585'},{Name: 'midnightblue', HEX: '#191970'},{Name: 'mintcream', HEX: '#f5fffa'},{Name: 'mistyrose', HEX: '#ffe4e1'},{Name: 'moccasin', HEX: '#ffe4b5'},{Name: 'navajowhite', HEX: '#ffdead'},{Name: 'navy', HEX: '#000080'},{Name: 'oldlace', HEX: '#fdf5e6'},{Name: 'olive', HEX: '#808000'},{Name: 'olivedrab', HEX: '#6b8e23'},{Name: 'orange', HEX: '#ffa500'},{Name: 'orangered', HEX: '#ff4500'},{Name: 'orchid', HEX: '#da70d6'},{Name: 'palegoldenrod', HEX: '#eee8aa'},{Name: 'palegreen', HEX: '#98fb98'},{Name: 'paleturquoise', HEX: '#afeeee'},{Name: 'palevioletred', HEX: '#db7093'},{Name: 'papayawhip', HEX: '#ffefd5'},{Name: 'peachpuff', HEX: '#ffdab9'},{Name: 'peru', HEX: '#cd853f'},{Name: 'pink', HEX: '#ffc0cb'},{Name: 'plum', HEX: '#dda0dd'},{Name: 'powderblue', HEX: '#b0e0e6'},{Name: 'purple', HEX: '#800080'},{Name: 'red', HEX: '#ff0000'},{Name: 'rosybrown', HEX: '#bc8f8f'},{Name: 'royalblue', HEX: '#4169e1'},{Name: 'saddlebrown', HEX: '#8b4513'},{Name: 'salmon', HEX: '#fa8072'},{Name: 'sandybrown', HEX: '#f4a460'},{Name: 'seagreen', HEX: '#2e8b57'},{Name: 'seashell', HEX: '#fff5ee'},{Name: 'sienna', HEX: '#a0522d'},{Name: 'silver', HEX: '#c0c0c0'},{Name: 'skyblue', HEX: '#87ceeb'},{Name: 'slateblue', HEX: '#6a5acd'},{Name: 'slategray', HEX: '#708090'},{Name: 'slategrey', HEX: '#708090'},{Name: 'snow', HEX: '#fffafa'},{Name: 'springgreen', HEX: '#00ff7f'},{Name: 'steelblue', HEX: '#4682b4'},{Name: 'tan', HEX: '#d2b48c'},{Name: 'teal', HEX: '#008080'},{Name: 'thistle', HEX: '#d8bfd8'},{Name: 'tomato', HEX: '#ff6347'},{Name: 'turquoise', HEX: '#40e0d0'},{Name: 'violet', HEX: '#ee82ee'},{Name: 'wheat', HEX: '#f5deb3'},{Name: 'white', HEX: '#ffffff'},{Name: 'whitesmoke', HEX: '#f5f5f5'},{Name: 'yellow', HEX: '#ffff00'},{Name: 'yellowgreen', HEX: '#9acd32'},
],
        sitenavitems: [
        { title: 'Add Content', icon: 'mdi-plus',Menu: false},
          { title: 'Site Menu & Pages', icon: 'mdi-home-city',Menu: false},
          { title: 'Page Design', icon: 'mdi-palette' ,Menu: false},
          { title: 'Page Layout', icon: 'mdi-monitor-dashboard' ,Menu: false},          
          { title: 'Media', icon: 'mdi-folder-image' ,Menu: false},
        ],
        MiniStyler: false,
        ActiveButtoncompname: '',
        ActiveButtonName: '',
        SelectedActiveButton: '',
        PageData: '',
        WikiPublishTypeDialog: false,
        GroupData: '',
        GroupAssets: [],
        TopRowAdding: false,  	
        formfielddragging: '',
        formfielddraggingindex: -1,
        PageBGGradient: '',
        PageBGAsset: '',
        PageBGColor: '',
        FieldTypes: [],								
        NewTestimonialFile: '',									
        SampleTestinomialFile: '',									
        EditTestimonyDialog: false,									
        EditedTestimony: '',									
        EditedTestimonyIndex: -1,									
        model: true,									
        colors: [									
        'primary',									
        'secondary',									
        'yellow darken-2',									
        'red',									
        'orange',									
      ],									
        DataCountCollections: [									
									
        ],									
        SelectedStoreProducts: [],									
        DefaultProductsArray: [],	TypeChange: '',									
        GalleryLibraries: [],									
        GalleryObjects: [],									
        PageContentFont: 'Montserrat',									
        PageHeadersFontSize: 42,									
        PageHeadersFont: 'Raleway',									
        customboxindex: -1,									
        elementIndex: -1,									
        rowindex: -1,									
        EditedRow: '',									
        WrappingOptions: [									
            {									
                DisplayName: 'Top Left',									
                FlexValue: 'align-self:flex-start',									
                LayoutValue: 'fill-height justify-start',									
                JustifyIcon: 'mdi-format-align-left'									
            },									
            {									
                DisplayName: 'Top Center',									
                FlexValue: 'align-self:flex-start',									
                LayoutValue: 'fill-height justify-center',									
                JustifyIcon: 'mdi-format-align-center'									
            },									
            {									
                DisplayName: 'Top Right',									
                FlexValue: 'align-self:flex-start',									
                LayoutValue: 'fill-height justify-end',									
                JustifyIcon: 'mdi-format-align-right'									
            },									
            {									
                DisplayName: 'Center Left',									
                FlexValue: 'align-self:center',									
                LayoutValue: 'fill-height justify-start',									
                JustifyIcon: 'mdi-format-align-left'									
            },									
            {									
                DisplayName: 'Absolute Center',									
                FlexValue: 'align-self:center',									
                LayoutValue: 'fill-height justify-center',									
                JustifyIcon: 'mdi-format-align-center'									
            },									
            {									
                DisplayName: 'Center Right',									
                FlexValue: 'align-self:center',									
                LayoutValue: 'fill-height justify-end',									
                JustifyIcon: 'mdi-format-align-right'									
            },									
            {									
                DisplayName: 'Bottom Left',									
                FlexValue: 'align-self:flex-end',									
                LayoutValue: 'fill-height justify-start',									
                JustifyIcon: 'mdi-format-align-left'									
            },									
            {									
                DisplayName: 'Bottom Center',									
                FlexValue: 'align-self:flex-end',									
                LayoutValue: 'fill-height justify-center',									
                JustifyIcon: 'mdi-format-align-center'									
            },									
            {									
                DisplayName: 'Bottom Right',									
                FlexValue: 'align-self:flex-end',									
                LayoutValue: 'fill-height justify-end',									
                JustifyIcon: 'mdi-format-align-right'									
            },									
            									
        ],									
        SystemAssets: [],									
        EditedTabindex: -1,									
        EditedTab: '',									
        ContentTypesDialog: false,									
        TabDialog: false,									
        ShowComponents: true,	
        NewFieldDragging: '',							
        								
        items: [									
        {									
          src: 'backgrounds/bg.jpg',									
        },									
        {									
          src: 'backgrounds/md.jpg',									
        },									
        {									
          src: 'backgrounds/bg-2.jpg',									
        },									
        {									
          src: 'backgrounds/md2.jpg',									
        },									
      ],									
      selected: [],									
        ContentBlocks : [],								
        PageOverview: '',									
        PageName: '',	
        PageRoute: '',
        PageIcon: '',	
        CatNavList: '',							
        initiallyOpen: ['Body'],									
      									
        PageTabs: [									
            									
        ],									
        RecordSpecificTypes: [									
            {									
            ID: 1000001,									
            Name: 'Wiki'									
            }									
        ],									
        PublishType: '',									
        PublishTypes: [									
            'Public',									
            'Members Only'									
        ],									
        RecordName: '',									
        FeatureType: '',									
        RecordSpecific: false,									
        SiteRouteComponents: [],									
        BannerComponents: [],   									
        BannerImage: 'https://firebasestorage.googleapis.com/v0/b/templatizer-9620d.appspot.com/o/DefaultSystemAssets%2FExports%2FRASolidA?alt=media&token=917741bf-7928-4b75-8baa-5564ef93fafd',									
        ActionButtonName: 'Find out More',									
        BannerLink: '/Groups/0erBwGHT5CzGEFSucUKf',									
        BannerPreview: true,									
        BannerHeader: '',									
        LinkType: '',									
        BannerName: '',									
        BannerDescription: '',									
        NewBannerTypes: [									
            {									
                ID: 1000001,									
                Name: 'Sidebar'									
            },									
            {									
                ID: 1000002,									
                Name: 'Topbar (GIF)'									
            },									
            {									
                ID: 1000003,									
                Name: 'TopBar (HTML)'									
            },									
        ],									
        SiteGroups: [],									
        LinkTypes: [									
            {									
                ID: 1000001,									
                Name: 'Page'									
            },									
            {									
                ID: 1000002,									
                Name: 'Group'									
            },									
            {									
                ID: 1000003,									
                Name: 'Article'									
            },									
            {									
                ID: 1000004,									
                Name: 'Wiki'									
            },									
            {									
                ID: 1000005,									
                Name: 'External'									
            },									
        ],								
        OptionSetDialog: false,									
        EditOptionSet: '',									
        OptionName: '',									
        Option: {},									
        FieldsDialogActivate: false,									
        UserRecord: '',									
        NewAssetFile: '',									
        SystemAssetsPage: 1,									
        rules: {									
            youtubeurl: value => {									
                const pattern = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;									
                return pattern.test(value) || "Not a Youtube Video Link.";									
            },									
            min8Chars: value => value.length >= 8 || "Min. 8 characters",									
            required: value => !!value || "Required.",									
            email: value => {									
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;									
                return pattern.test(value) || "Invalid e-mail.";									
            },									
            url: value => {									
                const urlpattern = new RegExp('^(https?:\\/\\/)?'+ // protocol									
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name									
            '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address									
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path									
            '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string									
            '(\\#[-a-z\\d_]*)?$','i'); 									
                return urlpattern.test(value) || "Invalid Link.";									
            }									
            },									
            									
									
            }									
    }, 									
	watch: {
        ResponsiveSize: {
            handler: function(newvalue, oldvalue) {
                //console.log(newvalue, oldvalue)
                let width = Number(newvalue.Width.split('px')[0])
                // this.$vuetify.breakpoint.width = width
                // if(width < 600){
                //     //alert('xs')
                //     this.$vuetify.breakpoint.xs = true
                //     this.$vuetify.breakpoint.sm = false
                //     this.$vuetify.breakpoint.md = false
                //     this.$vuetify.breakpoint.lg = false
                //     this.$vuetify.breakpoint.xl = false
                //      this.$vuetify.breakpoint.name = 'xs'
                // }
                // else if(width < 960){
                //     this.$vuetify.breakpoint.xs = false
                //     this.$vuetify.breakpoint.md = false
                //     this.$vuetify.breakpoint.lg = false
                //     this.$vuetify.breakpoint.xl = false
                //     this.$vuetify.breakpoint.sm = true
                //      this.$vuetify.breakpoint.name = 'sm'
                //      this.$vuetify.breakpoint.smOnly = true
                // }
                // else if(width < 1264){
                //     this.$vuetify.breakpoint.xs = false
                //     this.$vuetify.breakpoint.sm = false
                //     this.$vuetify.breakpoint.md = true
                //     this.$vuetify.breakpoint.lg = false
                //     this.$vuetify.breakpoint.xl = false
                //      this.$vuetify.breakpoint.name = 'md'
                // }
                // else if(width < 1904){
                //     this.$vuetify.breakpoint.xs = false
                //     this.$vuetify.breakpoint.sm = false
                //     this.$vuetify.breakpoint.md = false
                //     this.$vuetify.breakpoint.lg = true
                //     this.$vuetify.breakpoint.xl = false
                //     this.$vuetify.breakpoint.name = 'lg'
                // }
                // else {
                //     this.$vuetify.breakpoint.xs = false
                //     this.$vuetify.breakpoint.sm = false
                //     this.$vuetify.breakpoint.md = false
                //     this.$vuetify.breakpoint.lg = false
                //     this.$vuetify.breakpoint.xl = true
                //     this.$vuetify.breakpoint.name = 'xl'
                // }
                // console.log(width,this.$vuetify.breakpoint,this.$vuetify.breakpoint.name,this.$vuetify.breakpoint.width)
            },
            deep: true,
        },
        SystemAssets: {
            handler: function(newvalue, oldvalue) {
                //console.log(newvalue, oldvalue)
                if(newvalue !== oldvalue || newvalue.length > 0){
                    //console.log('setting assets')
                    this.$store.commit('setSystemAssets',newvalue)
                }
            },deep: true
        },
        ContentBlocks: {
            handler: function(newvalue, oldvalue) {
                if(newvalue !== oldvalue){
                    this.$store.commit('setContentBlocks',newvalue)
                }
            },deep: true
        },
        RenderedContentBlocks: {
            handler: function(newvalue, oldvalue) {
                if(newvalue !== oldvalue){
                    this.$store.commit('setRenderedContentBlocks',newvalue)
                }
            },deep: true
        },
        PageData: {
            handler: function(newvalue, oldvalue) {
                if(newvalue !== oldvalue){
                    this.$emit('IntranetViewToggle',false)
                    this.$store.commit('setEditedPage',newvalue)
                    this.PublishType = newvalue.PublishType
                    if(this.$route.name === 'DocumentationLibraryEditor'){         
                    this.$store.commit('setBuilderView',{Name: 'Documentation Builder'})
                    }
                    else if(newvalue && newvalue.PublishType === 'Public'){                        
                        this.$store.commit('setBuilderView',{Name: 'Website Builder'})
                    } 
                    else if(newvalue && newvalue.PublishType === 'Members Only'){
                        this.$store.commit('setBuilderView',{Name: 'Social Network Builder'})
                        this.$emit('IntranetViewToggle',true)
                    }
                    else if(this.IsGroupView){
                        this.$store.commit('setBuilderView',{Name: 'Website Builder'})
                    }
                }
            },deep: true
        },
        SocialItemInteractMethod(v){   
        //console.log(v)
        let acceptedmethods = ['UpdatePageBGAsset','Tabdragfinish','ReceiveAddedAssets','ShowTabElements','HideTabElements','Elmntdragfinish','AddTabBelow',
        'AdjustRowAmount','UpdatePageContentFont','UpdatePageHeadersFont','UpdateClearNavbarColor','UpdatePageCustomStyle','UpdatePageOverlay','UpdatePageBGColor','UpdatePageHeadersFontSize','SavePageAsIs',
        'UpdatePageBGGradient','ActivateSelectedElement','OpenDialogCustom']   
       
        if(v && acceptedmethods.includes(v)){
          if(typeof this.SocialItemInteractMethodProp !== 'undefined'){
            //console.log('yes with prop',this.SocialItemInteractMethod,this.SocialItemInteractMethodProp)
            this[this.SocialItemInteractMethod](this.SocialItemInteractMethodProp)
            if(this.SocialItemInteractMethod === 'ActivateSelectedElement'){
              this.SingleRecordNavMenuItem = ''
            }
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }
          else{ 
            this[this.SocialItemInteractMethod]()
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }          
        }
      },
        MiniView(value){
            // if(value){
            //     this.TurnoffSiteDialog()
            // }
            // else{
            //     this.TurnonSiteDialog()
            // }
        },
        SelectedMain (value){
            if(value){
                this.SelectedMainDialog = true
            }
            else{
                this.SelectedMainDialog = false
            }
        },
        StoreSystemObj : {
            handler: function(newvalue, oldvalue) {
            // if(this.$route.name !== 'landingpagesingle' && this.$route.meta && this.$route.meta.RouteEventID === 1028 && this.$route.meta && this.$route.meta.RouteEventID === 1027){
            // }
            if(newvalue.AppDefaultHeader){
            this.PageHeadersFont = newvalue.AppDefaultHeader.Name
            this.PageHeadersFontSize = newvalue.AppDefaultHeader.SizeMultiplier
            }
            if(newvalue.AppDefaultBody){
            this.PageContentFont = newvalue.AppDefaultBody.Name
            }             
              
            },
            deep: true
    },
        TopRowAdding (value){
            if(value){
                let elmnt = document.getElementById('top-drop-area')
                elmnt.style.visibility = 'visible'
            }
            else{
                let elmnt = document.getElementById('top-drop-area')
                elmnt.style.visibility = 'hidden' 
            }
        },
        PageTabsReady (value){
            if(value){
                this.PrepAnimations()
            }
        },
        AnitmatedElements: {
            handler: function(oldvalue, newvalue) {
                if(oldvalue !== newvalue){
                    setTimeout(() => {
                     this.RunWebAnimations()   
                    }, 1500);
                    
                }
            },deep: true
    },
        RouteObj: {
            handler: function(newvalue, oldvalue) {
                if(oldvalue !== newvalue){
                    this.CatNavList = ''
                    this.SelectedElement = ''
                    if(this.$route.name !== 'DocumentationLibraryEditor'
                    || this.$route.name === 'DocumentationLibraryEditor' && !this.ActiveDocumentationLibrary
                    || this.$route.name === 'DocumentationLibraryEditor' && this.ActiveDocumentationLibrary && this.ActiveDocumentationLibrary.id !== this.$route.params.id){
                      this.CheckUser()  
                    }
                    else if(this.$route.name === 'DocumentationLibraryEditor' && this.ActiveDocumentationLibrary && this.ActiveDocumentationLibrary.id === this.$route.params.id){
                       let pageobj = this.ActiveDocumentationLibrary.Pages.find(obj => obj.id === this.$route.params.slug.split(' ').join('_').split('-').join('_'))
                        this.AssignPageProperties(pageobj)
                    }
                    this.ScrolltoTop()
                }
            },deep: true
        },
        ActiveDocumentationLibraryPages : {
            handler: function(newvalue, oldvalue) {
                if(newvalue !== oldvalue){
                    let pageobj = this.ActiveDocumentationLibrary.Pages.find(obj => obj.id === this.$route.params.slug.split(' ').join('_').split('-').join('_'))
                       if(pageobj){
                        this.AssignPageProperties(pageobj)   
                       }
                }
            },deep: true
        },
        ActiveGroup: {
            handler: function(newvalue, oldvalue) {
                if(oldvalue !== newvalue && this.$route.name === 'GroupPageEditor'){
                    this.GetGroupInformation()
                }
            },deep: true
        },
        
    },								
    computed:{
        FontOptions(){
            return this.$store.state.FontOptions
        },
        SavingPageTabs(){
            return this.PageTabs.map(tab => {
                delete tab.ClippingStyle
                    delete tab.AnimationStyle
                if(tab.Elements){
                    tab.Elements = tab.Elements.map(elmnt => {
                       delete elmnt.ClippingStyle
                        delete elmnt.AnimationStyle  
                        if(elmnt.FormFields){
                            elmnt.FormFields = elmnt.FormFields.map(fieldobj => {
                                 delete fieldobj.Response
                                delete fieldobj.Array
                                delete fieldobj.CanEdit
                                delete fieldobj.CanGet
                                delete fieldobj.CanDelete
                                delete fieldobj.CanView
                                delete fieldobj.CanCreate
                                return fieldobj
                            })
                        }
                        return elmnt   
                    })
                }
                if(tab.Assets){
                    tab.Assets = tab.Assets.map(asset => {
                       delete asset.ClippingStyle
                        delete asset.AnimationStyle  
                        return asset   
                    })
                }
                return tab
            })
        },
        ResponsiveSize(){
            if(this.WindowPreset.Name === 'Default'){
                return {
                    Width: window.innerWidth,
                    Height: '100%'
                }
            }
            else{
                return {
                    Width: this.WindowPreset.Width,
                    Height: this.WindowPreset.Height
                }
            }
        },
        RAStorePagePresets(){
            return this.$store.state.RAStorePagePresets
        },
        ComputedSystemAssets(){
            //console.log(this.DocLibisRADB,this.$store.state.RASystemAssets,this.$store.state)
            return this.DocLibisRADB ? this.$store.state.RASystemAssets : this.SystemAssets
        },
        CanEditDocLib(){
            return this.ActiveDocumentationLibrary && !this.DocLibisRADB && this.userIsAdmin
            || this.ActiveDocumentationLibrary && this.DocLibisRADB && this.RAAdmin
        },
        RAAdmin(){
            return this.RAUserObj && this.RAUserObj.rolesarrayDBRules && this.RAUserObj.rolesarrayDBRules.SystemAdmin
        },
        RAUserObj(){
            return this.$store.state.RAUserObj
        },
        RADB(){
            return this.$store.state.RADB
        },
        DocLibisRADB(){
            return this.ActiveDocumentationLibrary && this.ActiveDocumentationLibrary.Database && this.ActiveDocumentationLibrary.Database === this.RADB
        },
        DocumentationLibraryObj(){
            let doclibobj = this.DocumentationLibraries.find(obj => obj.id === this.$route.params.id)
            if(this.DocLibEditor && doclibobj){
                return doclibobj
            }
        },
        ActiveDocumentationLibraryPages(){
            return this.ActiveDocumentationLibrary && this.ActiveDocumentationLibrary.Pages ? this.ActiveDocumentationLibrary.Pages : []
        },
        ActiveDocumentationLibrary(){
            return this.$store.state.ActiveDocumentationLibrary
        },
        SystemisRA(){
      return process.env.VUE_APP_RA_SYSTEM_ID === process.env.VUE_APP_RA_PROVIDER_ID
    },
        FilteredSystemTabs(){
            return this.DynamicWikiData && this.DynamicWikiData.id === process.env.VUE_APP_RA_SYSTEM_ID && this.System && !this.SystemisRA && this.$route.name !== 'SystemConfig'
        },
        PageEditStyling(){
            if(!this.AppBuilderView){
                return this.$route.name === 'newlandingpage' ? 'padding-bottom:80px;' : 'padding-bottom:80px;margin-top:55px;'
            }
            else if(this.IsGroupView){
                return this.$route.name === 'newlandingpage' ? 'padding-bottom:80px;' : 'padding-bottom:80px;margin-top:280px;'
            }
            else if(this.NetworkBuilderView){
                return this.$route.name === 'newlandingpage' ? 'padding-bottom:80px;' : 'padding-bottom:80px;'
            }
            else{
                return this.$route.name === 'newlandingpage' ? 'padding-bottom:80px;' : !this.System.PublicNavbarStyle || this.System.PublicNavbarStyle === 'Default' ? 'padding-bottom:80px;margin-top:280px;' : 'padding-bottom:80px;margin-top:200px;'
            }
        },
        AppBuilderView(){
        return this.WebsiteBuilderView || this.DBBuilderView || this.NetworkBuilderView
        },
        BuilderView(){
        return this.$store.state.BuilderView
        },
        WebsiteBuilderView(){
        return this.BuilderView && this.BuilderView.Name === 'Website Builder'
        },
        DBBuilderView(){
        return this.BuilderView && this.BuilderView.Name === 'Database Builder'
        },
        NetworkBuilderView(){
        return this.BuilderView && this.BuilderView.Name === 'Social Network Builder'
        },
        IsGroupView(){
        return this.$store.state.IsGroupView
        },
        draggingtab(){
            return this.$store.state.draggingtab
        },
        draggingtabindex(){
            return this.$store.state.draggingtabindex
        },
        draggingelement(){
            return this.$store.state.draggingelement
        },
        draggingelementindex(){
            return this.$store.state.draggingelementindex
        },
        draggingrow(){
            return this.$store.state.draggingrow
        },
        draggingrowindex(){
            return this.$store.state.draggingrowindex
        },
        dragging(){
            return this.$store.state.dragging
        },
        DefaultPath(){
            //UpdateSEOBasics
            if(this.$route.name === 'PageEditor'){
                return this.System.ClientAppURL+'/'
            }
            else if(this.$route.name === 'GroupPageEditor'){
                return this.System.ClientAppURL+'/Group-Page/'+this.$route.params.id+'/'
            }
        },
        SocialItemInteractMethod(){
        return this.$store.state.SocialItemInteractMethod
        },
        SocialItemInteractMethodProp(){
            return this.$store.state.SocialItemInteractMethodProp
        },
        SelectedImage(){
        return this.$store.state.SelectedGalleryAsset
      },
        Computedsitenavitems(){
            return this.sitenavitems.filter(item => {
                if(this.DataSingleBuilder || this.TableRecordView){
                    return item.title === 'Add Content' || item.title === 'Page Layout'
                }
                else if(this.$route.name === 'newlandingpage'){
                    
                    return item.title !== 'Site Menu & Pages'
                }
                else{
                    return item
                }
            })
        },
        SiteDialog(){
            return this.$store.state.SiteDialog
        },
        DocLibEditor(){
            return this.$route.name === 'DocumentationLibraryEditor'
        },
        SitePageNavStyle(){
            if(!this.SiteDialog){
                return ''
            }
            else {
                return this.MiniView ? 'padding: 0px;' : this.WindowPreset.Name === 'Default' ? 'padding-left:100px;padding-top:0px;padding-bottom:0px;padding-right:0px;' :
                'padding-left:0px;padding-top:0px;padding-bottom:0px;padding-right:0px;'
            }
            //WindowPreset.Name === 'Default' ? '100px'
        },
        ActiveGroup(){
            return this.$store.state.ActiveGroup
        },
              
        RouteObj(){
            return this.$route
        },
        MiniView(){
            return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
        },
        StyleItems(){
            return [
                // /GalAssetsComponent
                {
                Name: 'Child Elements',
                compname: 'SectionTypeAddChildComponent',
                Children: ['Data Single Related','blank','Data Single Cabinet','Data Single Standard'],
                Conditions: [],
                Icon: 'mdi-application-settings'
                },
                {
                Name: 'Basic Config',
                compname: 'BasicContentConfigComponent',
                Children: ['RSS Feed','Store Product Single','Card Link','Counter Single','Survey Form','Web Form','FAQ','IFRAME','Info Sheet','Google My Maps','Table Embed','Counter Single','Info Card','Timeline Item'],
                Conditions: [],
                Icon: 'mdi-eye-settings'
                },
                {
                Name: 'Basic Data View Types',
                compname: 'BasicDataViewTypesConfigComponent',
                Children: ['Data Single Document Register','Data Single Gallery','Wiki Collection',
                'Data Single Fields','Data Single Activities','Data Single Related Data','Data Single SubCollection'],
                Conditions: [],
                Icon: 'mdi-database',
                GlobalQualifier: 'WikiType'
                },
                {
                Name: 'Basic Data View Title',
                compname: 'BasicDataViewTitleConfigComponent',
                Children: ['Data Single Document Register','Data Single Gallery','Wiki Collection','Data Single Standard',
                'Data Single Fields','Data Single Activities','Data Single Related Data','Data Single SubCollection'],
                Conditions: [],
                Icon: 'mdi-format-title'
                },
                {
                Name: 'Items Config',
                compname: 'ItemsComponent',
                Children: ['HTML Table','Timeline'],
                Conditions: [],
                Icon: 'mdi-view-list'
                },
                 {
                Name: 'Testimonials',
                compname: 'TestimonialsComponent',
                Children: ['Testimonials'],
                Conditions: [],
                Icon: 'mdi-account-voice'
                },
                {
                Name: 'Title',
                ContentElementID: 'Title',
                compname: 'TitleConfiguringComponent',
                Children: ['HTML Box','Image','Title','Gallery','FAQ','Wiki Collection','HTML Table','Description List','Info Card','Web Form',
                'Card Block Single','Card Row Single','Counter Single','Store Product Single','Parallax','Card Row',
                'Testimonials','Site Articles','Site Blogs','Site Meetups','Notice Board','Site Events','Social Site Posts','Social Posts','Card Link',
                'Business Members','Table Embed','RSS Feed','Store Products','Counter','Card Blocks','Documents Table','Carousel','Info Sheet',
                'Survey Form','Google My Maps','IFRAME'],
                Conditions: [{
                    Child: 'Image',
                    Condition: 'HasTextBox',
                    ConditionType: 'Prop'
                }],
                DisqualifyingProp: 'ContentFromField',
                Icon: 'mdi-format-title'
                },
                {
                Name: 'Write Up',
                compname: 'WriteupComponent',                
                ContentElementID: 'Description',
                Children: ['HTML Box','Gallery','Info Sheet','Card Block Single','Card Row Single','Card Row','Store Product Single'],
                Conditions: [],
                DisqualifyingProp: 'ContentFromField',
                Icon: 'mdi-pencil'
                },
                 
                {
                Name: 'Image',
                compname: 'ImageConfiguringComponent',                
                ContentElementID: 'IMG',
                Children: ['HTML Box','HTML Table','Gallery','Card Block Single','Card Row Single','Card Row','Store Product Single','Image','Parallax'],
                Conditions: [
                    {
                    Child: 'HTML Table',
                    Condition: 'HasImage',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'HTML Box',
                    Condition: 'HasImage',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'Gallery',
                    Condition: 'HasImage',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'Card Block Single',
                    Condition: 'HasImage',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'Card Row Single',
                    Condition: 'HasImage',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'Card Row',
                    Condition: 'HasImage',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'Store Product Single',
                    Condition: 'HasImage',
                    ConditionType: 'Prop'
                    }
                ],
                Icon: 'mdi-file-image'
                },
                
               
                
                {
                Name: 'Clipping Config',
                compname: 'ClippingConfigurationComponent',
                Children: ['Parallax','Image','Clipped Tab'],
                Conditions: [],
                Icon: 'mdi-drawing'
                },
                
                {
                Name: 'Data Calls',
                compname: 'DataTableCallsComponent',
                Children: ['Store Products','Counter Single'],
                Conditions: [],
                Icon: 'mdi-database'
                },
                {
                Name: 'List Config',
                compname: 'DescriptionListConfigComponent',
                Children: ['Description List'],
                Conditions: [],
                Icon: 'mdi-format-list-text'
                },
             
                {
                Name: 'Social Feed Config',
                compname: 'SocialConfigFeedComponent',
                Children: ['Site Articles','Site Blogs','Site Meetups','Site Events','Site Groups'],
                Conditions: [],
                Icon: 'mdi-google-circles-communities'
                },
                 {
                Name: 'Box Styling',
                compname: 'BoxStylingComponent',
                Children: ['HTML Box','Image','Title','Gallery','FAQ','Wiki Collection','HTML Table','Description List','Info Card','Web Form',
                'Clipped Tab','Card Block Single','Card Row Single','Timeline Item','Counter Single','Store Product Single'],
                Conditions: [
                    {
                    Child: 'Image',
                    Condition: 'HasTextBox',
                    ConditionType: 'Prop'
                    }
                ],
                Icon: 'mdi-border-style'
                },
                {
                Name: 'Action Button',
                compname: 'ActionButtonConfiguringComponent',
                Children: ['HTML Box','Image','Card Row Single'],
                Conditions: [
                    {
                    Child: 'HTML Box',
                    Condition: 'HasActionButton',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'Image',
                    Condition: 'HasActionButton',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'Card Row Single',
                    Condition: 'HasActionButton',
                    ConditionType: 'Prop'
                    },
                ],
                Icon: 'mdi-gesture-tap-button'
                },
                {
                Name: 'Box Wrapping',
                compname: 'BoxWrappingComponent',
                Children: ['Image'],
                Conditions: [
                    {
                    Child: 'Image',
                    Condition: 'HasTextBox',
                    ConditionType: 'Prop'
                    },
                ],
                Icon: 'mdi-format-align-center'
                },
                {
                Name: 'Advanced',
                compname: 'AdvancedOptionsComponent',
                Children: ['HTML Box','Image','Title','Gallery','FAQ','Wiki Collection','HTML Table','Description List','Info Card','Web Form',
                'Clipped Tab','Card Block Single','Card Row Single','Timeline Item','Counter Single','Store Product Single','Parallax','Card Row',
                'Testimonials','Site Articles','Site Blogs','Site Meetups','Notice Board','Site Events','Social Site Posts','Social Posts','Card Link',
                'Business Members','Table Embed','RSS Feed','Store Products','Counter','Card Blocks','Documents Table','Carousel','Info Sheet',
                'Survey Form','Google My Maps','IFRAME'],
                Conditions: [],
                Icon: 'mdi-cogs'
                },
                  {
                Name: 'Margin Styling',
                compname: 'MarginStylingComponent',
                Children: ['HTML Box','Image','Title','Gallery','FAQ','Wiki Collection','HTML Table','Description List','Info Card','Web Form',
                'Clipped Tab','Card Block Single','Card Row Single','Timeline Item','Counter Single','Store Product Single','Parallax','Card Row',
                'Testimonials','Site Articles','Site Blogs','Site Meetups','Notice Board','Site Events','Social Site Posts','Social Posts','Card Link',
                'Business Members','Table Embed','RSS Feed','Store Products','Counter','Card Blocks','Timeline','Documents Table','Carousel','Info Sheet',
                'Survey Form','Google My Maps','IFRAME','blank'],
                Conditions: [],
                Icon: 'mdi-table-row-plus-after'
                },
                {
                Name: 'Sizing',
                compname: 'ElementSizingOptionsComponent',
                Children: ['blank','HTML Box','Image','Title','Gallery','FAQ','Wiki Collection','HTML Table','Description List','Info Card','Web Form',
                'Clipped Tab','Card Block Single','Card Row Single','Timeline Item','Counter Single','Store Product Single','Parallax','Card Row',
                'Testimonials','Site Articles','Site Blogs','Site Meetups','Notice Board','Site Events','Social Site Posts','Social Posts','Card Link',
                'Business Members','Table Embed','RSS Feed','Store Products','Counter','Card Blocks','Timeline','Documents Table','Carousel','Info Sheet',
                'Survey Form','Google My Maps','IFRAME','Data Single Cabinet','Data Single Document Register','Data Single Gallery','Site Groups',
                'Data Single Standard','Data Single Fields','Data Single Activities','Data Single Related'],
                Conditions: [],
                Icon: 'mdi-arrow-expand-horizontal'
                },
                
                {
                Name: 'Assets',
                compname: 'GalAssetsComponent',
                Children: ['Gallery','Carousel'],
                Conditions: [],
                Icon: 'mdi-folder-multiple-image'
                },
               
                ]
        },
        
        LandingPageAvailable(){
      return this.System.Group_Landing_Page_Paid && this.GroupData && this.GroupData.MonetizationPackage && this.GroupData.MonetizationPackage.FeatureScope.includes('Landing Page') || !this.System.Group_Landing_Page_Paid
    },
        ComputedSystemEntities(){
            return this.$route.name === 'GroupPageEditor' || this.$route.name === 'GroupPageBuilder' ? this.GroupEntities.filter(entity => entity.groupid === this.$route.params.id) : this.SystemEntities
        },
        SocialHeaderGradient(){
            return this.System.SocialHeaderGradient ? this.System.SocialHeaderGradient : 'background: linear-gradient(to right, rgba(0,0,0,0.5), rgb(0,132,255, 1));'
        },
        SocialHeaderFont(){
            return this.System.SocialHeaderFont ? this.System.SocialHeaderFont : {hex: '#adff2f'}
        },
        SocialHeaderBorder(){
            return this.System.SocialHeaderBorder ? this.System.SocialHeaderBorder : {hex: '#adff2f'}
        },
        SocialPageHeaderStyle(){
            return 'color: '+this.SocialHeaderFont.hex+';border-top: 5px solid '+this.SocialHeaderBorder.hex+';'+this.SocialHeaderGradient
        },
        IsDefaultSocialPage(){
            return this.System.Social_Landing_Page === '/'+this.PageName.split(' ').join('-')
        },
        FinalPageStyling(){
            let obj = Object.assign({},this.PageStyling)
            if(this.$route.meta && this.$route.meta.RouteEventID === 1028 || this.$route.name === 'PageEditor'){
                obj.paddingBottom = '50px'
            }
            return this.DocLibEditor ? 'padding: 20px;' : obj
        },
        PageStyling(){
            if(this.PageBGAsset && this.PageBGGradient){
                return { backgroundImage: this.PageBGGradient.split('background: ')[1].split(';')[0]+`,url('`+this.PageBGAsset+`')`,backgroundSize: `cover` }
            }
            else if(this.PageBGAsset && !this.PageBGGradient){
                return { backgroundImage: `url('`+this.PageBGAsset+`')`,backgroundSize: `cover` }
            }
            else if(this.PageBGGradient){
                return { backgroundImage: this.PageBGGradient.split('background: ')[1].split(';')[0]}
            }
            else if(this.PageBGColor){
                return { backgroundColor: this.PageBGColor+ `!important`}
            }
            else{
                return ''
            }
        },	
        StoreSystemObj(){
            return this.$store.state.SystemObj
        },
        PageTabsReady(){
            return this.PageTabs && this.PageTabs.length > 0
        },
        AnitmatedElements(){
            let array = []
            if(!this.DataSingleBuilder){
            let animatedrows = this.ComputedPageTabs.filter(tab => {
                return tab.AnimationsActive
            })
            let animatedelements = this.ComputedPageTabs.map(tab => {
                return tab.Elements
            }).flat().filter(elmnt => {
                return elmnt.AnimationsActive
            })
            array = animatedrows.concat(animatedelements)
            }
            return array
        },
        ComputedPageTabs(){
            return this.SelectedElement && !this.RefreshingSingleElement ? [this.SelectedElement.ParentTab]
            : this.DataSingleBuilder ? this.PageTabs :     
            this.PageTabs.map((tab,tabindex) => {
                //let tab = Object.assign({},tabobj)
                //unsure we had issues with this before, now we had to turn it off because we had issues with it on...
                //my thinking is it should remain off but let's just see how it fairs now
                tab.ElementID = tabindex
                 let toppaths = this.SVGPaths.filter(path => {
                    return path.includes('Top')
                })
                let bottompaths = this.SVGPaths.filter(path => {
                    return path.includes('Bottom')
                })
                let svgtypes = ['<path','<polygon','<circle','<text','<rect','<g','<img ','<symbol','<elipse','<svg']
                if(tab.HasTopWaves){
                    tab.TopPathsHTML = ``
                    toppaths.map(pth => {
                        let svgtype = ''
                        svgtypes.map(type => {
                            if(tab[pth] && tab[pth].includes(type)){
                                svgtype = type
                            }
                        })
                        tab.TopPathsHTML = tab.TopPathsHTML+tab[pth].replace(svgtype,svgtype+' id="'+tabindex+'_'+pth+'"')
                    })
                    if(!tab.TopWave1Still){
                        tab.TopWave1Style = 'animation: move-forever4 '+tab.TopWave1Speed+' linear infinite;'
                    }
                    else{
                        tab.TopWave1Style = ''
                    }
                    if(!tab.TopWave2Still){
                        tab.TopWave2Style = 'animation: move-forever3 '+tab.TopWave2Speed+' linear infinite;'
                    }                    
                    else{
                        tab.TopWave2Style = ''
                    }
                    if(!tab.TopWave3Still){
                        tab.TopWave3Style = 'animation: move-forever2 '+tab.TopWave3Speed+' linear infinite;'
                    }
                    else{
                        tab.TopWave3Style = ''
                    }
                    if(!tab.TopWave4Still){
                        tab.TopWave4Style = 'animation: move-forever1 '+tab.TopWave4Speed+' linear infinite;'
                    }
                    else{
                        tab.TopWave4Style = ''
                    }
                }
                if(tab.HasBottomWaves){
                    tab.BottomPathsHTML = ``
                    bottompaths.map(pth => {
                        let svgtype = ''
                        svgtypes.map(type => {
                            if(tab[pth] && tab[pth].includes(type)){
                                svgtype = type
                            }
                        })
                        tab.BottomPathsHTML = tab.BottomPathsHTML+tab[pth].replace(svgtype,svgtype+' id="'+tabindex+'_'+pth+'"')
                    })
                    if(!tab.BottomWave1Still){
                        tab.BottomWave1Style = 'animation: move-forever4 '+tab.BottomWave1Speed+' linear infinite;'
                    }
                    else{
                        tab.BottomWave1Style = ''
                    }
                    if(!tab.BottomWave2Still){
                        tab.BottomWave2Style = 'animation: move-forever3 '+tab.BottomWave2Speed+' linear infinite;'
                    }                    
                    else{
                        tab.BottomWave2Style = ''
                    }
                    if(!tab.BottomWave3Still){
                        tab.BottomWave3Style = 'animation: move-forever2 '+tab.BottomWave3Speed+' linear infinite;'
                    }                    
                    else{
                        tab.BottomWave3Style = ''
                    }
                    if(!tab.BottomWave4Still){
                        tab.BottomWave4Style = 'animation: move-forever1 '+tab.BottomWave4Speed+' linear infinite;'
                    }                    
                    else{
                        tab.BottomWave4Style = ''
                    }
                }
                if(tab.Name === 'Card Row'){
                     if(typeof tab.TitleSize === 'undefined'){
                        tab.TitleSize = 2
                        }
                    if(tab.AlternateSlideIn){
                      tab.Elements.map((elmnt,elmntindex) => {
                         if(this.isOdd(elmntindex)){
                            elmnt.CustomClass = 'ScrollRevealLeftWithReverse'
                        }
                        else{
                            elmnt.CustomClass = 'ScrollRevealRightWithReverse'
                        }
                        return elmnt
                        })  
                    }
                    let props = ['IMGonTop','TiledIMG','FullIMG','IMGHeight','FlipCard','LabelGradient','LabelBGColor','ContainIMG','TitleSize']
                    tab.Elements = tab.Elements.map(elmnt => {
                        props.map(prp => {
                            if(typeof tab[prp] !== 'undefined'){
                                elmnt[prp] = tab[prp]
                            }
                        })
                        if(tab.ClearBoxes){
                            elmnt.Elevation = 0
                            elmnt.BoxTransparency = 'transparent'
                        }
                        return elmnt
                    })
                    
                }
                
                else if(tab.Elements && tab.Name !== 'Card Row'){
                    tab.Elements.map(elmnt => {
                        if(elmnt.Name === 'Site Groups'){
                            let primnavlist = Object.assign({},this.CategoricalNavlists.find(obj => obj.id === 'Group_Categories'))
                            elmnt.ListPrimaryField = Object.assign({},primnavlist.ListPrimaryField)
                            if(!elmnt.CatNavList){
                            elmnt.CatNavList = Object.assign({},primnavlist)  
                            }
                            if(elmnt.PrimaryCategoryFilter){                                
                                elmnt.CatNavList.ListPrimaryField = elmnt.PrimaryCategoryFilter
                                if(elmnt.SecondaryCategoryFilter){
                                    elmnt.CatNavList.ListPrimaryField = elmnt.SecondaryCategoryFilter
                                }
                            }
                            if(!elmnt.CatNavList.ListPrimaryField.id){
                                elmnt.CatNavList.ListPrimaryField.id = 'Group_Categories'
                            }
                            let navitem = elmnt.CatNavList.NavList.find(item => item.Type === 'TreeView')
                            if(navitem){
                                elmnt.CatNavList = this.GetCatNavListHierarchy(elmnt,navitem)
                            }                    
                        }
                        if(elmnt.SocialComponent && !elmnt.TypeCategories){
                            elmnt.TypeCategories = []                            
                        }
                        if(elmnt.Name === 'Site Groups'){
                                elmnt.CategorySystemProp = elmnt.CatNavList.id
                            }
                        return elmnt
                    })
                }
                if(tab.Elements){
                    tab.Elements = tab.Elements.map((elmnt,elmntindex) => {
                        elmnt.ElementID = tabindex+'_'+elmntindex
                        return elmnt
                    })
                }
                return tab
            })
        },
        SavingTabs(){
            return this.PageTabs.map((tab,tabindex) => {
                delete tab.Children
                delete tab.TopPathsHTML
                delete tab.BottomPathsHTML
                tab.ElementID = tabindex
                tab.Elements = tab.Elements.map((elmnt,elmntindex) => {
                    elmnt.ElementID = tab.ElementID+'_'+elmntindex
                    let fieldsprop = ''
                    delete elmnt.ListPrimaryField
                    if(elmnt.Fields){
                        fieldsprop = 'Fields'
                    }
                    else if(elmnt.FormFields){
                        fieldsprop = 'FormFields'
                    }
                    if(fieldsprop){
                        elmnt[fieldsprop] = elmnt[fieldsprop].map(field => {
                            delete field.CanEdit
                            delete field.CanDelete
                            delete field.Response
                            delete field.Array
                            return field
                        })
                    }
                    delete elmnt.CanEdit
                    delete elmnt.CanDelete
                    return elmnt
                })
                delete tab.CanEdit
                delete tab.CanDelete
                return tab
            })
        },
        RAConfigDB(){
            if(this.DataSingleBuilder || this.TableRecordView){
                return this.RADB.collection('systems').doc(process.env.VUE_APP_RA_SYSTEM_ID).collection('entities').doc(this.CurrentEntity.id)
            }
            else if(this.$route.meta && this.$route.meta.SubColEntryViewer){
                return ''
            }            
        },
        NeedsRASync(){
            if(!this.SystemisRA){
              return this.DataSingleBuilder || this.$route.meta && this.$route.meta.SubColEntryViewer || this.TableRecordView
            }            
        },
        DataSingleBuilder(){
            return this.$route.meta && this.$route.meta.DataSingleBuilder
        },
        PageTabsPropName(){
            if(this.DataSingleBuilder || this.$route.meta && this.$route.meta.SubColEntryViewer || this.TableRecordView){
                return 'SingleBuildTabs'
            }
            else if(this.$route.meta && this.$route.meta.ClassifiedListingBuilder){
                return 'ClassifiedTabs'
            }
            else if(this.$route.meta && this.$route.meta.WikiListingBuilder){
                return 'WikiTabs'
            }
            else{
                return 'PageTabs'
            }
        //return this.$route.meta && this.$route.meta.DataSingleBuilder || this.$route.meta && this.$route.meta.SubColEntryViewer? 'SingleBuildTabs' : 'PageTabs'
    },							
        								
        StoreProducts(){	
            //Loop through entities that are "Haswiki && IsStoreProduct"
            //This could actually be done from router mind you, even if router items are pushed on app load...								
            let ModelsArray = this.ModelsWikiArray.map(model => {									
                let storeobj = {									
                recordid: model.id,									
                IsDataRecord: true,									
                Center: 'justify-center',									
                CenteredHeader: true,									
                Name: 'Store Product Single',									
                									
                show: false,									
                HasBGIMG: true,									
                BGIMGisIMG: true,									
                ShowsPrice: true,									
                SubHeaderFontFamily: 'Roboto',									
                SubHeaderFontSize: 18,									
                SubHeaderColor: {									
                    hex: '#FF0000FF'									
                },									
                HeaderFontFamily: 'Roboto',									
                HeaderFontSize: 14,									
                HeaderColor: { "alpha": 1, "hex": "#162E4D", "hexa": "#162E4DFF", "hsla": { "h": 213.8181818181818, "s": 0.5555555555555557, "l": 0.1941176470588235, "a": 1 }, "hsva": { "h": 213.8181818181818, "s": 0.7142857142857143, "v": 0.30196078431372547, "a": 1 }, "hue": 213.8181818181818, "rgba": { "r": 22, "g": 46, "b": 77, "a": 1 } },									
                FontSize: 10,									
                FontColor: { "alpha": 1, "hex": "#162E4D", "hexa": "#162E4DFF", "hsla": { "h": 213.8181818181818, "s": 0.5555555555555557, "l": 0.1941176470588235, "a": 1 }, "hsva": { "h": 213.8181818181818, "s": 0.7142857142857143, "v": 0.30196078431372547, "a": 1 }, "hue": 213.8181818181818, "rgba": { "r": 22, "g": 46, "b": 77, "a": 1 } },									
                HasActionButton: true,									
                ActionButtonName: 'Add to Cart',									
                ActionBtnDark: true,									
                ActionButtonType: 'Add Cart Item',									
                ButonColor: {									
                    hex: '#FF0000FF'									
                },									
                ButtonAlignment: 'justify-end',									
                Title: model.Model_Number,									
                Description: `<div style="text-align: center;">`+model.About+`</div>`,									
                									
                FlexXLRG:3,									
                FlexLarge: 3,									
                FlexMedium: 3,									
                FlexSmall: 4,									
                FlexXSmall: 4,									
                Cols: 3,									
                Justify: 'justify-center',									
                RowColor: '#00ffff',									
                ShowComponents: true,									
                Icon: 'mdi-cards',									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                BGColor: {									
                        hex: '#ffffff',	
                        hexa: '#ffffffff',									
                        rgba: {r: 255,g: 255,b: 255}									
                }									
                }									
                if(model.Sample_Photo){									
                    storeobj.HasImage = true									
                    storeobj.IMG = model.Sample_Photo									
                }									
                if(model.Price){									
                    storeobj.Price = model.Price									
                }									
                return storeobj									
									
            })									
            return ModelsArray									
        },									
        ItemName(){									
            if(this.EditedTab){									
                if(this.EditedTab.Name === 'Web Form'){									
                    return this.EditedTab.FormName									
                }									
                else{									
                    return this.EditedTab.Title									
                }									
               									
            }									
        },									
        								
        SystemAssetsPaginated(){									
            let displayrange = 10*this.SystemAssetsPage-10									
            return this.SystemAssets.slice(displayrange, displayrange+10)       									
        },									
        FinalGalleryObjects(){									
            let arr1 = JSON.parse(JSON.stringify(this.SystemAssets))									
            let arr2 = JSON.parse(JSON.stringify(this.GalleryObjects))									
            arr1.map(asset => {									
                asset.GalleryObject = false									
                return asset									
            })									
            arr2.map(asset => {									
                asset.GalleryObject = true									
                return asset									
            })									
            return arr1.concat(arr2)									
        },									
        									
        DefaultPageFont(){									
            return `font-family: "`+this.PageContentFont+`", sans-serif;`									
        },									
        									
        BannerImageSimple(){									
            if(this.BannerImage && this.BannerImage.Path){									
                return this.BannerImage.Path									
            }									
            else if(this.BannerImage){									
                return this.BannerImage									
            }									
        },									
        WikiRouteComponents(){									
            return this.SiteRouteComponents.filter(comp => {									
                return typeof comp.meta !== 'undefined' && comp.meta.type === 'Wiki Pages'									
            })									
        },									
      SimpleBannerComponents(){									
          return this.BannerComponents.map(comp => {									
              let obj = {									
                  Name: comp.name,									
                  path: comp.path,									
                  meta: comp.meta									
              }									
              return obj									
          })									
      },									
      SimpleBannerComponentsNames(){									
          return this.BannerComponents.map(comp => {									
              let obj = {									
                  Name: comp.name,									
                  path: comp.path,									
                  meta: comp.meta									
              }									
              return obj.Name									
          })									
      },		
      userIsAdmin () {
        return this.$store.state.IsAdmin
    },							
      userLoggedIn () {									
      return this.$store.getters.user									
    },	
    RevealClassMax(){
        return window.innerWidth/2
      },
    WindowHeight(){
        return window.innerHeight
      },								
    // WindowWidth(){
    //     return window.innerWidth
    // },
    // ResponsiveRatio(){
    //     return this.ResponsiveSize/this.WindowWidth
    // }						
      									
      									
      									
									
    },									
    created(){	
        
        //console.log(this.DataSingleTabs)
        if(this.DataSingleBuilder){
            this.$store.commit('setBuilderView',{Name: 'Website Builder'})
        }
        this.ScrolltoTop()
        // if(this.MiniView){
        //     this.TurnoffSiteDialog()
        // }	
        // else{
        //     this.TurnonSiteDialog()
        // }	
        
        if(this.SystemAssets && this.SystemAssets.length > 0){
            this.$store.commit('setSystemAssets',this.SystemAssets)
        }
        //console.log('this.WikiEntities',this.WikiEntities)						
      document.body.scrollTop = 0;									
      document.documentElement.scrollTop = 0;									
      setTimeout(() => {									
        }, 1000);			
        if(this.$route.name === 'GroupPageEditor' || this.$route.name === 'GroupPageBuilder'){
            this.GetGroupInformation()
        }
        else{
            this.FocusedViewToggle()
        }
      									
      this.CheckUser()
      let fieldtypes = ['Single Line Text','Multiple Lines Text','Common Field','Boolean','Option Set','Radio Group',
      'Date','AutoNumber Field','Number Field','Single File Upload','Rollup Calculation','Calculated Field',
      'Map Location','Shared Doc Link','Lookup','Parent Field','Route Path','Social Lookup','Custom Object']
      this.FieldTypes = fieldtypes.map(type => {
          let typeobj = {
              Type: type,
              Name: '',
              DisplayName: '',              
          }
          if(type === 'Lookup'){
               //typeobj.Description = 'Here is a Description about Lookup Fields'
          }
          else if(type === 'Parent Field'){
              typeobj.ReadOnly = true
          }
          else if(type === 'Option Set'){
              typeobj.Options = []
              typeobj.lastassignedinteger = 1000000
          }
          return typeobj
      }).sort((a, b) => {			
                // console.log('sorting again')			
                // console.log(a.Value)			
                var key1 = b.Type			
                var key2 = a.Type			

                if (key1 > key2) {			
                    return -1;			
                } else if (key1 == key2) {			
                    return 0;			
                } else {			
                    return 1;			
                }			
        })							
									
    },									
    									
    methods: {
         RunWebAnimations(){
            let Elements = this.AnitmatedElements            //console.log(Elements)
            Elements.map((elmnt,elmntindex) => {
                let propoptions = ['Tab','Title','Description','IMG']
                propoptions.map(opt => {   
                     let e = document.getElementById(elmnt.ElementID+'_'+opt)
                    if(elmnt.AnimationKeyframesObject[opt] && elmnt.Animations[opt] && e){
                        let elmntkeyframes = []
                        let eanimobj = Object.assign({},elmnt.AnimationKeyframesObject[opt])
                        let animprops = {}
                        let cssprop = elmnt.AnimationProperties[opt]
                        // console.log(cssprop)
                        if(typeof cssprop.duration !== 'undefined'){
                            animprops.duration = cssprop.duration
                        }
                        if(typeof cssprop.fill !== 'undefined' && cssprop.fill !== null){
                            animprops.fill = cssprop.fill
                        }
                        if(typeof cssprop.easing !== 'undefined' && cssprop.easing !== null){
                            animprops.easing = cssprop.easing
                        }
                         if(typeof cssprop.iterations !== 'undefined'){
                            animprops.iterations = cssprop.iterations
                        }
                        Object.keys(eanimobj).forEach(function(prop,index) {
                            if(prop.includes('%')){
                                    //okay the point being now we must dissect this
                                    let perc = (Number(prop.split('%').join('')))/100
                                    if(!elmntkeyframes[index]){
                                        elmntkeyframes[index] = {}
                                    }
                                    elmntkeyframes[index].iterationStart = perc
                                }
                                for(var prp in eanimobj[prop]) {	                                    
                                    if (eanimobj[prop].hasOwnProperty(prp)) {
                                        if(!elmntkeyframes[index]){
                                            elmntkeyframes[index] = {}
                                        }
                                        elmntkeyframes[index][prp] = eanimobj[prop][prp]
                                    }
                                }
                        });
                        elmntkeyframes = elmntkeyframes.sort(function(a, b){return a.iterationStart - b.iterationStart})
                        let animobj = new KeyframeEffect(
                        e, // element to animate
                        elmntkeyframes,
                        animprops // keyframe options
                        );
                        let newanim = new Animation(animobj, document.timeline)
                        newanim.play()     
                    }
                    
                        })
            })
        },
        ResponsiveElmntFlex(elmnt,tab){
            //  elmnt.Alignment ? 
            //                 'position: relative;padding-top:'+elmnt.MarginTop+'px;padding-bottom:'+elmnt.MarginBottom+'px;padding-left:'+elmnt.MarginLeft+'px;padding-right:'+elmnt.MarginRight+'px;align-self:'+elmnt.Alignment : 
            //                 'position: relative;padding-top:'+elmnt.MarginTop+'px;padding-bottom:'+elmnt.MarginBottom+'px;padding-left:'+elmnt.MarginLeft+'px;padding-right:'+elmnt.MarginRight+'px;align-self:'+tab.Alignment
            let style = ''
            if(elmnt.Alignment){
                style = 'position: relative;padding-top:'+elmnt.MarginTop+'px;padding-bottom:'+elmnt.MarginBottom+'px;padding-left:'+elmnt.MarginLeft+'px;padding-right:'+elmnt.MarginRight+'px;align-self:'+elmnt.Alignment
            }
            else{
                style = 'position: relative;padding-top:'+elmnt.MarginTop+'px;padding-bottom:'+elmnt.MarginBottom+'px;padding-left:'+elmnt.MarginLeft+'px;padding-right:'+elmnt.MarginRight+'px;align-self:'+tab.Alignment
            }
            style = style+this.ResponsiveTabFlex(elmnt,true)
            //console.log(style)
            return style
        },
        ResponsiveTabFlex(tab,forelmnt){
           let xs = 600
           let sm = 900
           let md = 1264
           let lg = 1904
           let ratio = 0
           let type = ''
           let width = this.ResponsiveSize.Width
           if(typeof width === 'string'){
            width = width.split('px')[0]
           }
           //console.log(width)
           if(width < xs){
            ratio = tab.FlexXSmall/12
            type = 'xs'
           }
           else if(width < sm){
            ratio = tab.FlexSmall/12
            type = 'sm'
           }
           else if(width < md){
            ratio = tab.FlexMedium/12
            type = 'md'
           }
           else if(width < lg){
            ratio = tab.FlexLarge/12
            type = 'lg'
           }
           else{
            ratio = tab.FlexXLRG/12
            type = 'xl'
           }
           ratio = ratio*100
           //console.log(forelmnt,ratio,type,`flex-grow: 0;flex-shrink: 0;flex-basis: `+ratio+`%;max-width: `+ratio+`%;`,tab)
           return `flex-grow: 0;flex-shrink: 0;flex-basis: `+ratio+`%;max-width: `+ratio+`%;`

        },
        TabWavesStyle(tab){
            let style = ``
            if(tab.WavesGradient){
               style = `clip-path: url(#svgPath);
                        background-size: cover;z-index:4 !important;padding: 0;position:absolute;width:100%;text-align:center;
                        `+tab.WavesGradient+`color:white;`
            }
            else{
                style = `clip-path: url(#svgPath);
                        background-size: cover;z-index:4 !important;padding: 0;position:absolute;width:100%;text-align:center;
                        background: linear-gradient(60deg, rgba(85,58,183,1) 0%, rgba(0,172,193,1) 100%);color:white;`
            }
            if(typeof tab.WaveHeight === 'number'){
                style = style+`height: `+tab.WaveHeight+`%;`
            }
            else{
                style = style+`height: 100%;`
            }
            return style
        },
        GetTabStyle(tab){
            let style = {}
            if(tab.RowBlendMode){
                    style.mixBlendMode = tab.RowBlendMode
                }
            if(tab.Name !== 'Card Row'){
                style.marginTop = tab.MarginTop+'px'
                style.marginBottom = tab.MarginBottom+'px'
                style.marginLeft = tab.MarginLeft+'px'
                style.marginRight = tab.MarginRight+'px'
            }
            if(tab.Floating){
                style.marginRight = 'absolute'
            }
             if(tab.BGIMG && tab.HasBGIMG){
                
                if(tab.HasBGGradient && tab.BGGradient){
                    style.backgroundImage = tab.BGGradient.split('background: ')[1].split(';')[0]+`,url('`+tab.BGIMG+`')`
                    style.backgroundSize = 'cover'
                }
                else{
                    style.backgroundImage = `url('`+tab.BGIMG+`')`
                    style.backgroundSize = 'cover'
                }    
                 if(tab.BGIMGFixed){
                    style.backgroundAttachment = 'fixed'
                    if(this.$vuetify.breakpoint.xs){
                      style.backgroundSize = 'auto'  
                    }                    
                }   
                if(tab.BGIMGCentered){
                    style.backgroundPosition = 'center'
                }             
            }
                return style
        },
        ReceiveAddedAssets(assets){
            console.log(assets,this.ImageRecord,this.ImageField)    
            this.ImageRecord[this.ImageField.Name] = assets[0]
            this.ImageRecord = ''
            this.ImageField = ''
        },
        onPhotoFileselected(field,file,files,Record,tab){
            let fileList = files
            this.ImageRecord = Record
            this.ImageField = field
            console.log(field,file,files,Record,tab)
            this.$store.commit('setUploadFilesList',fileList)
            let filestorageref = ''
            if(this.$route.name === 'PageEditor'){
                filestorageref = 'Pages/'+this.$route.params.id+'/'+new Date()+'/'
            }            
            //let dbrecordref = this.TableCollectionRef
            this.$store.commit('setUploadFileStorageRef',filestorageref)
            this.$store.commit('setUploadFilesDBStorageRef','')
            console.log(file,field,Record)
        },
        AddNewTimelineItem(tab){
            let even = {									
                    HasIcon: true,									
                    Name: 'Timeline Item',									
                    Title: 'Lorem Ipsum Dolor',									
                    Description: 'Lorem ipsum dolor sit amet, no nam oblique veritus.',									
                    HasActionButton: true,									
                    ActionButtonName: 'Button',									
                    TitleColor: 'white',									
                    color: 'purple darken-1',									
                    icon: 'mdi-book-variant',									
                    }
                    let odd = {									
                    HasIcon: true,									
                    Name: 'Timeline Item',									
                    Title: 'Lorem Ipsum Dolor',									
                    Description: 'Lorem ipsum dolor sit amet, no nam oblique veritus.',									
                    HasActionButton: true,									
                    ActionButtonName: 'Button',									
                    TitleColor: 'white',									
                    color: 'red lighten-2',									
                    icon: 'mdi-star',									
                    }
                    let length = tab.Items.length
                    if(length%2 != 0){
                        tab.Items.push(even)
                    }
                    else{
                        tab.Items.push(odd)
                    }
        },
        FilteredRAStorePagePresets(elmnt,IsRow){
            //console.log(elmnt,IsRow)
            let defaultblock = this.ContentBlocks.find(obj => obj.Name === elmnt.Name)
            if(IsRow && elmnt.Name !== 'Card Row' && elmnt.Name !== 'Card Blocks'){
                //console.log(elmnt,IsRow,defaultblock)
                defaultblock = JSON.parse(JSON.stringify(elmnt))
            }
            return this.RAStorePagePresets.filter(item => {
                return IsRow ? item.Category === defaultblock.Category && item.Elements && item.Elements.length > 1 && defaultblock.Name === 'blank' ||
                item.Category === defaultblock.Category && defaultblock.SectionType && defaultblock.Name !== 'blank' && item.Name === elmnt.Name : 
                item.Category === defaultblock.Category && item.Elements && item.Elements.length === 1 ||
                item.Category === defaultblock.Category && !item.Elements
            }).map(preset => {
                let presetblock = JSON.parse(JSON.stringify(preset))
                //console.log(presetblock)
                if(IsRow){
                  for(var prop in presetblock) {	
                        if (presetblock.hasOwnProperty(prop) && defaultblock.StaticVariables && defaultblock.StaticVariables.includes(prop)) {	
                            presetblock[prop] = elmnt[prop]
                        }
                    }  
                }
                
                return presetblock
            })
            
        },
        UpdateTabPreset(tab,item,tabindex){
            let defaultblock = this.ContentBlocks.find(obj => obj.Name === tab.Name)
            let oldblock = JSON.parse(JSON.stringify(tab))
            let presetblock = JSON.parse(JSON.stringify(item))
            //console.log(tab,defaultblock.StaticVariables,tab[defaultblock.StaticVariables[0]])
            for(var prop in presetblock) {			
                if (presetblock.hasOwnProperty(prop) && !defaultblock.StaticVariables.includes(prop)) {	
                    oldblock[prop] = presetblock[prop]
                }
            } 
            oldblock.Preset_Name = item.Preset_Name
            this.PageTabs.splice(tabindex, 1, oldblock);
            //this.PageTabs[tabindex] = oldblock
            // this.PageTabs[tabindex].ShowComponents = false
            // setTimeout(() => {
            //     this.PageTabs[tabindex].ShowComponents = true
            // }, 50);
            //console.log(this.ComputedPageTabs)
        },
        UpdatePreset(elmnt,item,tabindex,elmntindex){
            //console.log(presetname)
            //let item = this.FilteredRAStorePagePresets(elmnt).find(obj => obj.Preset_Name === presetname)
            let defaultblock = this.ContentBlocks.find(obj => obj.Name === elmnt.Name)
            let oldblock = JSON.parse(JSON.stringify(elmnt))
            let presetblock = JSON.parse(JSON.stringify(item))
            // if(presetblock.SectionType && presetblock.Name !== 'blank' || 
            //     presetblock.SectionType && presetblock.Name === 'blank' && presetblock.Category === 'Custom' ){
            //     presetblock = presetblock.Elements.find(obj => obj.Name === elmnt.Name)
            // }
            if(presetblock.SectionType && presetblock.Elements.length > 1){
                presetblock = presetblock.Elements.find(obj => obj.Name === elmnt.Name)
            }
            else if(presetblock.SectionType && presetblock.Elements.length === 1){
                presetblock = presetblock.Elements[0]
            }
            for(var prop in presetblock) {			
                if (presetblock.hasOwnProperty(prop) && !defaultblock.StaticVariables.includes(prop)) {	
                    oldblock[prop] = presetblock[prop]
                }
            }  
            oldblock.Preset_Name = item.Preset_Name
            let sizeprops= [
                        'FlexXLRG',
                        'FlexLarge',
                        'FlexMedium',
                        'FlexSmall',
                        'FlexXSmall'
                    ]
                    sizeprops.map(val => {
                        if(oldblock[val]){
                            oldblock[val] = elmnt[val]
                        }
                })
            this.PageTabs[tabindex].Elements[elmntindex] = JSON.parse(JSON.stringify(oldblock))
            this.PageTabs[tabindex].ShowComponents = false
            setTimeout(() => {
                this.PageTabs[tabindex].ShowComponents = true
            }, 50);
             console.log(elmnt,oldblock,presetblock,item)
        },
        ElmntPresets(elmnt,IsRow){
             let defaultblock = this.ContentBlocks.find(obj => obj.Name === elmnt.Name)
            return this.RAStorePagePresets.filter(preset => {
                console.log(preset,defaultblock)
                return preset.Category === defaultblock.Category
            })
        },
        PreparedPreviewTabElement(elmnt,item){
            let defaultblock = this.ContentBlocks.find(obj => obj.Name === elmnt.Name)
            let previewblock = JSON.parse(JSON.stringify(elmnt))
            let presettab = JSON.parse(JSON.stringify(item))
            let presetblock = ''
            if(defaultblock.SectionType){
                presetblock = JSON.parse(JSON.stringify(item))
            }  
            else{
                let match = item.Elements.find(obj => obj.Name === elmnt.Name)
                //console.log(item.Preset_Name,match)
                if(match){
                presetblock = JSON.parse(JSON.stringify(match))
                }
            } 
            console.log(presetblock,previewblock)   
            if(presetblock){
             for(var prop in presetblock) {			
                if (presetblock.hasOwnProperty(prop) && !defaultblock.StaticVariables.includes(prop)) {	
                    previewblock[prop] = presetblock[prop]
                }
            }   
            }
            	      
            if(!defaultblock.SectionType){
                let match = presettab.Elements.find(obj => obj.Name === previewblock.Name)
                if(match){
                    let index = presettab.Elements.indexOf(match)
                    presettab.Elements[index] = previewblock
                    previewblock = presettab
                }                
            }
            //console.log(defaultblock,previewblock,presetblock)
            return previewblock
        },
        PreparedPreviewElement(elmnt,item){
            let defaultblock = this.ContentBlocks.find(obj => obj.Name === elmnt.Name)
            let previewblock = JSON.parse(JSON.stringify(elmnt))
            let presettab = JSON.parse(JSON.stringify(item))
            let presetblock = ''
            //console.log(defaultblock,item)
            if(defaultblock.SectionType || !defaultblock.SectionType && defaultblock.StaticVariables.length === 0 && item.Name !== elmnt.Name){
                presetblock = JSON.parse(JSON.stringify(item))
            }  
            else{
                let match = item.Elements.find(obj => obj.Name === elmnt.Name)
                //console.log(item.Preset_Name,match)
                if(match){
                presetblock = JSON.parse(JSON.stringify(match))
                }
            }    
            if(presetblock){
             for(var prop in presetblock) {			
                if (presetblock.hasOwnProperty(prop) && !defaultblock.StaticVariables.includes(prop)) {	
                    previewblock[prop] = presetblock[prop]
                }
            }   
            }
            	      
            if(!defaultblock.SectionType){
                let match = presettab.Elements.find(obj => obj.Name === previewblock.Name)
                if(match){
                    let index = presettab.Elements.indexOf(match)
                    presettab.Elements[index] = previewblock
                    previewblock = presettab
                }                
            }
            //console.log(defaultblock,previewblock,presetblock)
            return previewblock
        },
        ActivateAddContentDialog(tab,i,iselmnt){
            if(iselmnt){
                this.ToElement = iselmnt
                this.EditedTab = tab
            }
            else{
                this.ToElement = false
                this.EditedTab = ''
            }
            this.$store.commit('SetSocialItemInteractMethodProp','Add Content') 
            this.$store.commit('SetSocialItemInteractMethod','PrepareSelectedMain')
            this.BelowTabIndex = i
            this.BelowTab = tab
            
        },
        DownloadallBlockTypes(){
            console.log(this.RenderedContentBlocks)
            console.log(this.ContentBlocks)
            let headers = []
            let exportdata = this.ContentBlocks
            exportdata.map(block => {
                for(var prop in block) {			
                    if (block.hasOwnProperty(prop)) {			
                      let onheaders = headers.find(obj => obj === prop)
                      if(!onheaders){
                        headers.push(prop)
                      }
                    }
                }
            })
            console.log(headers,exportdata)
            setTimeout(() => {
                const headerrows = [headers]
            const datarows = exportdata.map(row => {
                console.log(row)
                return headers.map(header => {
                    return row[header] 
                })
            })
            setTimeout(() => {
                console.log(datarows)
                const rows = headerrows.concat(datarows)        
                console.log(rows)
        let csvContent = "data:text/csv;charset=utf-8," 
            + rows.map(e => e.join("|")).join("\n");
            console.log(csvContent)
            setTimeout(() => {
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "ContentBlocks.csv");
            document.body.appendChild(link); // Required for FF
            link.click();
            }, 2000);
            }, 2000);
            }, 2000);
        
            
        },
        AddContentDialog(EditedTab){
            if(EditedTab.ContentDialogType){
                let contentbox = this.ContentBlocks.find(obj => obj.Name === EditedTab.ContentDialogType.Name)
                EditedTab.ContentDialogBox = Object.assign({},contentbox)
                EditedTab.ContentDialogBox.Elevation = 0
                EditedTab.ContentDialogBox.Tile = true
                EditedTab.ContentDialogBox.Flat = true
                EditedTab.ContentDialogBox.IsContentDialog = true
            }
        },
        ScrolltoTop(){
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        },
        ActivateLibraryPage(item){
            let newpath = '/DocumentationLibraryEditor/'+this.$route.params.id+'/'+item.Path.split(' ').join('_').split('-').join('_')
            if(this.$route.path !== newpath){
             this.$router.push(newpath)   
            }            
        },
        ActivateSelectedElement(item){      
        console.log('ActivateSelectedElement',item)
        this.RefreshingSingleElement = true
        if(item === this.SelectedElement && this.$route.name !== 'SystemConfig'){
            this.SelectedElement = ''
        }
        else{
            this.SelectedElement = item
        }
        setTimeout(() => {
            this.RefreshingSingleElement = false
        }, 100);
        //console.log(item,this.SelectedElement,this.RefreshingSingleElement)
        },
        UpdatePageContentFont(value){
            this.PageContentFont = value
        }, 
        UpdatePageHeadersFont(value){
            this.PageHeadersFont = value
        },
        UpdatePageHeadersFontSize(value){
            this.PageHeadersFontSize = value
        },
        UpdatePageBGColor(value){
            this.PageBGColor = value
        },
        ToggleSiteDialog(){
            this.$store.commit('setSiteDialog',!this.SiteDialog)
        },
        TurnoffSiteDialog(){
            this.$store.commit('setSiteDialog',false)
        },
        TurnonSiteDialog(){
            this.$store.commit('setSiteDialog',true)
        },
        
        AssignSocialItemInteractMethod(item,SecondProp){
        //console.log('AssignSocialItemInteractMethod',item,SecondProp)
        this.$store.commit('SetSocialItemInteractMethodProp','') 
        this.$store.commit('SetSocialItemInteractMethod','')
        if(SecondProp){
            this.$store.commit('SetSocialItemInteractMethodProp',SecondProp) 
            this.$store.commit('SetSocialItemInteractMethod',item)
        }
        else if(item){
            this.$store.commit('SetSocialItemInteractMethod',item)
        }
        },
        AssignRenderedContentBlocks(blocks){
            //console.log('sure we assign blocks',blocks)
            //THIS BECOMES STORE COMMIT
            this.RenderedContentBlocks = blocks
        },
        DeleteTabNew(tab,tabindex,IsElement,CustomBoxTabIndex,isrow,rowindex,ContentDialog){
            this.OpenDialog(tab,tabindex,IsElement,CustomBoxTabIndex,isrow,rowindex,ContentDialog)
            this.DeleteTab(true)
        },
        ActivateTabDialNew(btn,tab,tabindex,IsElement,CustomBoxTabIndex,isrow,rowindex,ContentDialog){
            this.SelectedActiveButton = btn
            this.OpenDialog(tab,tabindex,IsElement,CustomBoxTabIndex,isrow,rowindex,ContentDialog)
        },
        ActivateStyleButton(btn,tab){
            this.EditedTab = tab
            this.ActiveButtoncompname = btn.compname
            this.ActiveButtonName = btn.Name
            this.SelectedActiveButton = btn
            // this.MiniStyler = true
            this.TabDialog = true
        },
        TabhasChildren(tab){
            return this.TabStyleItems(tab).find(obj => obj.Name === 'Child Elements')
        },
        FilteredTabStyleItems(tab){
            return this.TabStyleItems(tab).filter(item => {
                return item.Name !== 'Child Elements'
            })
        },
        TabStyleItems(tab){
            // console.log('TabStyleItems',tab)
            if(tab && !tab.DataViewName){
                return this.StyleItems.filter(item => {return item.Children.includes(tab.Name) || item.GlobalQualifier && this[item.GlobalQualifier]}).filter(item => {
                    let conditionalchild = item.Conditions.find(cond => {return cond.Child === tab.Name})
               
                    return !conditionalchild && !item.DisqualifyingProp || !conditionalchild && item.DisqualifyingProp && !tab[item.DisqualifyingProp]
                    || conditionalchild && conditionalchild.ConditionType === 'Prop' && tab[conditionalchild.Condition] && !item.DisqualifyingProp || 
                    conditionalchild && conditionalchild.ConditionType === 'Prop' && tab[conditionalchild.Condition] && item.DisqualifyingProp && !tab[item.DisqualifyingProp] ||
                    conditionalchild && conditionalchild.ConditionType === 'Method' && this[conditionalchild.Condition](tab) && !item.DisqualifyingProp || 
                    conditionalchild && conditionalchild.ConditionType === 'Method' && this[conditionalchild.Condition](tab) && item.DisqualifyingProp && !tab[item.DisqualifyingProp]
                    || item.GlobalQualifier && this[item.GlobalQualifier]
                }).map((item,index) => {
                    item.Index = index
                    return item
                })
            }
            else if(tab && tab.DataViewName){
                return this.StyleItems.filter(item => {return item.Children.includes(tab.DataViewName)})
            }
            else{
                return []
            }
        },
        
        GetGroupInformation(){
            if(this.ActiveGroup){
                this.GroupData = this.ActiveGroup
                this.GetGroupAssets(db.collection('groups').doc(this.$route.params.id).collection('pageassets'))
            }
        },            
        GetCatNavListHierarchy(elmnt,navitem){
            let HierarchyField = elmnt.CatNavList.ListPrimaryField
            let array = JSON.parse(JSON.stringify(HierarchyField.Options))      
                navitem.TreeList = array
                .map(option => {
                    //console.log('option',option)
                let treeobj = {
                    name: option.Name,
                    // id: option.ID+'Record:'+option.LevelFieldName,
                    id: option.ID,
                    //EntityID: entity.id,
                    HierarchyFieldid: HierarchyField.id,
                    LevelFieldName: option.Level.FieldName,
                    Levelid: 1
                }
                if(option.AppendedFilters){
                    navitem.AppendedFilters = option.AppendedFilters
                }
                // if(treeobj.Level && treeobj.Level.id === 1){
                    if(option.Options){
                    treeobj.children = option.Options.map(secondoption => {
                        //console.log('secondoption',secondoption)
                        let secondtreeobj = {
                        name: secondoption.Name,
                        id: secondoption.ID,
                        //EntityID: entity.id,
                        HierarchyFieldid: HierarchyField.id,
                        LevelFieldName: secondoption.Level.FieldName,
                        Levelid: 2
                        }
                        if(secondoption.AppendedFilters){
                            secondtreeobj.AppendedFilters = secondoption.AppendedFilters
                        }
                        if(secondoption.Options){
                        secondtreeobj.children = secondoption.Options.map(thirdoption => {
                           // console.log('thirdoption',thirdoption)
                            let thirdtreeobj = {
                            name: thirdoption.Name,
                            id: thirdoption.ID,
                            //EntityID: entity.id,
                            HierarchyFieldid: HierarchyField.id,
                            LevelFieldName: thirdoption.Level.FieldName,
                            Levelid: 3
                            }
                            if(thirdoption.AppendedFilters){
                                thirdtreeobj.AppendedFilters = thirdoption.AppendedFilters
                            }
                            if(thirdoption.Options){
                            thirdtreeobj.children = thirdoption.Options.map(fourthoption => {
                                let fourthtreeobj = {
                                name: fourthoption.Name,
                                id: fourthoption.ID,
                                //EntityID: entity.id,
                                HierarchyFieldid: HierarchyField.id,
                                LevelFieldName: fourthoption.Level.FieldName,
                                Levelid: 4
                                }
                                return fourthtreeobj
                            })
                            }
                            return thirdtreeobj
                        })
                        }
                        return secondtreeobj
                    })
                    }
                // }
                return treeobj
                })
                return elmnt.CatNavList
        },
        RemoveFieldfromTab(field,fieldindex,EditedTab){
            confirm('This will remove the field from the Tab only. Are you sure?') && this.ProceedRemoveFieldfromTab(field,fieldindex,EditedTab)
        },
        ProceedRemoveFieldfromTab(field,fieldindex,EditedTab){
            EditedTab.Fields.splice(fieldindex,1)
            field.UsedonForm = false
            this.EntityCollectionRef.collection('AllFields').doc(field.id).update({
                    UsedonForm: false
                })
        },
        dataformfielddragstart(field, fieldindex){
            this.formfielddragging = field
            this.formfielddraggingindex = fieldindex
        },
        dataformfielddragfinish(EditedTab,formfieldindex){
            console.log(EditedTab,formfieldindex)
            EditedTab.Fields.splice(formfieldindex,0,EditedTab.Fields.splice(this.formfielddraggingindex,1)[0]) 
            EditedTab.Fields.map((field,fieldindex) => {
                field.WebFormIndex = fieldindex
            })           
            setTimeout(() => {
                    this.formfielddraggingindex = -1
                    this.formfielddragging = ''
            }, 50);          
        },
        formfielddragstart(field, fieldindex){
            this.formfielddragging = field
            this.formfielddraggingindex = fieldindex
        },
        formfielddragfinish(EditedTab,formfieldindex){
            console.log(EditedTab,formfieldindex)
            EditedTab.FormFields.splice(formfieldindex,0,EditedTab.FormFields.splice(this.formfielddraggingindex,1)[0]) 
            EditedTab.FormFields.map((field,fieldindex) => {
                field.WebFormIndex = fieldindex
            })           
            setTimeout(() => {
                    this.formfielddraggingindex = -1
                    this.formfielddragging = ''
            }, 50);          
        },
        UpdatePageBGAsset(){
            this.PageBGAsset = this.SelectedImage.fileurl
            console.log(this.PageBGAsset,this.SelectedImage)
        },
        UpdatePageBGGradient(PageBGGradient){
            this.PageBGGradient = PageBGGradient
        },
        isOdd(num) {
            return num % 2;
        },
        PrepAnimations(){
            
        setTimeout(() => {
          this.AnimationScrollRevealSections('ScrollRevealLeftWithReverse','scrollinfromleft',this.WindowHeight,'left','animscrollinfromleft',true,'scrollinfromleftreverse')
          this.AnimationScrollRevealSections('ScrollRevealRightWithReverse','scrollinfromright',this.WindowHeight,'right','animscrollinfromright',true,'scrollinfromrightreverse')
          this.AnimationScrollRevealSections('ScrollRevealLeft','scrollinfromleft',this.WindowHeight,'left','animscrollinfromleft')
          this.AnimationScrollRevealSections('ScrollRevealRight','scrollinfromright',this.WindowHeight,'right','animscrollinfromright')
          this.AnimationScrollRevealSectionsStick('ScrollRevealLeftStick','left',this.RevealClassMax,this.WindowHeight,200)
          this.AnimationScrollRevealSectionsStick('ScrollRevealRightStick','right',this.RevealClassMax,this.WindowHeight,200)
          var docStyle = document.documentElement.style;
          docStyle.setProperty('--WindowWidth', window.innerWidth);
        }, 5);
      },
      AnimationScrollRevealSectionsStick(clssname,cssprop,maxvalue,heighttresh,finalheightpos){
        var Sections = document.getElementsByClassName(clssname);
        if(Sections && Sections.length > 0){
        Sections.forEach((e, i) => {        
            e.style[cssprop] = -this.RevealClassMax+'px'
            e.style.visibility = 'hidden'
        })
        document.addEventListener('scroll', function () {
          Sections.forEach((e, i) => {           
          var top = (e.getBoundingClientRect().top);
          if(top < heighttresh && top >= finalheightpos){
            let proppos = ((finalheightpos-top)/finalheightpos*maxvalue)
            e.style[cssprop] = proppos+'px'
          }          
          });
        })
        }
      },
      AnimationScrollRevealSections(clssname,newclssname,heighttresh,cssprop,animation,WithReverse,revclssname){
        var Sections = document.getElementsByClassName(clssname);
        //console.log(Sections)
        if(Sections && Sections.length > 0){
        Sections.forEach((e, i) => {        
            e.style[cssprop] = -this.RevealClassMax+'px'
            e.style.visibility = 'hidden'
        })
        document.addEventListener('scroll', function () {
          Sections.forEach((e, i) => {
          let name = e.style['animation-name']
          let direction = e.style['animation-direction']
          var top = (e.getBoundingClientRect().top);
          //console.log(top,e)
          let showheight = (heighttresh*0.7)
          let hideheight = heighttresh*2
          if (top < showheight) {
            //console.log(top,e)
            e.classList.remove(revclssname)
            if(e.style.visibility === 'hidden'){
             e.style.visibility = 'visible' 
            }            
          if(top !== 0){
            e.classList.remove(revclssname)
            
            setTimeout(() => {                
                e.classList.add(newclssname)
                e.style[cssprop] = '0px'
              }, 1);
          }
          
          }
          else {
        //   if(top < hideheight) {
            //console.log(name)
            if(WithReverse && e.classList.contains(newclssname)){
              //e.style.visibility = 'hidden'
              
              e.classList.remove(newclssname)
              
              setTimeout(() => {                
                e.classList.add(revclssname)
                e.style[cssprop] = -window.innerWidth+'px'
              }, 1);
              
            }
          }
          });
        })
        }
      },
        UpdateChildren(Prop,Children){
            Children.map(child => {
                child[Prop] = this.EditedTab[Prop]
            })
        },
        AddSurveyEntityFields(entityid,EditedTab){
            
            // EditedTab.FormFields = []
            let entityobj = this.ComputedSystemEntities.find(obj => obj.id === entityid)
            console.log('tab Survey Form',entityobj)
            if(entityobj){
                // let finalboj = {
                //     DisplayName: entityobj.DisplayName,
                //     SingleName: entityobj.SingleName,
                //     SurveyTab: entityobj.SurveyTab,
                //     Name: 'Survey Form',
                //     MarginTop: 0,									
                //     MarginBottom: 0,									
                //     MarginLeft: 0,									
                //     MarginRight: 0,									
                //     BGColor: {
                //         hex: '#ffffff',
                //         hexa: '#ffffffff'
                // },									
                //     FontColor :{									
                //             hex: '#000000'									
                //     },									
                //     HeaderColor: {									
                //         hex: '#000000'									
                //     },									
                //     FlexXLRG:6,									
                //     FlexLarge: 8,									
                //     FlexMedium: 10,									
                //     FlexSmall: 12,									
                //     FlexXSmall: 12,									
                //     Cols: 12,	

                // }
            EditedTab.SurveyTab = entityobj.SurveyTab
            EditedTab.ShowComponents = true
            }
            console.log('Survey Form',entityid,EditedTab,this.EditedTab,this.PageTabs)
            
        },
        AddEntityFields(entityid,EditedTab){
            console.log(entityid,EditedTab)
            // EditedTab.FormFields = []
            let entityobj = this.ComputedSystemEntities.find(obj => obj.id === entityid)
            if(entityobj){
             EditedTab.FormFields = entityobj.AllFields.filter(field => {
                return field.UsedonWebForm
            })
            EditedTab.SingleName = entityobj.SingleName
            EditedTab.WebFormType = entityobj.WebFormType
            if(entityobj.HideUserInfoFields){
                EditedTab.HideUserInfoFields = entityobj.HideUserInfoFields
            }
             
            EditedTab.StatusDefault = entityobj.WebFormTab.StatusDefault
            EditedTab.Status_ReasonDefault = entityobj.WebFormTab.Status_ReasonDefault
            EditedTab.RelatedEntity = entityobj.WebFormTab.RelatedEntity
            if(entityobj.ParentEntity){
                EditedTab.ParentEntity = entityobj.ParentEntity
            }
            if(!EditedTab.FormName){
                EditedTab.FormName = entityobj.WebFormTab.FormName
            }   
            }
            
        },
        CheckObjectforUndefined(lvl,obj,path){
      for(var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          let newpath = path+'/'+prop
          if(typeof obj[prop] === 'undefined'){
            console.log('LVL '+lvl+' prop UNDEFINED!!! '+newpath,obj)
          }
          else{
            if(!Array.isArray(obj[prop])){
              //console.log('LVL '+lvl+' prop OK '+newpath+' as ',obj[prop])
              //repeat this function somehow
              if(typeof obj[prop] !== 'string'){
                this.CheckObjectforUndefined(lvl-1+2,obj[prop],newpath)
              }
              
            }
            else{              
              //call array undefined check
              this.CheckArrayforUndefined(lvl-1+2,obj[prop],newpath)
            }
          }
        }
      }
    },
    CheckArrayforUndefined(lvl,obj,path){
      //console.log('checkingprop '+checkingprop+' on path '+path)
      obj.map(arrayrecord => {
        for(var prop in arrayrecord) {
          if (arrayrecord.hasOwnProperty(prop)) {
            let newpath = path+'/'+prop
            if(typeof arrayrecord[prop] === 'undefined'){
              console.log('LVL '+lvl+' array prop UNDEFINED!!! '+newpath,arrayrecord)
            }
            else{
              //console.log('LVL '+lvl+' prop OK '+newpath+' as ',arrayrecord[prop])
              if(!Array.isArray(arrayrecord[prop])){
                if(typeof arrayrecord[prop] !== 'string'){
                this.CheckObjectforUndefined(lvl-1+2,arrayrecord[prop],newpath)
                }
              }
              else{
                this.CheckArrayforUndefined(lvl-1+2,arrayrecord[prop],newpath)
                //prop is array check for third prop
                // arrayrecord[prop].map(thirdrecord => {
                // })
              }
            }
          }
        }
      })
    },
        AssignNewFieldDragging(field){
            console.log(field)
            this.NewFieldDragging = field
        },

        AddTableOption(opt){
            console.log(this.EntityCollectionRef,opt.ConfigCollection,opt)
            console.log(this.EntityCollectionRef.collection(opt.ConfigCollection).doc(opt.Name))
            console.log('CheckObjectforUndefined')
            this.CheckObjectforUndefined(1,opt,'('+opt.Name+')')
            if(!this.NeedsRASync){
                if(!opt.id){
                this.EntityCollectionRef.collection(opt.ConfigCollection).doc(opt.Name).set(opt)   
                }
                else{
                    if(opt.ConfigCollection === 'SubCollections'){
                        this.EntityCollectionRef.collection(opt.ConfigCollection).doc(opt.Name).set(opt)
                    }
                }
            }
            else{
                if(!opt.id){
                    this.RAConfigDB.collection(opt.ConfigCollection).doc(opt.Name).set(opt).then(radoc => {
                        this.EntityCollectionRef.collection(opt.ConfigCollection).doc(opt.Name).set(opt)
                    })  
                }
                else{
                    this.RAConfigDB.collection(opt.ConfigCollection).doc(opt.id).set(opt).then(radoc => {
                        this.EntityCollectionRef.collection(opt.ConfigCollection).doc(opt.id).set(opt)
                    })
                }
            }
            
        },
        AddField(field){
            let fieldobj = Object.assign({},field)
            delete fieldobj.Array
            delete fieldobj.RecordData
            
            if(this.NeedsRASync){
             this.RAConfigDB.collection('AllFields').doc(field.id).set(fieldobj).then(radoc => {
                 console.log(this.EntityCollectionRef,field,fieldobj)
                this.EntityCollectionRef.collection('AllFields').doc(field.id).set(fieldobj)
            })   
            }
            else{
                console.log(this.EntityCollectionRef,field,fieldobj)
                this.EntityCollectionRef.collection('AllFields').doc(field.id).set(fieldobj)
            }
            
            
        },
        DeactivateTabDialog(){
            this.TabDialog = false
            this.EditedTab = ''
            this.EditedTabindex = -1
        },
        ActivateUploadingSingleFileNotification(boolean){
            this.$emit('ActivateUploadingSingleFileNotification',boolean)
        },
        ActivateMultipleFilesUploadNotification(boolean){
            this.$emit('ActivateMultipleFilesUploadNotification',boolean)
        },
        UpdateEditableField(prop,value,AdditionalSaveMethod,FieldObject){
            this.$emit('UpdateEditableField',prop,value,AdditionalSaveMethod,FieldObject)
        },

        NewFieldDragfinish(NewFieldDragging,section){
            //console.log(this.EntityCollectionRef,NewFieldDragging,section)
            
            if(!this.NeedsRASync){
                this.EntityCollectionRef.collection('AllFields').doc(NewFieldDragging.id).update({
                    UsedonForm: true
                })
                NewFieldDragging.UsedonForm = true
                section.Fields.push(NewFieldDragging)
                
            }
            else{
                this.RAConfigDB.collection('AllFields').doc(NewFieldDragging.id).update({
                        UsedonForm: true
                    }).then(radoc => {
                         this.EntityCollectionRef.collection('AllFields').doc(NewFieldDragging.id).update({
                            UsedonForm: true
                        })
                        NewFieldDragging.UsedonForm = true
                        section.Fields.push(NewFieldDragging)
                    })
            }
        },
        NoPropsemit(MethodName){
            this[MethodName]()
        },
        // TabPropEmit(MethodName){
        //     this[MethodName](this.Edite)
        // },
        Onepropemit(MethodName,prop){
            console.log(MethodName,prop)
            this[MethodName](prop)
        },
        Twopropemit(MethodName,firstprop,secondprop){
            this[MethodName](firstprop,secondprop)
        },
        Threepropemit(MethodName,firstprop,secondprop,thirdprop){
            this[MethodName](firstprop,secondprop,thirdprop)
        },
        AddContentBlocks(blocks){
            //console.log('blocks',blocks)
            this.ContentBlocks = blocks
        },					
        CancelEditTestimony(){									
            this.EditedTestimony = ''									
            this.EditedTestimonyIndex = -1									
            this.EditTestimonyDialog = false									
        },									
        EditTestimony(tes,i){									
            this.EditedTestimony = tes									
            this.EditedTestimonyIndex = i									
            this.EditTestimonyDialog = true									
        },									
        AddTestimony(tab){		
            let newindex = tab.Elements.length-1+2
            						
            let NewTestimony = {									
                Avatar: '',										
                Description: `<div style="text-align: center;"><i>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque non lacus nisi.</i></div>`									
            }
            if(this.isOdd(newindex)){
                NewTestimony.Name = 'Joe Doe'
                NewTestimony.Role = 'Regular Joe'
            }								
            else{
                NewTestimony.Name = 'Jane Doe'
                NewTestimony.Role = 'Plain Jane'
            }		
            tab.Elements.push(NewTestimony)									
            									
        },									
        UpdateTabCount(tab){									
            let array = this.$store.state[tab.DataCountCollection.ArrayName]									
            console.log(array)									
            									
            if(tab.CountOperation === 'Amount'){									
                tab.CounterInteger = array.filter(item => {									
                    if(tab.CountisFiltered){									
                        if(tab.Countby && tab.CountCategory && tab.CategoryValue){									
                            if(item[tab.CountCategory.Name]){									
                                if(tab.Countby === 'Option Set'){									
                                return item[tab.CountCategory.Name].ID === tab.CategoryValue.ID  									
                                }									
                                else if(tab.Countby === 'Lookup'){									
                                   									
                                return item[tab.CountCategory.Name+'id'] === tab.CategoryValue.id  									
                                }									
                            									
                            }                        									
                        }   									
                    }									
                    									
                    else if(tab.DataCountCollection){									
                        return item									
                    }									
                }).length									
                if(tab.CountisFiltered && tab.Countby && tab.CountCategory && tab.CategoryValue){									
                tab.Title = tab.CategoryValue.Name									
                }									
                else if(tab.DataCountCollection){									
                 tab.Title = tab.DataCountCollection.Name 									
                }									
            }									
									
        },									
        UpdateStoreProducts(tab){           									
        this.SelectedStoreProducts.map(product => {									
            let match = tab.Elements.find(obj => obj.recordid === product.recordid)									
            if(!match){									
                tab.Elements.push(product)  									
            }                									
        })									
        tab.Elements = tab.Elements.filter((elmnt,i) => {									
            let match = this.SelectedStoreProducts.find(obj => obj.recordid === elmnt.recordid)									
            if(match){									
                return elmnt									
            }									
        })									
        },									
        ColMY(tab){									
            if(tab.Name === 'Card Block Single'){									
                return ''									
            }									
            else{									
                return ' my-3'									
            }									
        },								
        MatchColor(tab){									
            if(tab.RowColor && tab.RowColor.hexa){									
                return tab.RowColor.hexa									
            }	
            else if(tab.RowColor){									
                return tab.RowColor									
            }								
            									
        },										
        ShowTabElements(i){									
            setTimeout(() => {									
                									
            let id = i+'ElementsConfig'			
            console.log('showing elmnts',id)						
            let elmnt = document.getElementById(id)									
            console.log(elmnt)									
            if(elmnt !== null){									
                if(elmnt.style.display === "none"){									
                    elmnt.style.display = "block"									
                    let hidebtnid = document.getElementById(i+'HideElementsConfig')									
                    let showbtnid = document.getElementById(i+'ShowElementsConfig')									
                    hidebtnid.style.display = "block"									
                    if(showbtnid !== null){									
                    showbtnid.style.display = "none"									
                    }									
                }									
            									
            }									
            }, 10);									
            									
            									
        },									
        HideTabElements(i){									
       									
            let id = i+'ElementsConfig'									
            let elmnt = document.getElementById(id)									
            elmnt.style.display = "none"									
            let hidebtnid = document.getElementById(i+'HideElementsConfig')									
            let showbtnid = document.getElementById(i+'ShowElementsConfig')									
            hidebtnid.style.display = "none"									
            if(showbtnid !== null){									
            showbtnid.style.display = "block"									
            }									
            									
        },									
        InsertTab(){									
            let newtab = {									
            SectionType: true,									
            Transparent: true,									
            Alignment: 'center',									
            Justify: 'justify-center',									
            RowTransparency: 'transparent',									
            Name: 'blank',									
            Elements: [],									
            ShowComponents: true									
            }									
            this.PageTabs.push(newtab)									
        },									
        DeleteRow(tab,rowindex){									
            confirm('Are you sure? This will remove the row and any content added to it, there is no going back.') && this.ProcessDeleteRow(tab,rowindex)									
        },									
        ProcessDeleteRow(tab,rowindex){									
            tab.Rows.splice(rowindex,1)									
        },
        UpdateEntitySource(EditedTab){
            if(EditedTab.DataViewName === 'Data Single SubCollection'){
              EditedTab.EntitySource = 'SubCollection'  
              let subcol = this.CurrentEntity.SubCollections.find(obj => obj.id === EditedTab.Entityid)
              EditedTab.DisplayName = subcol.DisplayName
              EditedTab.Name = subcol.Name
              EditedTab.MultipleFileUploadType = 'SubCollection'
            } 
            else if(EditedTab.DataViewName === 'Data Single Related Data'){
            EditedTab.MultipleFileUploadType = 'Related Table'
            EditedTab.EntitySource = 'System Routes' 
            EditedTab.Entityid = EditedTab.EntityObj.id 
            EditedTab.RelationshipField = EditedTab.EntityObj.RelationshipField 
            } 
            else if(EditedTab.DataViewName === 'Data Single Gallery'){
              EditedTab.MultipleFileUploadType = 'Gallery'
              EditedTab.SectionType = 'Gallery'
              let subcol = this.CurrentEntity.Galleries.find(obj => obj.id === EditedTab.Entityid)
              EditedTab.DisplayName = subcol.DisplayName
              EditedTab.Name = subcol.Name
              EditedTab.ConfigCollection = subcol.ConfigCollection
              EditedTab.CreatePermission = subcol.CreatePermission
              EditedTab.DeletePermission = subcol.DeletePermission
              EditedTab.GetPermission = subcol.GetPermission
              EditedTab.ListPermission = subcol.ListPermission
              EditedTab.CreatePermission = subcol.CreatePermission
            } 
            else if(EditedTab.DataViewName === 'Data Single Document Register'){
              EditedTab.MultipleFileUploadType = 'Document Register'
              EditedTab.SectionType = 'Document Register'
              let subcol = this.CurrentEntity.DocumentRegisters.find(obj => obj.id === EditedTab.Entityid)
              EditedTab.DisplayName = subcol.DisplayName
              EditedTab.Name = subcol.Name
              EditedTab.ConfigCollection = subcol.ConfigCollection
              EditedTab.CreatePermission = subcol.CreatePermission
              EditedTab.DeletePermission = subcol.DeletePermission
              EditedTab.GetPermission = subcol.GetPermission
              EditedTab.ListPermission = subcol.ListPermission
              EditedTab.CreatePermission = subcol.CreatePermission
            }        
        },			
        ChangeContentType(tab,TypeChange){		
            console.log(TypeChange)							
            let tabobj = ''
            if(TypeChange.DataViewName){
                tabobj = this.ContentBlocks.find(obj => obj.DataViewName === TypeChange.DataViewName)
            }
            else{
                tabobj = this.ContentBlocks.find(obj => obj.Name === TypeChange.Name)
            }						
            console.log(tabobj)									
            									
          									
           									
           									
           this.EditedTab = Object.assign({},tabobj)									
          if(tab.SectionType){									
              this.PageTabs[this.EditedTabindex] = this.EditedTab									
           this.EditedTab.ShowComponents = false									
            setTimeout(() => {									
                this.EditedTab.ShowComponents = true									
            }, 30)									
          }									
             console.log(this.EditedTab)									
           if(!tab.SectionType){									
               console.log(this.PageTabs[this.customboxindex])									
           console.log(this.PageTabs[this.customboxindex].Elements[this.rowindex])									
                this.PageTabs[this.customboxindex].Elements[this.elementIndex] = this.EditedTab									
                 this.TypeChange = ''									
            this.PageTabs[this.customboxindex].ShowComponents = false									
             setTimeout(() => {									
                this.PageTabs[this.customboxindex].ShowComponents = true									
            }, 3)									
            }									
           									
            									
        //    console.log(tab)									
       									
        },									
        OpenContentTypesDialog(elmnt,elmntindex){									
            this.ContentTypesDialog = true									
        },									
        AdjustRowElementsAmount(tab,row,rowindex){									
           									
            let NewElmnt = {									
                Name: 'blank',									
                Cols: 8									
            }									
            tab.Rows[rowindex].Elements.push(NewElmnt)									
            									
        },									
        AdjustRowAmount(tab,tabindex){	
            							
            if(tab.Name !== 'Card Blocks' && tab.Name !== 'Counter' && tab.Name !== 'Store Products' && tab.Name !== 'Card Row'){									
               let NewRow = {									
                Name: 'blank',									
                Elements: []									
            }   
            if(tab.DataViewName){
                NewRow.ParentTabType = tab.DataViewName
            }									
            tab.Elements.push(NewRow) 									
            this.PageTabs[tabindex] = tab									
            console.log(this.PageTabs)									
            }									
            									
            else if(tab.Name === 'Card Row'){									
               									
                   let NewRow = {	
                    IMG: 'https://firebasestorage.googleapis.com/v0/b/templatizer-9620d.appspot.com/o/LandingPagesShare%2Fweb-developer-vector-illustration-5de192c700231.png?alt=media&token=1dc9a48c-aaf4-473b-87c0-9f7ef84b827f',
                    HasImage: true,								
                Center: 'justify-center',									
                CenteredHeader: true,									
                Name: 'Card Row Single',									
                HeaderFontFamily: 'Roboto',									
                HeaderFontSize: 18,	
                Elevation: 2,								
                HeaderColor: { "alpha": 1, "hex": "#162E4D", "hexa": "#162E4DFF", "hsla": { "h": 213.8181818181818, "s": 0.5555555555555557, "l": 0.1941176470588235, "a": 1 }, "hsva": { "h": 213.8181818181818, "s": 0.7142857142857143, "v": 0.30196078431372547, "a": 1 }, "hue": 213.8181818181818, "rgba": { "r": 22, "g": 46, "b": 77, "a": 1 } },									
                FontSize: 10,									
                FontColor: { "alpha": 1, "hex": "#162E4D", "hexa": "#162E4DFF", "hsla": { "h": 213.8181818181818, "s": 0.5555555555555557, "l": 0.1941176470588235, "a": 1 }, "hsva": { "h": 213.8181818181818, "s": 0.7142857142857143, "v": 0.30196078431372547, "a": 1 }, "hue": 213.8181818181818, "rgba": { "r": 22, "g": 46, "b": 77, "a": 1 } },									
                									
                Title: 'Type',									
                Description: `<div style="text-align: center;">Lorem ipsum dolor sit amet.</div>`,									
                // FlexXLRG:FlexXLRG,									
                // FlexLarge: FlexLarge,									
                FlexMedium: 6,									
                FlexSmall: 6,									
                FlexXSmall: 8,									
                Cols: 3,									
                Justify: 'justify-center',									
                RowColor: '#00ffff',									
                ShowComponents: true,									
                Icon: 'mdi-cards',									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                IsDark: true,									
                									
                									
            }		
            
            let props = ['IMGonTop','TiledIMG','FullIMG','IMGHeight','FlipCard','LabelGradient','LabelBGColor','ContainIMG']
            props.map(prp => {
                    if(typeof tab[prp] !== 'undefined'){
                        NewRow[prp] = tab[prp]
                    }
                })							
            let colors = [									
                    '#F44336',									
                    '#E91E63',									
                    '#9C27B0',									
                    '#673AB7',									
                    '#3F51B5',									
                    '#2196F3',									
                    '#03A9F4',									
                    '#00BCD4',									
                    '#009688',									
                ]									
                let ranint = Math.floor(Math.random() * Math.floor(colors.length))									
                let length = tab.Elements.length									
                let twoback = length-2									
									
                let images = [									
                    'https://firebasestorage.googleapis.com/v0/b/templatizer-9620d.appspot.com/o/LandingPagesShare%2Fweb-developer-vector-illustration-5de192c700231.png?alt=media&token=1dc9a48c-aaf4-473b-87c0-9f7ef84b827f',									
                    'https://firebasestorage.googleapis.com/v0/b/templatizer-9620d.appspot.com/o/LandingPagesShare%2Fwebsite-loading-speed-optimisation-vector-illustration-5de2455056206.png?alt=media&token=39ac7c7a-c899-4cd1-ba7b-269ad58d3962',									
                    'https://firebasestorage.googleapis.com/v0/b/templatizer-9620d.appspot.com/o/LandingPagesShare%2Fwebsite-maintenance-vector-illustration-5de194c28795e.png?alt=media&token=2071c005-5a06-4682-913c-758e4fa1e7f9',									
                    'https://firebasestorage.googleapis.com/v0/b/templatizer-9620d.appspot.com/o/LandingPagesShare%2Fwebsite-support-vector-illustration-5de193d48a370.png?alt=media&token=4f7196c4-c1e0-4010-bdd5-b3d8a952b421'									
                ]									
                let imgopt = tab.Elements.length									
                NewRow.HasImage = true									
                        									
               									
                									
                NewRow.BGColor.hex = '#ffffff'									
                tab.Elements.push(NewRow)									
                this.PageTabs[tabindex] = tab									
               									
                let   lengthint = tab.Elements.length                									
                let FlexXLRG = 0									
                let FlexLarge = 0
                if(tab.Type === 'Magazine Style'){
                    NewRow.IMG = images[imgopt]	
                    let length = tab.Elements.length
                    if(!isOdd(length)){
                        NewRow.MagType = 'Type 2'
                        NewRow.FlexXLRG = 4
                        NewRow.FlexLarge = 4
                        NewRow.FlexMedium = 4								
                        NewRow.FlexSmall = 4							
                        NewRow.FlexXSmall = 12
                    }
                    else{
                        NewRow.MagType = 'Type 1'
                        NewRow.FlexXLRG = 6
                        NewRow.FlexLarge = 6
                        NewRow.FlexMedium = 6							
                        NewRow.FlexSmall = 6							
                        NewRow.FlexXSmall = 12
                    }
                }									
                else if(tab.Elements.length < 5){									
                    FlexXLRG = 10/lengthint									
                    FlexLarge = 12/lengthint									
                    NewRow.IMG = images[imgopt]									
               }									
               else{									
                   let n =  lengthint/4									
                   let decimal = n - Math.floor(n)									
                   									
                   let newlengthint = 4*decimal									
                  									
                   if(decimal === 0 || decimal === 0.75){									
                       FlexXLRG = 10/4									
                        FlexLarge = 12/4									
                        									
                   }									
                   else {									
                        FlexXLRG = 10/3									
                        FlexLarge = 12/3									
                        									
                   }									
                   									
                   									
                    									
                NewRow.IMG = images[3]									
               }									
                tab.Elements.map(elmnt => {									
                    elmnt.FlexXLRG = FlexXLRG									
                    elmnt.FlexLarge = FlexLarge									
                    elmnt.ShowComponents = false									
                    setTimeout(() => {									
                        elmnt.ShowComponents = true									
                    }, 100);									
									
                })									
                tab.ShowComponents = false									
                    setTimeout(() => {									
                        tab.ShowComponents = true									
                    }, 100);									
            console.log(this.PageTabs)									
               									
                									
                									
            }									
            else if(tab.Name === 'Card Blocks'){									
                									
                let NewRow = {									
                Center: 'justify-center',									
                CenteredHeader: true,									
                Name: 'Card Block Single',									
                HeaderFontFamily: 'Roboto',									
                HeaderFontSize: 18,									
                HeaderColor: { "alpha": 1, "hex": "#162E4D", "hexa": "#162E4DFF", "hsla": { "h": 213.8181818181818, "s": 0.5555555555555557, "l": 0.1941176470588235, "a": 1 }, "hsva": { "h": 213.8181818181818, "s": 0.7142857142857143, "v": 0.30196078431372547, "a": 1 }, "hue": 213.8181818181818, "rgba": { "r": 22, "g": 46, "b": 77, "a": 1 } },									
                FontSize: 10,									
                FontColor: { "alpha": 1, "hex": "#162E4D", "hexa": "#162E4DFF", "hsla": { "h": 213.8181818181818, "s": 0.5555555555555557, "l": 0.1941176470588235, "a": 1 }, "hsva": { "h": 213.8181818181818, "s": 0.7142857142857143, "v": 0.30196078431372547, "a": 1 }, "hue": 213.8181818181818, "rgba": { "r": 22, "g": 46, "b": 77, "a": 1 } },									
                									
                Title: 'Here is a Headline',									
                Description: `<div style="text-align: center;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque non lacus nisi.</div>`,									
                FlexXLRG:2,									
                FlexLarge: 3,									
                FlexMedium: 3,									
                FlexSmall: 4,									
                FlexXSmall: 4,									
                Cols: 3,									
                Justify: 'justify-center',									
                RowColor: '#00ffff',									
                ShowComponents: true,									
                Icon: 'mdi-cards',									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                IsDark: true,									
                									
                									
            }									
            let colors = [									
                    '#F44336',									
                    '#E91E63',									
                    '#9C27B0',									
                    '#673AB7',									
                    '#3F51B5',									
                    '#2196F3',									
                    '#03A9F4',									
                    '#00BCD4',									
                    '#009688',									
                ]									
                let ranint = Math.floor(Math.random() * Math.floor(colors.length))									
                let length = tab.Elements.length									
                let twoback = length-2									
                if(length%2 != 0){									
                    if(tab.Elements[twoback] && tab.Elements[twoback].Type  && tab.Elements[twoback].Type === 1){									
                    NewRow.Title = ''									
                    NewRow.Description = '' 									
                    NewRow.HasImage = true									
                    NewRow.IMG = 'https://firebasestorage.googleapis.com/v0/b/templatizer-9620d.appspot.com/o/DefaultSystemAssets%2FExports%2FRAInvert-BG?alt=media&token=ed09e64f-d4ee-4948-b481-809495b3e236'									
                        NewRow.Type = 2									
                    }									
                    else{									
                    NewRow.Title = ''									
                    NewRow.Description = '' 									
                    NewRow.HasImage = true									
                    NewRow.IMG = 'https://firebasestorage.googleapis.com/v0/b/templatizer-9620d.appspot.com/o/DefaultSystemAssets%2FExports%2FRAInvert?alt=media&token=54d7ec67-2109-4eda-93c0-7bf98f55dbf8'									
                        NewRow.Type = 1									
                    }									
                }									
									
               									
                									
                NewRow.BGColor.hex = colors[ranint]									
                tab.Elements.push(NewRow)									
                this.PageTabs[tabindex] = tab									
            console.log(this.PageTabs)									
            }									
            else if(tab.Name === 'Counter'){									
                let counterrandint = Math.floor(Math.random() * Math.floor(256))									
                let titles = [									
                    'Number of Clients',									
                    'Amount Sold',									
                    'Years in Business',									
                    'Food for Thought'									
									
                ]									
                let titlerandint = Math.floor(Math.random() * Math.floor(titles.length))									
                let NewRow = {									
                CounterIcon: 'mdi-excavator',									
                CounterInteger: counterrandint,									
                Center: 'justify-center',									
                CenteredHeader: true,									
                Name: 'Counter Single',									
                HeaderFontFamily: 'Roboto',									
                HeaderFontSize: 18,									
                Tile: true,									
                HeaderColor: { "alpha": 1, "hex": "#162E4D", "hexa": "#162E4DFF", "hsla": { "h": 213.8181818181818, "s": 0.5555555555555557, "l": 0.1941176470588235, "a": 1 }, "hsva": { "h": 213.8181818181818, "s": 0.7142857142857143, "v": 0.30196078431372547, "a": 1 }, "hue": 213.8181818181818, "rgba": { "r": 22, "g": 46, "b": 77, "a": 1 } },									
                FontSize: 10,									
                FontColor: { "alpha": 1, "hex": "#162E4D", "hexa": "#162E4DFF", "hsla": { "h": 213.8181818181818, "s": 0.5555555555555557, "l": 0.1941176470588235, "a": 1 }, "hsva": { "h": 213.8181818181818, "s": 0.7142857142857143, "v": 0.30196078431372547, "a": 1 }, "hue": 213.8181818181818, "rgba": { "r": 22, "g": 46, "b": 77, "a": 1 } },									
                									
                Title: titles[titlerandint],									
                Description: `<div style="text-align: center;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque non lacus nisi.</div>`,									
                FlexXLRG:2,									
                FlexLarge: 3,									
                FlexMedium: 3,									
                FlexSmall: 6,									
                FlexXSmall: 12,									
                Cols: 3,									
                Justify: 'justify-center',									
                RowColor: '#00ffff',									
                ShowComponents: true,									
                Icon: 'mdi-cards',									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                IsDark: true,									
                									
                									
            }									
            let colors = [									
                    'red',									
                    'pink',									
                    'purple',									
                    'deep-purple',									
                    'indigo',									
                    'blue',									
                    'light-blue',									
                    'cyan',									
                    'teal',									
                ]									
                let ranint = Math.floor(Math.random() * Math.floor(colors.length))									
                // let length = tab.Elements.length									
                // let twoback = length-2									
                // if(length%2 != 0){									
                //     if(tab.Elements[twoback] && tab.Elements[twoback].Type  && tab.Elements[twoback].Type === 1){									
                //     NewRow.Title = ''									
                //     NewRow.Description = '' 									
                //     NewRow.HasImage = true									
                //     NewRow.IMG = 'https://firebasestorage.googleapis.com/v0/b/templatizer-9620d.appspot.com/o/DefaultSystemAssets%2FExports%2FRAInvert-BG?alt=media&token=ed09e64f-d4ee-4948-b481-809495b3e236'									
                //         NewRow.Type = 2									
                //     }									
                //     else{									
                //     NewRow.Title = ''									
                //     NewRow.Description = '' 									
                //     NewRow.HasImage = true									
                //     NewRow.IMG = 'https://firebasestorage.googleapis.com/v0/b/templatizer-9620d.appspot.com/o/DefaultSystemAssets%2FExports%2FRAInvert?alt=media&token=54d7ec67-2109-4eda-93c0-7bf98f55dbf8'									
                //         NewRow.Type = 1									
                //     }									
                // }									
									
               									
                									
                NewRow.BGColor.hex = colors[ranint]									
                tab.Elements.push(NewRow)									
                this.PageTabs[tabindex] = tab									
            console.log(this.PageTabs)									
            }									
            else if(tab.Name === 'Store Products'){									
                let counterrandint = Math.floor(Math.random() * Math.floor(256))									
                let titles = [									
                    'Brazillian BlowWave',									
                    'Tummy Tuck',									
                    'Bum Lift',									
                    'SpiderVein Removal'									
									
                ]									
                let titlerandint = Math.floor(Math.random() * Math.floor(titles.length))									
                let NewRow = {									
                CounterIcon: 'mdi-excavator',									
                CounterInteger: counterrandint,									
                Center: 'justify-center',									
                CenteredHeader: true,									
                Name: 'Store Product Single',									
                									
                show: false,									
                HasBGIMG: true,									
                BGIMGisIMG: true,									
                ShowsPrice: true,									
                SubHeaderFontFamily: 'Roboto',									
                SubHeaderFontSize: 18,									
                SubHeaderColor: {									
                    hex: '#FF0000FF'									
                },									
                HeaderFontFamily: 'Roboto',									
                HeaderFontSize: 14,									
                HeaderColor: { "alpha": 1, "hex": "#162E4D", "hexa": "#162E4DFF", "hsla": { "h": 213.8181818181818, "s": 0.5555555555555557, "l": 0.1941176470588235, "a": 1 }, "hsva": { "h": 213.8181818181818, "s": 0.7142857142857143, "v": 0.30196078431372547, "a": 1 }, "hue": 213.8181818181818, "rgba": { "r": 22, "g": 46, "b": 77, "a": 1 } },									
                FontSize: 10,									
                FontColor: { "alpha": 1, "hex": "#162E4D", "hexa": "#162E4DFF", "hsla": { "h": 213.8181818181818, "s": 0.5555555555555557, "l": 0.1941176470588235, "a": 1 }, "hsva": { "h": 213.8181818181818, "s": 0.7142857142857143, "v": 0.30196078431372547, "a": 1 }, "hue": 213.8181818181818, "rgba": { "r": 22, "g": 46, "b": 77, "a": 1 } },									
                HasActionButton: true,									
                ActionButtonName: 'Add to Cart',									
                ActionBtnDark: true,									
                ActionButtonType: 'Add Cart Item',									
                ButonColor: {									
                    hex: '#FF0000FF'									
                },									
                ButtonAlignment: 'justify-end',									
                Title: titles[titlerandint],									
                Description: `<div style="text-align: center;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque non lacus nisi.</div>`,									
                FlexXLRG:3,									
                FlexLarge: 3,									
                FlexMedium: 3,									
                FlexSmall: 6,									
                FlexXSmall: 12,									
                Cols: 3,									
                Justify: 'justify-center',									
                RowColor: '#00ffff',									
                ShowComponents: true,									
                Icon: 'mdi-cards',									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                BGColor: {									
                        hex: '#ffffff',			
                        hexa: '#ffffffff',						
                        rgba: {r: 255,g: 255,b: 255}									
                },									
                IsDark: true,									
                									
                									
            }									
            let cards = [									
                {									
                    Title: 'Sandals',									
                    Price: 'ONLY $14.99',									
                    Description: `<div style="text-align: center;">Fun to Wear</div>`,									
                    IMG: 'https://firebasestorage.googleapis.com/v0/b/templatizer-9620d.appspot.com/o/LandingPagesShare%2FXero_Shoes_Sensori_Venture_huarache_style_barefoot_sandal_01.png?alt=media&token=bd65ff7c-0901-4340-8684-21412a8692c6'									
                },									
                {									
                    Title: 'Shirt',									
                    Price: '$10.99',									
                    Description: `<div style="text-align: center;">a Cool Summer Shirt</div>`,									
                    IMG: 'https://firebasestorage.googleapis.com/v0/b/templatizer-9620d.appspot.com/o/LandingPagesShare%2Fblank-1976334_640.png?alt=media&token=276078fd-21df-4dce-880d-231c7709be60'									
                },									
                {									
                    Title: 'Jeans',									
                    Price: '$108.99',									
                    Description: `<div style="text-align: center;">Empty pocket Jeans, priced to go!</div>`,									
                    IMG: 'https://firebasestorage.googleapis.com/v0/b/templatizer-9620d.appspot.com/o/LandingPagesShare%2Fno-money-2070384_640.jpg?alt=media&token=a48c26c5-ccb1-4a73-a386-36ccda526983'									
                },									
                {									
                    Title: 'Grafitti LaceUps',									
                    Price: '$8.99',									
                    Description: `<div style="text-align: center;">So funky they make you want to undress</div>`,									
                    IMG: 'https://firebasestorage.googleapis.com/v0/b/templatizer-9620d.appspot.com/o/LandingPagesShare%2Fshoe-1433925_640.jpg?alt=media&token=2e1bb030-e9bd-42ad-9854-9f412d852576'									
                }									
            ]									
  									
                let ranint = Math.floor(Math.random() * Math.floor(cards.length))									
                NewRow.HasImage = true									
                NewRow.IMG = cards[ranint].IMG									
                NewRow.Description = cards[ranint].Description									
                NewRow.Price = cards[ranint].Price									
                NewRow.Title = cards[ranint].Title									
									
               									
                									
                NewRow.BGColor.hex = '#ffffff'									
                tab.Elements.push(NewRow)									
                this.PageTabs[tabindex] = tab									
                console.log(this.PageTabs)									
            }									
            // tab.ShowComponents = false									
            //  setTimeout(() => {									
            //     tab.ShowComponents = true									
            // }, 3)									
            									
        },									
        NewTestimonialImageFileselected(){									
            this.NewTestimonialFile = event.target.files[0]									
            this.SampleTestinomialFile = URL.createObjectURL(this.NewTestimonialFile)									
        },									
        PrepareTestimonyThumbnail(filename,file,storageref){									
        let vm = this									
        return new Promise(function(resolve, reject) {									
        file.tmpsrc = URL.createObjectURL(file)									
              //this.OutboundPhotosforUpload.push(file)									
              var img = document.createElement("IMG");									
                img.setAttribute('width',150)									
                img.setAttribute('src',file.tmpsrc)									
                document.body.appendChild(img)									
                									
                img.onload = function() {									
                var c = document.createElement("canvas");									
                var ctx = c.getContext("2d");									
                var canvasRatio = img.naturalHeight / img.naturalWidth									
                c.width = 400									
                c.height = c.width*canvasRatio									
                ctx.drawImage(img, 0, 0, c.width, c.height);									
                c.toBlob(blob => {									
                  let blobfile = new File([blob], filename, {									
              type: file.type,									
            });									
            console.log(blobfile)									
            var storageRef = firebase.storage().ref(storageref+'_thumb')									
                document.body.removeChild(img)									
                var uploadTask = storageRef.put(blobfile)									
                uploadTask									
                  .then(snapshot => snapshot.ref.getDownloadURL())									
                    .then((thumburl) => {									
                      console.log(thumburl)									
                      vm.EditedTestimony.Avatar = thumburl									
                      vm.CancelEditTestimony()									
                    })									
              })									
                }									
        })									
      },									
        SaveTestimonialFile(){									
            if(this.NewTestimonialFile){									
                let vm = this                									
                var storageRef = 'LandingPages/'+vm.$route.params.id+'/Testimonials/'+new Date()+'/'+vm.NewTestimonialFile.name									
                vm.PrepareTestimonyThumbnail(vm.NewTestimonialFile.name,vm.NewTestimonialFile,storageRef)									
                									
            }									
        },									
        NewAssetFileselected(){									
            									
            var value = prompt("Please choose a name for future refence to this asset", "");									
                if (value != null) {									
                this.AssetName = value									
                this.NewAssetFile = event.target.files[0]									
            // this.SampleBannerImagefile = URL.createObjectURL(this.NewAssetFile)									
                }									
            									
        },									
        SaveNewsystemAsset(){									
            if(this.NewAssetFile){									
                let vm = this                									
                var storageRef = firebase.storage().ref('systemAssets/'+vm.$route.params.id+'/'+vm.NewAssetFile.name+'_thumb')									
               									
                var uploadTask = storageRef.put(this.NewAssetFile)									
                uploadTask									
                  .then(snapshot => snapshot.ref.getDownloadURL())									
                    .then(thumburl => {									
                    let Assetshorttype = vm.NewAssetFile.type.split('image/').join('')									
                    let NewAsset = {Name: vm.AssetName, Path: thumburl, ShortType: Assetshorttype, FullName: vm.AssetName.split(' ').join('_')+'.'+Assetshorttype}									
                        // this.SystemAssets.push(NewAsset)									
                        db.collection('systemassets').doc(vm.AssetName.split(' ').join('_')).set(NewAsset).then(doc => {									
                                console.log('updated asset')									
                        })									
                })									
            }									
        },									
            									
        HeaderCenterClass(tab){									
            if(tab.CenteredHeader){									
                tab.Center = 'justify-center'									
            }									
            else{									
                tab.Center = ''									
            }									
            tab.ShowComponents = false									
             setTimeout(() => {									
                tab.ShowComponents = true									
            }, 3)									
        },									
        									
        DeleteTabAsset(tab,photoindex){									
            confirm('This will remove the item from this tab, are you sure?') && this.ProcessDeleteTabAsset(tab,photoindex)									
        },									
        ProcessDeleteTabAsset(tab,photoindex){									
            tab.Assets.splice(photoindex,1)									
            tab.ShowComponents = false									
             setTimeout(() => {									
                tab.ShowComponents = true									
            }, 3)									
        },									
        AssignClippingAnimationValue(){									
            if(tab.ClippedPathOption === 'circle'){									
                if(tab.ClipAnimation === 'Spotlight Search'){									
									
                }									
            }									
        },									
        AssignClippingValue(tab){									
            if(tab.ClippedPathOption === 'polygon'){									
                tab.TopLeftCrnrX = tab.TopLeftCrnrXValue+'%'									
                tab.TopLeftCrnrY = tab.TopLeftCrnrYValue+'%'									
                tab.TopRightCrnrX = tab.TopRightCrnrXValue+'%'									
                tab.TopRightCrnrY = tab.TopRightCrnrYValue+'%'									
                tab.BottomRightCrnrX = tab.BottomRightCrnrXValue+'%'									
                tab.BottomRightCrnrY = tab.BottomRightCrnrYValue+'%'									
                tab.BottomLeftCrnrX = tab.BottomLeftCrnrXValue+'%'									
                tab.BottomLeftCrnrY = tab.BottomLeftCrnrYValue+'%'									
									
            }									
             else if(tab.ClippedPathOption === 'elipse'){									
            tab.ElipseX = tab.ElipseXValue+'%'									
            tab.EliseY = tab.ElipseYValue+'%'									
            tab.ElipseXPosition = tab.ElipseXPositionValue+'%'									
            tab.ElipseYPosition = tab.ElipseYPositionValue+'%'									
             }									
             else if(tab.ClippedPathOption === 'circle'){									
            tab.CircleRadius = tab.CircleRadiusValue+'%'									
            tab.CircleXPosition = tab.CircleXPositionValue+'%'									
            tab.CircleYPosition = tab.CircleYPositionValue+'%'									
             }									
             console.log(tab)									
             tab.ShowComponents = false									
             setTimeout(() => {									
                tab.ShowComponents = true									
            }, 3)									
        },									
        AssignClipDefaults(tab){									
            //polygon(              25%                   0%,                   100%                    0%,                     75%                     100%,                       0%                      100%);									
 //return `clip-path: polygon(`+tab.TopLeftCrnrX+` `+tab.TopLeftCrnrY+`, `+tab.TopRightCrnrX+` `+tab.TopRightCrnrY+`, `+tab.BottomRightCrnrX+` `+tab.BottomRightCrnrY+`, `+tab.BottomLeftCrnrX+` `+tab.BottomLeftCrnrY+`);`									
            if(tab.ClippedPathOption === 'polygon'){									
                tab.TopLeftCrnrXValue = 25									
                tab.TopLeftCrnrYValue = 0									
                tab.TopLeftCrnrX = '25%'									
                tab.TopLeftCrnrY = '0%'									
                tab.TopRightCrnrXValue = 100									
                tab.TopRightCrnrYValue = 0									
                tab.TopRightCrnrX = '100%'									
                tab.TopRightCrnrY = '0%'									
                tab.BottomRightCrnrXValue = 75									
                tab.BottomRightCrnrYValue = 100									
                tab.BottomRightCrnrX = '75%'									
                tab.BottomRightCrnrY = '100%'									
                tab.BottomLeftCrnrXValue = 0									
                tab.BottomLeftCrnrYValue = 100									
                tab.BottomLeftCrnrX = '0%'									
                tab.BottomLeftCrnrY = '100%'									
            }									
            else if(tab.ClippedPathOption === 'elipse'){									
                tab.ElipseXValue = 100									
                tab.ElipseYValue = 55									
                tab.ElipseXPositionValue = 48									
                tab.ElipseYPositionValue = 44									
                tab.ElipseX = '100%'									
                tab.EliseY = '55%'									
                tab.ElipseXPosition = '48%'									
                tab.ElipseYPosition = '44%'									
            }									
            else if(tab.ClippedPathOption === 'circle'){									
                tab.CircleRadiusValue = 50									
                tab.CircleXPositionValue = 50									
                tab.CircleYPositionValue = 50									
                tab.CircleRadius = '50%'									
                tab.CircleXPosition = '50%'									
                tab.CircleYPosition = '50%'									
            }									
            console.log(tab)									
        },									
        CheckifClipped(tab){									
        									
            if(tab.Clipped){									
                if(tab.ClippedbyPath){									
                    if(tab.ClippedPathOption){									
                        if(tab.ClippedPathOption === 'elipse'){									
                            return `clip-path: ellipse(`+tab.ElipseX+` `+tab.EliseY+` at `+tab.ElipseXPosition+` `+tab.ElipseYPosition+`);`									
                        }									
                        if(tab.ClippedPathOption === 'circle'){									
                            if(tab.ClipAnimation === 'Spotlight Search'){									
                                return `animation: spotlightsearch 3s `+tab.CircleAnimationRepeat+`;`									
                            }									
                            else{									
                             return `clip-path: circle(`+tab.CircleRadius+` at `+tab.CircleXPosition+` `+tab.CircleYPosition+`);`   									
                            }									
                            									
                        }									
                        if(tab.ClippedPathOption === 'polygon'){									
                            return `clip-path: polygon(`+tab.TopLeftCrnrX+` `+tab.TopLeftCrnrY+`, `+tab.TopRightCrnrX+` `+tab.TopRightCrnrY+`, `+tab.BottomRightCrnrX+` `+tab.BottomRightCrnrY+`, `+tab.BottomLeftCrnrX+` `+tab.BottomLeftCrnrY+`);`									
                        }									
                        // if(tab.ClippedPathOption === 'beizer'){									
                        //     return `clip-path: circle(`+tab.CircleRadius+` at `+tab.CircleXPosition+` `+tab.CircleYPosition+`);` 									
                        //     d="M 0,1									
						// 			L 0,0
						// 			L 1,0
						// 			L 1,1
						// 			C .65 .8, .35 .8, 0 1
						// 			Z"
                        // }									
                    }									
                    									
                }									
                else if(tab.ClippingIMG){									
                 return `-webkit-mask-image: url(`+tab.ClippingIMG+`);									
                                        -webkit-mask-repeat: no-repeat;									
                                        -webkit-mask-size: contain;									
                                        -webkit-mask-position: center;`   									
                }									
                									
                									
            }									
        },									
        FormFieldsDialogActivate(){									
            this.FieldsDialogActivate = true									
        },
        FormFieldsDialogDeactive()	{									
            this.FieldsDialogActivate = false									
        },							
									
       ActivateOptionSetDialog(field,ContentBlockObject){									
         this.EditOptionSet = field		
         if(field.PrimaryOptions){
             this.EditOptionSet.Options = field.PrimaryOptions
             this.EditOptionSet.lastassignedinteger = field.PrimaryOptionsInteger
         }							
         if(!this.EditOptionSet.Options){									
           this.EditOptionSet.Options = []									
         }									
         this.OptionSetDialog = true
         console.log(this.EditOptionSet)									
       },									
       AddOptionSetOption(OptionName){									
      if(typeof this.EditOptionSet.lastassignedinteger === 'undefined'){									
        this.EditOptionSet.lastassignedinteger = 1000000									
        									
      }      									
       let integer = this.EditOptionSet.lastassignedinteger-1+2									
      									
      let NewOption = {Name: OptionName, ID: integer}									
      this.EditOptionSet.Options.push(NewOption)									
      this.OptionName = ''									
      this.EditOptionSet.lastassignedinteger = integer									
    },									
    OptionNameSelect(option){									
      this.Option = option									
    },									
    CancelOptionSetDialog(){									
		this.OptionSetDialog = false
        this.EditOptionSet = ''
        this.Option = {}							
    },									
    SaveOptionSets(fieldconfig){	
        if(!fieldconfig){
        let fieldobj = this.EditedTab.FormFields.find(obj => obj.Name === this.EditOptionSet.Name)									
        let fieldindex = this.EditedTab.FormFields.indexOf(fieldobj)									
        this.EditedTab.FormFields[fieldindex].Options = this.EditOptionSet.Options									
        this.OptionSetDialog = false									
        this.NewContentDialog = false									
        this.NewContentDialog = true
        }	
        else{
            this.OptionSetDialog = false
        }							
        									
    },									
        AddFieldtoWebForm(){									
         this.FieldsDialogActivate = false									
         this.FieldsDialogActivate = true									
         if(!this.EditedTab.FormFields){									
           this.EditedTab.FormFields = []									
         }									
         let NewField = {Name: 'Field',Type:'Single Line Text'}									
         this.EditedTab.FormFields.push(NewField)									
          tab.ShowComponents = false									
             setTimeout(() => {									
                tab.ShowComponents = true									
            }, 3)									
       },									
       HeaderFontFamily(tab,tabHeaderFontFamily){
           if(tabHeaderFontFamily){
               if(!tab.HeaderFontSize){
                 return 'font-family: '+tabHeaderFontFamily+', sans-serif;font-size:50px;'  
               }
               else{
                return 'font-family: '+tabHeaderFontFamily+', sans-serif;font-size:'+tab.HeaderFontSize+'px;'
               }
               
           }
           else{
            return 'font-family: '+this.PageHeadersFont+', sans-serif;font-size:'+tab.HeaderFontSize+'px;'
           }
       },							
        HeaderColor(tabHeaderColor){									
            if(tabHeaderColor.hex){									
                return tabHeaderColor.hex									
            }									
        },									
        SetRowTransparency(tab){									
            if(tab.Transparent){									
                tab.RowTransparency = 'transparent'									
            }									
            else{									
                tab.RowTransparency = ''									
            }									
             tab.ShowComponents = false									
             setTimeout(() => {									
                tab.ShowComponents = true									
            }, 3)									
									
        },									
        AlertMe(){									
            alert('alert me')									
        },									
        									
        ImageAlignment(tab,justify){									
            tab.Justify = justify									
            this.TabDialog = false									
            tab.ShowComponents = false									
             setTimeout(() => {									
                tab.ShowComponents = true									
            }, 3)									
        },									
        BoxWrapping(tab,alignment){									
            if(tab.Name === 'Parallax'){									
                tab.LayoutValue = alignment.LayoutValue.split('fill-height ')[1]									
            }									
            else{									
                tab.LayoutValue = alignment.LayoutValue									
            }									
            									
            tab.FlexValue = alignment.FlexValue									
            this.TabDialog = false									
            this.ShowComponents = false									
            									
            setTimeout(() => {									
                this.ShowComponents = true									
            }, 10);									
            									
        },									
        DeleteTab(NewDelete){									
            confirm('Are you sure? Everything on this tab will be lost forever') && this.ProcessDeleteTab(NewDelete)									
        },									
        ProcessDeleteTab(NewDelete){									
            console.log('this one yeah',this.customboxindex,this.elementIndex,this.PageTabs)									
            if(this.elementIndex === -1){									
              console.log(this.EditedTabindex)									
            this.PageTabs.splice(this.EditedTabindex,1)									
            console.log(this.PageTabs)  									
            }									
            else{									
                console.log(this.rowindex)									
                if(this.rowindex > -1){									
                    this.PageTabs[this.customboxindex].Rows[this.rowindex].Elements.splice(this.elementIndex,1)									
                }									
                else{									
                    console.log('this one yeah',this.customboxindex,this.elementIndex,this.PageTabs)									
                   this.PageTabs[this.customboxindex].Elements.splice(this.elementIndex,1) 									
                }									
                									
            }									
            	if(NewDelete){
                    this.DeactivateTabDialog()
                }								
        },									
        ActivateTextBoxDialog(tab,tabindex){									
            									
            // this.EditedTab = tab									
            // this.EditedTabindex = tabindex									
             this.ContentTypesDialog = false									
            this.TabDialog = false									
            tab.ShowComponents = false									
             setTimeout(() => {									
                tab.ShowComponents = true									
            }, 3)									
            this.TextBoxDialog = true									
           									
            console.log(this.TextBoxDialog)									
        },									
        AssignGalleryAssets(tab,asset){									
            //console.log(tab,asset)									
            if(tab.Name === 'Gallery' || tab.Name === 'Carousel' || tab.Name === 'Image' && tab.IMGRotation || tab.Name === 'Image' && tab.ComparingImages){									
                let galleryobj = {									
                Name: asset.Name,									
                URL: asset.Path									
            }									
            if(asset.Path){									
                galleryobj.URL = asset.Path									
            }									
            else if(asset.path){									
                galleryobj.URL = asset.path									
            }	
            else if(asset.url){									
                galleryobj.URL = asset.url									
            }								
            if(asset.ThumbURL){									
                galleryobj.ThumbURL = asset.ThumbURL									
            }									
            if(!asset.ThumbURL){									
                galleryobj.ThumbURL = galleryobj.URL									
            }									
            									
            tab.Assets.push(galleryobj)									
            console.log(tab)									
             tab.ShowComponents = false									
             setTimeout(() => {									
                tab.ShowComponents = true									
            }, 3)									
            }									
            else if(tab.Name === 'Parallax' || tab.Name === 'Image' || tab.HasImage){									
                this.AssignImage(tab,'IMG',asset)									
            }									
            									
            									
        },								
        AssignImage(tab,prop,asset,IsThis){
            console.log(tab,prop,asset,IsThis)	
            if(IsThis){
                if(asset.Path){									
                this[prop] = asset.Path   									
                }									
                else if(asset.path){									
                    this[prop] = asset.path 									
                }
            }	
            else{
                console.log(tab,prop,asset)								
                if(asset.Path){									
                tab[prop] = asset.Path   									
                }									
                else if(asset.path){									
                    tab[prop] = asset.path 									
                }									
                                                    
                console.log(tab)									
                tab.ShowComponents = false									
                setTimeout(() => {									
                    tab.ShowComponents = true									
                }, 3)	
            }
            								
        },		
       	SavePageAsIs(){
               this.SavePage(this.PublishType,this.PageName,this.PageRoute,this.PageOverview,this.PageContentFont,this.PageHeadersFontSize,this.PageHeadersFont,this.PageIcon,this.PageBGGradient,this.PageBGAsset,this.PageBGColor,this.ClearNavbarColor)
        },						
        SavePage(PublishType,PageName,PageRoute,PageOverview,PageContentFont,PageHeadersFontSize,PageHeadersFont,PageIcon,PageBGGradient,PageBGAsset,PageBGColor,ClearNavbarColor){									
            confirm('This will save the page are you sure?') && this.ProcessSavePage(PublishType,PageName,PageRoute,PageOverview,PageContentFont,PageHeadersFontSize,PageHeadersFont,PageIcon,PageBGGradient,PageBGAsset,PageBGColor,ClearNavbarColor)									
        },	
        VerifyWikiEntityPath(path,PublishType,PageName,PageRoute,PageOverview,PageContentFont,PageHeadersFontSize,PageHeadersFont,PageIcon,PageBGGradient,PageBGAsset,PageBGColor){
           path.get().then(snapshot => {
               let wikientitydata = snapshot.data()
               if(!wikientitydata){
                   this.WikiPublishTypeDialog = true
               }
               else{
                   this.ProcessSaveWikiTabs(path)
               }
           })
        },	
        CancelCreateWikiEntityandSaveWikiTabs(){
            this.WikiPublishTypeDialog = false
            this.$emit('CancelEditing',false)  
        },
        ProcessCreateWikiEntityandSaveWikiTabs(path){
            let NewWikiEntity = {
                // DescriptionField: '',
                // HideIMG: false,
                // IMGField: 'PageName',
                // PageName: '',
                // PageOverview: '',
                PublishType: this.PublishType,
                SingleName: this.CurrentEntity.SingleName,
                // TaggedFields: [],
                // TitleField: '',
                WikiFields: this.CurrentEntity.WikiFields,
                WikiTabs: this.SavingTabs,
                AdditionalFields: []
            }
            path.set(NewWikiEntity).then(doc => {
                        if(this.SingleFormEditing){
                            setTimeout(() => {
                            this.$emit('CancelEditing',false)   
                            }, 100);
                            
                        }
                    })
        },
        ProcessSaveWikiTabs(path){
             path.update({
                    [this.PageTabsPropName]: this.SavingTabs,
                    PublishType: 'Public',
                    WikiFields: this.CurrentEntity.WikiFields
                }).then(doc => {
                    if(this.SingleFormEditing){
                        setTimeout(() => {
                         this.$emit('CancelEditing',false)   
                        }, 100);
                        
                    }
                })
        },		
        UpdatePageOverlay(PageOverlay){
            this.PageOverlay = PageOverlay
             let path = ''
            if(this.$route.name === 'newlandingpage'){
                path = db.collection('landingpages').doc(this.$route.params.id)
            }
            else if(this.$route.name === 'DocumentationLibraryEditor'){
                let doclibobj = this.DocumentationLibraryObj
                //console.log(doclibobj)
                path = doclibobj.Database.collection('SystemConfig').doc(doclibobj.SystemID).collection('DocumentationLibraries').doc(this.$route.params.id).collection('Pages').doc(this.$route.params.slug)
            }
            else if(this.$route.name === 'PageBuilder'){
                path = db.collection('SystemConfig').doc(this.System.id).collection('Pages').doc(PageName.split(' ').join('_'))
            }
            else if(this.$route.name === 'PageEditor'){
                path = db.collection('SystemConfig').doc(this.System.id).collection('Pages').doc(this.$route.params.id)
            }
            else if(this.$route.name === 'GroupPageBuilder'){
                path = db.collection('groups').doc(this.$route.params.id).collection('pages').doc(PageName.split(' ').join('_'))
            }
            else if(this.$route.name === 'GroupPageEditor'){
                path = db.collection('groups').doc(this.$route.params.id).collection('pages').doc(this.$route.params.slug)
            }
            else{
                path = this.EntityCollectionRef
            }
            path.update({
                PageOverlay: PageOverlay
            })
        },
        UpdatePageCustomStyle(PageCustomStyle){
            this.PageCustomStyle = PageCustomStyle
             let path = ''
            if(this.$route.name === 'newlandingpage'){
                path = db.collection('landingpages').doc(this.$route.params.id)
            }
            else if(this.$route.name === 'DocumentationLibraryEditor'){
                let doclibobj = this.DocumentationLibraryObj
                //console.log(doclibobj)
                path = doclibobj.Database.collection('SystemConfig').doc(doclibobj.SystemID).collection('DocumentationLibraries').doc(this.$route.params.id).collection('Pages').doc(this.$route.params.slug)
            }
            else if(this.$route.name === 'PageBuilder'){
                path = db.collection('SystemConfig').doc(this.System.id).collection('Pages').doc(PageName.split(' ').join('_'))
            }
            else if(this.$route.name === 'PageEditor'){
                path = db.collection('SystemConfig').doc(this.System.id).collection('Pages').doc(this.$route.params.id)
            }
            else if(this.$route.name === 'GroupPageBuilder'){
                path = db.collection('groups').doc(this.$route.params.id).collection('pages').doc(PageName.split(' ').join('_'))
            }
            else if(this.$route.name === 'GroupPageEditor'){
                path = db.collection('groups').doc(this.$route.params.id).collection('pages').doc(this.$route.params.slug)
            }
            else{
                path = this.EntityCollectionRef
            }
            path.update({
                PageCustomStyle: PageCustomStyle
            })
        },
        UpdateClearNavbarColor(bool){
            this.ClearNavbarColor = bool
            let path = ''
            if(this.$route.name === 'newlandingpage'){
                path = db.collection('landingpages').doc(this.$route.params.id)
            }
            else if(this.$route.name === 'DocumentationLibraryEditor'){
                let doclibobj = this.DocumentationLibraryObj
                //console.log(doclibobj)
                path = doclibobj.Database.collection('SystemConfig').doc(doclibobj.SystemID).collection('DocumentationLibraries').doc(this.$route.params.id).collection('Pages').doc(this.$route.params.slug)
            }
            else if(this.$route.name === 'PageBuilder'){
                path = db.collection('SystemConfig').doc(this.System.id).collection('Pages').doc(PageName.split(' ').join('_'))
            }
            else if(this.$route.name === 'PageEditor'){
                path = db.collection('SystemConfig').doc(this.System.id).collection('Pages').doc(this.$route.params.id)
            }
            else if(this.$route.name === 'GroupPageBuilder'){
                path = db.collection('groups').doc(this.$route.params.id).collection('pages').doc(PageName.split(' ').join('_'))
            }
            else if(this.$route.name === 'GroupPageEditor'){
                path = db.collection('groups').doc(this.$route.params.id).collection('pages').doc(this.$route.params.slug)
            }
            else{
                path = this.EntityCollectionRef
            }
            path.update({
                ClearNavbarColor: bool
            })
        },		
        ProcessSavePage(PublishType,PageName,PageRoute,PageOverview,PageContentFont,PageHeadersFontSize,PageHeadersFont,PageIcon,PageBGGradient,PageBGAsset,PageBGColor,ClearNavbarColor,PageCustomStyle,PageOverlay){	
            //Okay now this.CurrentEntity.WikiFields get added
            //console.log(PublishType,PageName,PageRoute,PageOverview,PageContentFont,PageHeadersFontSize,PageHeadersFont,PageIcon,PageBGGradient,PageBGAsset,PageBGColor,ClearNavbarColor)								
            let CodeElmentArray = document.getElementsByClassName('CodeRenders')									
            let PageCode = ''									
            this.PageTabs.map((tab,i) => {									
                PageCode = PageCode+CodeElmentArray[i].innerHTML									
            })							
            //console.log(this.PageTabs,this.PageName)
            //this.CheckArrayforUndefined(1,this.SavingTabs,'(SavingTabs)')	
            let path = ''
            if(this.$route.name === 'newlandingpage'){
                path = db.collection('landingpages').doc(this.$route.params.id)
            }
            else if(this.$route.name === 'DocumentationLibraryEditor'){
                let doclibobj = this.DocumentationLibraryObj
                //console.log(doclibobj)
                path = doclibobj.Database.collection('SystemConfig').doc(doclibobj.SystemID).collection('DocumentationLibraries').doc(this.$route.params.id).collection('Pages').doc(this.$route.params.slug)
            }
            else if(this.$route.name === 'PageBuilder'){
                path = db.collection('SystemConfig').doc(this.System.id).collection('Pages').doc(PageName.split(' ').join('_'))
            }
            else if(this.$route.name === 'PageEditor'){
                path = db.collection('SystemConfig').doc(this.System.id).collection('Pages').doc(this.$route.params.id)
            }
            else if(this.$route.name === 'GroupPageBuilder'){
                path = db.collection('groups').doc(this.$route.params.id).collection('pages').doc(PageName.split(' ').join('_'))
            }
            else if(this.$route.name === 'GroupPageEditor'){
                path = db.collection('groups').doc(this.$route.params.id).collection('pages').doc(this.$route.params.slug)
            }
            else{
                path = this.EntityCollectionRef
            }
            
            //console.log(path)
            if(this.$route.name === 'newlandingpage' || this.$route.name === 'PageBuilder' || this.$route.name === 'PageEditor' || this.$route.name === 'GroupPageBuilder' || this.$route.name === 'GroupPageEditor'){
                let pageobj = {									
                    PageTabs: this.SavingPageTabs,									
                    PublishType: PublishType,									
                    // PageCode: PageCode,									
                    Name: PageName,									
                    Overview: PageOverview,									
                    PageContentFont: PageContentFont,									
                    PageHeadersFontSize: PageHeadersFontSize,									
                    PageHeadersFont: PageHeadersFont,									
                }
                if(this.PageData && this.PageData.KeyWords){
                    pageobj.KeyWords = this.PageData.KeyWords
                }
                if(this.PageData && typeof this.PageData.SEO !== 'undefined'){
                    pageobj.SEO = this.PageData.SEO
                }
                if(typeof PageRoute !== 'undefined'){
                    pageobj.PageRoute = PageRoute.split('_').join('-').split(' ').join('-')
                }
                if(typeof PageBGGradient !== 'undefined'){
                    pageobj.PageBGGradient = PageBGGradient
                }
                if(typeof PageBGAsset !== 'undefined'){
                    pageobj.PageBGAsset = PageBGAsset
                }
                if(typeof PageBGColor !== 'undefined'){
                    pageobj.PageBGColor = PageBGColor
                }
                if(typeof ClearNavbarColor !== 'undefined'){
                    pageobj.ClearNavbarColor = ClearNavbarColor
                }
                 if(typeof PageCustomStyle !== 'undefined'){
                    pageobj.PageCustomStyle = PageCustomStyle
                }
                if(typeof PageOverlay !== 'undefined'){
                    pageobj.PageOverlay = PageOverlay
                }
                
                if(typeof PageIcon !== 'undefined'){
                    pageobj.PageIcon = PageIcon
                }
                if(this.CatNavList){
                    pageobj.CatNavList = this.CatNavList.id
                }
                if(this.PageData.IsDirectory){
                    pageobj.IsDirectory = this.PageData.IsDirectory
                    pageobj.DirectoryType = this.PageData.DirectoryType
                }
                this.CheckArrayforUndefined(1,this.SavingPageTabs,'(SavingPageTabs)')
                path.set(pageobj) 
                this.DeactivateTabDialog()
            }
            else if(this.$route.name.includes('classifiedbuilder')){
                console.log(path,this.SavingTabs,this.$route)
                this.CheckArrayforUndefined(1,this.SavingTabs,'(SavingTabs)')
                path.update({
                    [this.PageTabsPropName]: this.SavingTabs,
                    PublishType: 'Public',
                    SingleName: this.$route.meta.SingleName
                }).then(doc => {
                    if(this.SingleFormEditing){
                        setTimeout(() => {
                         this.$emit('CancelEditing',false)   
                        }, 100);
                        
                    }
                })
            }
            else if(this.$route.name.includes('wikibuilder')){
                console.log(path,this.SavingTabs)
                this.CheckArrayforUndefined(1,this.SavingTabs,'(SavingTabs)')
                this.VerifyWikiEntityPath(path,PublishType,PageName,PageRoute,PageOverview,PageContentFont,PageHeadersFontSize,PageHeadersFont,PageIcon,PageBGGradient,PageBGAsset,PageBGColor)
                
            }
            else if(this.NeedsRASync){                
                this.UpdateRAandClientApp(path)
            }        
            else{
                console.log(path,this.SavingTabs)
                this.CheckArrayforUndefined(1,this.SavingTabs,'(SavingTabs)')
                path.update({
                    [this.PageTabsPropName]: this.SavingTabs
                    }).then(doc => {
                        if(this.SingleFormEditing){
                            setTimeout(() => {
                            this.$emit('CancelEditing',false)   
                            }, 100);
                            
                        }
                    })
                
                
            }							
            									
        },
        UpdateRAandClientApp(path){
            //RAConfigDB
            console.log('UpdateRAandClientApp',this.RAConfigDB,path)
            this.CheckArrayforUndefined(1,this.SavingTabs,'(SavingTabs)')
            this.RAConfigDB.update({
                    [this.PageTabsPropName]: this.SavingTabs
                }).then(radoc => {
                path.update({
                    [this.PageTabsPropName]: this.SavingTabs
                }).then(doc => {
                    if(this.SingleFormEditing){
                        setTimeout(() => {
                         this.$emit('CancelEditing',false)   
                        }, 100);
                        
                    }
                })
            })
        },								
        FlexClass(tab){									
            return 'lg'+tab.FlexLarge+' md'+tab.FlexMedium+' sm'+tab.FlexSmall+' xs'+tab.FlexXSmall+' mx-2 '									
        },									
        UpdateTestimonyHTMLBox(){									
            let id = this.EditedTestimony.Name.split(' ').join('_')+'editor'									
            let contentbox = document.getElementById(id)									
            if(contentbox){									
                this.EditedTestimony.Description = contentbox.innerHTML									
            }									
           									
        },									
        UpdateHTMLBox(){	
            						
            let id = this.EditedTab.Name.split(' ').join('_')+this.EditedTabindex+'_editor'									
            let contentbox = document.getElementById(id)	
            	console.log(this.EditedTab,this.EditedTabindex,id,contentbox)							
            if(contentbox){									
                this.EditedTab.Description = contentbox.innerHTML									
            }									
            console.log(this.EditedTab,id)									
        },									
        UpdateTextBoxHTMLBox(){									
            let id = this.EditedTab.Name.split(' ').join('_')+this.EditedTabindex+'editor'									
            let contentbox = document.getElementById(id)									
            if(contentbox){									
                this.EditedTab.TextBoxContent = contentbox.innerHTML									
            }									
            this.TabDialog = false									
            tab.ShowComponents = false									
             setTimeout(() => {									
                tab.ShowComponents = true									
            }, 3)									
            console.log(this.EditedTab,id)									
        },									
        addphone(){									
         var url = prompt("Enter the Number internationalformat (e.g. +27123457890")									
         document.execCommand("CreateLink", false, 'tel:'+url);									
       },									
       addemail(){									
         var url = prompt("Enter the Number internationalformat (e.g. +27123457890")									
         document.execCommand("CreateLink", false, 'mailto:'+url);									
       },									
       link() {									
    var url = prompt("Enter the URL");									
    document.execCommand("createLink", false, url);									
    },									
        changeColor() {									
        var color = prompt("Enter your color in hex ex:#f1f233");									
        document.execCommand("foreColor", false, color);									
        },									
        copy() {									
      document.execCommand("copy", false, "");									
    },									
									
        ImageHeight(tab,value){									
            if(!tab.Height){									
                tab.Height = 50									
            }									
            if(value === 'down'){									
                tab.Height = tab.Height-50									
            }									
             if(value === 'up'){									
                tab.Height = tab.Height+50									
            }									
            this.TabDialog = false									
            this.TabDialog = true									
            tab.ShowComponents = false									
             setTimeout(() => {									
                tab.ShowComponents = true									
            }, 3)									
            console.log(tab.Height)									
        },									
        ImageWidth(tab,value){									
            let widthnumber = Number(tab.Width.split('%')[0])									
            if(value === 'down'){									
                tab.Width = widthnumber-10+'%'									
            }									
             if(value === 'up'){									
                tab.Width = widthnumber+10+'%'									
            }									
            this.TabDialog = false									
            this.TabDialog = true									
            tab.ShowComponents = false									
             setTimeout(() => {									
                tab.ShowComponents = true									
            }, 3)									
        },									
        FillHeight(tab){									
            console.log(tab.isFillHeight)									
            if(tab.isFillHeight){									
                tab.FillHeight = 'fill-height'									
            }									
            else{									
                tab.FillHeight = ''									
            }									
        },									
        RowHeight(tab,value){									
            if(!tab.RowHeight){									
                tab.RowHeight = 200									
            }									
            console.log(tab.RowHeight)									
          									
            if(value === 'down'){									
                tab.RowHeight = tab.RowHeight-25									
            }									
             if(value === 'up'){									
                tab.RowHeight = tab.RowHeight+25									
            }									
            this.TabDialog = false									
            this.TabDialog = true									
            tab.ShowComponents = false									
             setTimeout(() => {									
                tab.ShowComponents = true									
            }, 3)									
        },									
        AssignImageWidth(tab){									
             let value = tab.IMGWidthValue+'%'									
            console.log(value)									
            tab.IMGWidth = value									
            console.log(tab.IMGWidth)									
            },									
        CheckCardFullHeight(tab){									
            									
            let value = tab.HeightValue+'%'									
            console.log(value)									
            tab.FullHeight = ' height: '+value+';'									
            console.log(tab.FullHeight)									
        },									
        UpdateBoxTransparency(tab){									
            console.log(tab.BoxTransparent)									
            if(tab.BoxTransparent){									
                tab.BoxTransparency = 'transparent'									
            }									
            else{									
                tab.BoxTransparency = ''									
            }									
            },									
        BoxHeight(tab,value){									
            if(!tab.BoxHeight){									
                tab.BoxHeight = 200									
            }									
            console.log(tab.BoxHeight)									
          									
            if(value === 'down'){									
                tab.BoxHeight = tab.BoxHeight-10									
            }									
             if(value === 'up'){									
                tab.BoxHeight = tab.BoxHeight+10									
            }									
            this.TabDialog = false									
            this.TabDialog = true									
            tab.ShowComponents = false									
             setTimeout(() => {									
                tab.ShowComponents = true									
            }, 3)									
        },									
        RowBottomMargin(tab,value){									
            if(!tab.MarginBottom){									
                tab.MarginBottom = 0									
            }									
            // let widthnumber = Number(tab.Width.split('%')[0])									
            if(value === 'down'){									
                tab.MarginBottom = tab.MarginBottom-10									
            }									
             if(value === 'up'){									
                tab.MarginBottom = tab.MarginBottom+10									
            }									
            this.TabDialog = false									
            this.TabDialog = true									
            tab.ShowComponents = false									
             setTimeout(() => {									
                tab.ShowComponents = true									
            }, 3)									
        },									
        RowTopMargin(tab,value){									
            if(!tab.MarginTop){									
                tab.MarginTop = 0									
            }									
            // let widthnumber = Number(tab.Width.split('%')[0])									
            if(value === 'down'){									
                tab.MarginTop = tab.MarginTop-10									
            }									
             if(value === 'up'){									
                tab.MarginTop = tab.MarginTop+10									
            }									
            this.TabDialog = false									
            this.TabDialog = true									
            tab.ShowComponents = false									
             setTimeout(() => {									
                tab.ShowComponents = true									
            }, 3)									
        },									
        RowLeftMargin(tab,value){									
            if(!tab.MarginLeft){									
                tab.MarginLeft = 0									
            }									
            // let widthnumber = Number(tab.Width.split('%')[0])									
            if(value === 'down'){									
                tab.MarginLeft = tab.MarginLeft-10									
            }									
             if(value === 'up'){									
                tab.MarginLeft = tab.MarginLeft+10									
            }									
            this.TabDialog = false									
            this.TabDialog = true									
            tab.ShowComponents = false									
             setTimeout(() => {									
                tab.ShowComponents = true									
            }, 3)									
        },									
        RowRightMargin(tab,value){									
            if(!tab.MarginRight){									
                tab.MarginRight = 0									
            }									
            // let widthnumber = Number(tab.Width.split('%')[0])									
            if(value === 'down'){									
                tab.MarginRight = tab.MarginRight-10									
            }									
             if(value === 'up'){									
                tab.MarginRight = tab.MarginRight+10									
            }									
            this.TabDialog = false									
            this.TabDialog = true									
            tab.ShowComponents = false									
             setTimeout(() => {									
                tab.ShowComponents = true									
            }, 3)									
        },									
        BottomMargin(tab,value){									
            if(!tab.MarginBottom){									
                tab.MarginBottom = 0									
            }									
            // let widthnumber = Number(tab.Width.split('%')[0])									
            if(value === 'down'){									
                tab.MarginBottom = tab.MarginBottom-10									
            }									
             if(value === 'up'){									
                tab.MarginBottom = tab.MarginBottom+10									
            }									
            this.TabDialog = false									
            this.TabDialog = true									
            tab.ShowComponents = false									
             setTimeout(() => {									
                tab.ShowComponents = true									
            }, 3)									
        },									
        TopMargin(tab,value){									
            // let widthnumber = Number(tab.Width.split('%')[0])									
            if(value === 'down'){									
                tab.MarginTop = tab.MarginTop-10									
            }									
             if(value === 'up'){									
                tab.MarginTop = tab.MarginTop+10									
            }									
            this.TabDialog = false									
            this.TabDialog = true									
            tab.ShowComponents = false									
             setTimeout(() => {									
                tab.ShowComponents = true									
            }, 3)									
        },									
        LeftMargin(tab,value){									
            // let widthnumber = Number(tab.Width.split('%')[0])									
            if(value === 'down'){									
                tab.MarginLeft = tab.MarginLeft-10									
            }									
             if(value === 'up'){									
                tab.MarginLeft = tab.MarginLeft+10									
            }									
            this.TabDialog = false									
            this.TabDialog = true									
            tab.ShowComponents = false									
             setTimeout(() => {									
                tab.ShowComponents = true									
            }, 3)									
        },									
        RightMargin(tab,value){									
            // let widthnumber = Number(tab.Width.split('%')[0])									
            if(value === 'down'){									
                tab.MarginRight = tab.MarginRight-10									
            }									
             if(value === 'up'){									
                tab.MarginRight = tab.MarginRight+10									
            }									
            this.TabDialog = false									
            this.TabDialog = true									
            tab.ShowComponents = false									
             setTimeout(() => {									
                tab.ShowComponents = true									
            }, 3)									
        },									
        ClassCheck(tab){									
           var newclass = ''									
           									
            if(tab.Transparent){									
                newclass = newclass+' red'									
                tab.Color = '#ffffff'									
            }									
             if(tab.Clipped){									
                newclass = newclass+' clipped'									
            }									
            return newclass									
        },									
        OpenDialogCustom(propobj){
            console.log('OpenDialogCustom',propobj,this.PageTabs)
            let tab = ''
            if(propobj.IsElement){
                tab = this.PageTabs[propobj.CustomBoxTabIndex].Elements[propobj.tabindex]
            }
             else{
                tab = this.PageTabs[propobj.tabindex]
            }
           console.log(tab)
            this.OpenDialog(tab,propobj.tabindex,propobj.IsElement,propobj.CustomBoxTabIndex,propobj.isrow,propobj.rowindex,propobj.ContentDialog)
        },								
        OpenDialog(tab,tabindex,IsElement,CustomBoxTabIndex,isrow,rowindex,ContentDialog){	
            console.log(tab,tabindex,IsElement,CustomBoxTabIndex,isrow,rowindex,ContentDialog)
            if(this.SelectedActiveButton){
                let newtabbtns = this.FilteredTabStyleItems(tab)
                let oncheck = newtabbtns.find(obj => obj.Name === this.SelectedActiveButton.Name)
                if(!oncheck && newtabbtns[0]){
                    this.SelectedActiveButton = newtabbtns[0]
                }
            }								
            this.EditedTab = tab									
            this.EditedTabindex = tabindex									
            if(this.TabDialog === false){									
              this.TabDialog = true  									
            }									
            if(IsElement){									
                this.customboxindex = CustomBoxTabIndex									
                									
                this.elementIndex = tabindex									
               									
                if(isrow){									
                this.rowindex = rowindex       									
                									
                this.EditedRow = this.PageTabs[this.customboxindex].Rows[this.rowindex]            									
                console.log(this.PageTabs[this.customboxindex])   									
                }									
                else{									
                    this.EditedRow = ''									
                this.rowindex = -1									
                }									
                									
            }									
            else{									
                this.EditedRow = ''									
                this.rowindex = -1									
                this.elementIndex = -1									
                this.customboxindex = -1									
            }									
            									
            //console.log('supposed to open tabdialog for this one',tab,this.EditedTab)									
			if(ContentDialog){
                let buttons = this.FilteredTabStyleItems(tab)
                this.ActivateStyleButton(buttons[0],tab)
            }						
        },
        AllowTopRowAdding(){
            this.TopRowAdding = !this.TopRowAdding
        }	,								
        allowDrop(event,index){									
            if(this.dragging.SectionType){									
               // alert('dragover triggerds')									
            let elmnt = document.getElementById(index+'drop-area')									
            // console.log(elmnt)									
            elmnt.style.visibility = 'visible'									
            elmnt.style.height = '100px' 									
            }									
            									
        },									
        unallowDrop(event,index){									
            // alert('dragover triggerds')									
            let elmnt = document.getElementById(index+'drop-area')									
            // console.log(elmnt)									
            elmnt.style.visibility = 'hidden'									
            elmnt.style.height = '0px'									
        },									
        									
        Elmntdragstart(tab,tabindex,elmnt,elmntindex){		
            console.log(tab,tabindex,elmnt,elmntindex)							
            this.draggingtab = tab									
            this.draggingtabindex = tabindex									
            this.draggingelement = elmnt									
            this.draggingelementindex = elmntindex									
        },									
        Elmntdragfinish(to,ev){									
            // let newobj = Object.assign({},this.dragging)									
            console.log(this.draggingrow)									
            // this.EditedTab.Rows.splice(to, 1,this.draggingrow,this.EditedTab.Rows.splice(to)[0])									
            this.PageTabs[this.draggingtabindex].Elements.splice(to, 0, this.PageTabs[this.draggingtabindex].Elements.splice(this.draggingelementindex, 1)[0]);									
            // console.log(this.PageTabs)									
            //this.SiteTabs[totab].Sections[tosection].Content.splice(tocontent, 0, this.SiteTabs[fromtab].Sections[fromsection].Content.splice(fromcontent, 1)[0]);									
            this.$store.commit('setdraggingtab','') 
            this.$store.commit('setdraggingtabindex',-1)
            this.$store.commit('setdraggingelement','')
            this.$store.commit('setdraggingelementindex',-1)								
        },								
        Tabdragfinish(to,ev){										
            this.PageTabs.splice(to, 0, this.PageTabs.splice(this.draggingrowindex, 1)[0]);		
            this.$store.commit('setdraggingrow','') 
            this.$store.commit('setdraggingrowindex',-1)								
        },									
        rowdragstart(row,rowindex){									
            this.draggingrow = row									
            this.draggingrowindex = rowindex									
        },											
            Rowdragfinish(to,ev){									
                // let newobj = Object.assign({},this.dragging)									
                console.log(this.draggingrow)									
                // this.EditedTab.Rows.splice(to, 1,this.draggingrow,this.EditedTab.Rows.splice(to)[0])									
                this.EditedTab.Rows.splice(to, 0, this.EditedTab.Rows.splice(this.draggingrowindex, 1)[0]);									
                // console.log(this.PageTabs)									
                //this.SiteTabs[totab].Sections[tosection].Content.splice(tocontent, 0, this.SiteTabs[fromtab].Sections[fromsection].Content.splice(fromcontent, 1)[0]);									
                this.draggingrow = ''									
                this.draggingrowindex = -1									
            },									
            newcontentdropFinish(to,ev){									
                if(this.dragging.SectionType){									
                  let newobj = JSON.parse(JSON.stringify(this.dragging))									
                    this.PageTabs.splice(to, 0, newobj);									
                    console.log(this.PageTabs)  									
                }									
                									
            },									
            elementdropFinish(to,ev){									
                let newobj = JSON.parse(JSON.stringify(this.dragging))									
                //console.log(this.dragging)									
                this.PageTabs[to].Elements.push(newobj);									
                									
                console.log(this.PageTabs)									
            },		
            scrollintoview(to,ev){
                let elmnt = ev.target
                //console.log(elmnt)
                //elmnt.scrollIntoView()
            },	
            AddTabBelow(){
                console.log(this.ToElement)
                if(this.ToElement){
                    if(this.dragging.SectionType && this.dragging.Elements && this.dragging.Elements.length === 1){
                        this.AddtoParent(this.dragging.Elements[0])
                    }
                    else{
                        this.AddtoParent(this.dragging)
                    }
                     
                }
                else{
                 this.contentdropFinish(this.BelowTabIndex)   
                }
                
            },
            AddtoParent(block){
                let index = this.EditedTab.Elements.length
                let newblock = JSON.parse(JSON.stringify(block))
                if(this.$route.name === 'DocumentationLibraryEditor'){
                    newblock.FlexXLRG = 12
                    newblock.FlexLarge = 12
                    newblock.FlexMedium = 12
                    newblock.FlexSmall = 12
                    newblock.FlexXSmall = 12
                    
                    if(block.Name === 'HTML Box'){
                        newblock.Elevation = 0
                        newblock.BoxTransparency = 'transparent'
                    }
                }
                this.EditedTab.Elements.push(newblock)
                this.$emit('ActivateNewElement',index)
                 this.BelowTabIndex = -1
                this.BelowTab = ''
                this.ToElement = false
                this.EditedTab = ''
                this.$store.commit('setdragging','')
            },				
            contentdropFinish(to,ev){	
                							
                let newobj = JSON.parse(JSON.stringify(this.dragging))									
                //console.log(this.dragging)									
                this.PageTabs.splice(to-1+2, 0, newobj);									
                this.BelowTabIndex = -1
                this.BelowTab = ''
                this.ToElement = false
                this.$store.commit('setdragging','')									
                //console.log(this.PageTabs)									
            },									
            									
            tabdragFinish(to, ev) {									
                const tabindex = this.PageTabs.indexOf(ev)									
                this.tabmoveItem(this.dragging,  to);									
									
                },									
                tabmoveItem(from, to) {									
									
                // console.log(this.dragging)									
                // console.log(from)									
                // console.log(to)									
                    this.SiteTabs.splice(to, 0, this.SiteTabs.splice(from, 1)[0]);									
									
                },									
        SaveBannerAd(){									
            let BannerAdObj = {									
                BannerImage: this.BannerImageSimple,									
                ActionButtonName: this.ActionButtonName,									
                BannerLink: this.BannerLink,									
                BannerHeader: this.BannerHeader,									
                LinkType: this.LinkType,									
                BannerType: this.BannerType,									
                BannerTypeID: this.BannerType.ID,									
                BannerName: this.BannerName,									
                BannerDescription: this.BannerDescription,									
                									
                RecordSpecific: this.RecordSpecific,									
                LinkSource: this.LinkSource,									
                PublishType: this.PublishType									
            }									
            if(this.FeatureType && this.RecordSpecific){									
                BannerAdObj.FeatureType = this.FeatureType									
                BannerAdObj.BannerComponents = this.SimpleBannerComponents									
                BannerAdObj.BannerComponentsNames = this.SimpleBannerComponentsNames      									
                BannerAdObj.RecordName = this.RecordName          									
            }									
            else{									
                BannerAdObj.BannerComponents = this.SimpleBannerComponents									
                BannerAdObj.BannerComponentsNames = this.SimpleBannerComponentsNames									
            }									
            console.log(BannerAdObj)									
            db.collection('bannerads').doc(this.$route.params.id).set(BannerAdObj).then(doc => {									
                console.log('yipee set the doc '+doc.id)									
            })									
        },									
        PrepareNewBannerAd(){									
            let ref = db.collection('bannerads').doc()									
        let newdocid = ref.id									
        this.BannerAdView = true									
        this.NewBannerAdID = newdocid									
        									
        },									
        PrepareNewLandingPage(){									
            let ref = db.collection('landingpages').doc()									
        let newdocid = ref.id									
        this.LandingPageView = true									
        this.NewLandingePageID = newdocid									
        this.$router.push('/BannerAd/New/'+newdocid)									
        let LinkedfromObj = {									
                        Type: "Password Link",									
                        id: this.$route.params.id,									
                        Created_On: passwordresetdata.Created_On.toDate(),									
                        ExpiryDate: ExpiryDate,									
                        CanAction: true,									
                        ActionText: 'You can always Request another Password Reset?',									
                        ActionLink: '/Login'									
                    }									
                    console.log(LinkedfromObj)									
                    this.$router.push({ name: 'newbannerad', params: {LinkedfromObj: LinkedfromObj }})									
        									
        },									
      AssignViewbyOptions(obj){									
        console.log(obj)									
        this[obj.prop] = obj.options									
        if(obj.DefaultView){									
          this[obj.defaultprop] = obj.DefaultView									
        }									
      },									
      FocusedViewToggle(){									
        this.$emit('FocusedViewToggle',false)									
      },
      GetParentLibrary(libobj){
          this.$store.dispatch('GetActiveDocumentationLibrary',libobj)
      },					
      CheckUser(){									
            if(this.userLoggedIn){									
               this.UserRecord = this.userLoggedIn									
              //console.log(this.UserRecord)	 
              if(this.$route.name === 'GroupPageEditor'){                
                    this.GetLandingPage(db.collection('groups').doc(this.$route.params.id).collection('pages').doc(this.$route.params.slug))
                    // this.GetGroupAssets(db.collection('groups').doc(this.$route.params.id).collection('pageassets'))
                }
                else if(this.$route.name === 'GroupPageBuilder'){
                    //this.GetGroupAssets(db.collection('groups').doc(this.$route.params.id).collection('pageassets'))
                }
                else if(this.$route.name === 'DocumentationLibraryEditor'){                       
                    let libid = this.$route.params.id.split(' ').join('_')
                    if(!this.ActiveDocumentationLibrary || this.ActiveDocumentationLibrary && this.ActiveDocumentationLibrary.id !== libid){
                        this.GetParentLibrary(this.DocumentationLibraryObj)
                    }
                    else{
                        let pageobj = this.ActiveDocumentationLibrary.Pages.find(obj => obj.id === this.$route.params.slug.split(' ').join('_').split('-').join('_'))
                        this.AssignPageProperties(pageobj)
                    } 
                    if(!this.DocLibisRADB){
                        this.GetGalleryObjects()   
                        if(this.userIsAdmin){
                        this.GetSiteGroups()    
                        }                    									
                        this.GetSiteComponents() 
                    }
                }
                else{
                    if(this.userIsAdmin){
                     this.GetSiteGroups()    
                    }                    									
                    this.GetSiteComponents()									
                    if(this.$route.name === 'landingpagesingle' || this.$route.name === 'newlandingpage'){
                        this.GetLandingPage(db.collection('landingpages').doc(this.$route.params.id))
                        }
                        else if(this.$route.meta && this.$route.meta.PageEditor){
                            
                        this.GetLandingPage(db.collection('SystemConfig').doc(process.env.VUE_APP_RA_SYSTEM_ID).collection('Pages').doc(this.$route.params.id))
                        }
                        else if(this.$route.meta && this.$route.meta.PageBuilder){
                            //then nothing    
                        }
                        else if(this.$route.meta && this.$route.meta.TableBuilder && !this.TableRecordView){
                            //how to call table tabs TBD on table comp estblished
                        }
                        else{
                            console.log(this.CurrentEntity)
                            if(this.CurrentEntity.PublishType){
                                this.PublishType = this.CurrentEntity.PublishType
                            }
                            this.PageTabs = this.DataSingleTabs
                            this.$store.commit('setEditedPage',this.CurrentEntity)
                        }								
                    this.GetSystemAssets()
                    //console.log(this.$route.query)
                    let queryobj = this.$route.query
                    if(!queryobj || this.$route.name === 'PageBuilder' || queryobj && Object.keys(queryobj).length === 0 && queryobj.constructor === Object){
                    this.GetGalleryObjects()    
                    }
                }             							
              									
              								
            }									
        },									
        GetGroupAssets(query){
            console.log(this.ActiveGroup)
            this.SystemAssets = this.ActiveGroup.GroupAssets
        },							
        GetGalleryObjects(){									
            let routes = this.$router.getRoutes()									
            let GalleryPaths = routes.filter(option => {return option.meta && option.meta.photolibrary})									
           //console.log('GalleryPaths',GalleryPaths)									
            GalleryPaths.map(path => {									
                this.GetGalleryItems(path)									
            })									
        },									
        GetGalleryItems(path){									
            db.collection(path.name).onSnapshot(res => {									
                        const changes = res.docChanges();									
                        changes.forEach(change => {									
                          if (change.type === 'added') {									
                              let returnobj = {									
                              ...change.doc.data(),									
                              id: change.doc.id									
                            }									
                            //console.log(typeof this.SystemAssets)									
                            // returnobj.Library = path.meta.subcat									
                            let check = this.GalleryLibraries.find(obj => obj.name === path.meta.subcat)									
                            if(!check){									
                                let libraryobj = {									
                                    name: path.meta.subcat,									
                                    compname: path.meta.subcat.split(' ').join(''),									
                                    Assets: []									
                                }	
                                let libentity = this.SystemPhotoLibraries.find(obj => obj.id === path.meta.EntityID)	
                                if(libentity){
                                    if(libentity.CustomTags){
                                      libraryobj.CustomTags = libentity.CustomTags  
                                    }
                                    libraryobj.TableCollectionRef = db.collection(libentity.id.split('_').join('').toLowerCase())	                                    
                                }	
                                	//console.log('libraryobj',libraryobj)				
                                libraryobj.Assets.push(returnobj)									
                                this.GalleryLibraries.push(libraryobj)									
                            }									
                            else{									
                                check.Assets.push(returnobj)									
                            }									
                            //console.log(this.GalleryLibraries)									
                            									
                          }									
                        })									
                      })									
        },									
        GetSystemAssets(){		
            //console.log('calling site level assets')							
            db.collection('systemassets').onSnapshot(res => {									
                        const changes = res.docChanges();									
                        changes.forEach(change => {									
                          if (change.type === 'added') {									
                            this.SystemAssets.push({									
                              ...change.doc.data(),									
                              id: change.doc.id									
                            })									
                          }									
                        })									
                      })									
        },
        GetCategoricalNavList(id){
            //alert(id)
            db.collection('SystemConfig').doc(process.env.VUE_APP_RA_SYSTEM_ID).collection('CategoricalNavlists').doc(id).onSnapshot(snapshot => {
                let data = snapshot.data()
                this.CatNavList = data
                this.CatNavList.id = id
                console.log(data)
            })
        },	
        AssignPageProperties(landingpagedata){
            this.PageData = landingpagedata
                //console.log(landingpagedata)	
               						
                if(landingpagedata && landingpagedata.PageTabs){									
                    this.PageTabs = landingpagedata.PageTabs.map(tab => {									
                        tab.ShowComponents = true									
                        return tab									
                    })									
                if(landingpagedata.Name){									
                    this.PageName = landingpagedata.Name									
                }
                if(landingpagedata.PageRoute){									
                    this.PageRoute = landingpagedata.PageRoute									
                }
                if(landingpagedata.PageIcon){									
                    this.PageIcon = landingpagedata.PageIcon									
                }		
                if(landingpagedata.CatNavList){
                    this.GetCategoricalNavList(landingpagedata.CatNavList)
                }
                							
                if(landingpagedata.Overview){									
                    this.PageOverview = landingpagedata.Overview									
                }	
                if(landingpagedata.PageBGGradient){									
                    this.PageBGGradient = landingpagedata.PageBGGradient									
                }	
                if(landingpagedata.PageBGAsset){									
                    this.PageBGAsset = landingpagedata.PageBGAsset									
                }	
                if(landingpagedata.PageBGColor){									
                    this.PageBGColor = landingpagedata.PageBGColor									
                }	
                if(typeof landingpagedata.ClearNavbarColor !== 'undefined'){									
                    this.ClearNavbarColor = landingpagedata.ClearNavbarColor									
                }
                if(typeof landingpagedata.PageCustomStyle !== 'undefined'){									
                    this.PageCustomStyle = landingpagedata.PageCustomStyle									
                }
                if(typeof landingpagedata.PageOverlay !== 'undefined'){									
                    this.PageOverlay = landingpagedata.PageOverlay									
                }                
                
                if(landingpagedata.PageContentFont){									
                    this.PageContentFont = landingpagedata.PageContentFont									
                }
                if(landingpagedata.PageHeadersFont){									
                    this.PageHeadersFont = landingpagedata.PageHeadersFont									
                }	
                 if(landingpagedata.PageHeadersFontSize){									
                    this.PageHeadersFontSize = landingpagedata.PageHeadersFontSize									
                }							
                }
        },					
        GetLandingPage(query){	
            //alert('getting page')								
            query.onSnapshot(snapshot => {									
                let landingpagedata = snapshot.data()
                this.AssignPageProperties(landingpagedata)                									
            })									
        },									
        GetSiteComponents(){									
            this.SiteRouteComponents = this.$router.options.routes									
        },									
        GetSiteGroups(){									
            db.collection('groups').onSnapshot(res => {									
                        const changes = res.docChanges();									
                        changes.forEach(change => {									
                          if (change.type === 'added') {									
                            this.SiteGroups.push({									
                              ...change.doc.data(),									
                              id: change.doc.id									
                            })									
                          }									
                        })									
                      })									
        },									
          DateFormatter(date){									
            if(date){									
            let yearstring = date.split('-')[0]									
              let monthstring = date.split('-')[1]									
              let daystring = date.split('-')[2]									
              let yearnumber = Number(yearstring)									
              let monthnumber = Number(monthstring)									
              let daynumber = Number(daystring)									
              return new Date(yearnumber, monthnumber-1, daynumber)									
              }									
            else{									
              return null									
            }									
          },									
									
    }    									
}									
</script>									
									
<style>									
.tabdrop-area {									
  border: 2px dashed #ccc;									
  border-radius: 20px;									
  margin: 50px auto;									
  padding: 20px;									
  background-color: rgb(235, 235, 235)									
}									
  #drop-area {									
  border: 2px dashed #ccc;									
  border-radius: 20px;									
  margin: 50px auto;									
  padding: 20px;									
  background-color: rgb(235, 235, 235)									
}									
#drop-area.highlight {									
  border-color: purple;									
}	
  #top-drop-area {									
  border: 2px dashed #ccc;									
  border-radius: 20px;									
  margin: 50px auto;									
  padding: 20px;									
  background-color: rgb(235, 235, 235)									
}									
#top-drop-area.highlight {									
  border-color: purple;									
}								
.stickycontent {									
  position: fixed;									
  margin-top: -100px;									
}									
.clipped{									
      mask-size: contain;									
  mask-image: url(https://firebasestorage.googleapis.com/v0/b/templatizer-9620d.appspot.com/o/Assets%2FQSHCimvRtK2k5IgF1edf%2FELBInvert_Window?alt=media&token=6d585c59-3127-4665-9a02-aa113f654ac1);									
  mask-repeat: no-repeat;									
  mask-position: center; 									
}									
.handles {									
  									
    position: absolute;									
    top: 0;									
    left: 0;									
    right: 0;									
    bottom: 0;									
}									
.handle {									
    height: 25px;									
  width: 25px;									
  border-radius: 50%;									
  box-shadow: inset 0 0 0 2px;									
  opacity: 0.8;									
  cursor: grab;									
  /* border-radius: 50%;									
    box-shadow: inset 0 0 0 10px;									
    opacity: 0.8;									
    -webkit-transition: opacity 0.25s;									
    transition: opacity 0.25s;									
    cursor: -webkit-grab;									
    cursor: -moz-grab;									
    cursor: grab; */									
}									
									
@keyframes spotlightsearch {									
									
    0% { clip-path: circle(50px at 0 100px); }									
    15% { clip-path: circle(15% at 100% 50%); }									
    50% { clip-path: circle(15% at 10% 80%); }									
    60% { clip-path: circle(15% at 80% 70%); }									
    75% { clip-path: circle(15% at 50% 50%); }									
    100% { clip-path: circle(75%); }									
}									
.v-treeview-node__prepend {									
    width: 100%! important;									
}
							
/* @media  (width: 1264px) {
  .responder {
    padding: 10rem 10rem;
  }
}									 */
</style>